(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref490"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref490"] = parcelRequire;
}
parcelRequire.register("eYBMY", function(module, exports) {

var $lFqQT = parcelRequire("lFqQT");
var $ae73fb5b4a13e796$require$MAX_SAFE_COMPONENT_LENGTH = $lFqQT.MAX_SAFE_COMPONENT_LENGTH;

var $8ljiL = parcelRequire("8ljiL");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const createToken = (name, value, isGlobal)=>{
    // Replace all greedy whitespace to prevent regex dos issues. These regex are
    // used internally via the safeRe object since all inputs in this library get
    // normalized first to trim and collapse all extra whitespace. The original
    // regexes are exported for userland consumption and lower level usage. A
    // future breaking change could export the safer regex only with a note that
    // all input should have extra whitespace removed.
    const safe = value.split("\\s*").join("\\s{0,1}").split("\\s+").join("\\s");
    const index = R++;
    $8ljiL(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$ae73fb5b4a13e796$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$ae73fb5b4a13e796$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$ae73fb5b4a13e796$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRequire.register("lFqQT", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $fc6241934ab21f69$var$SEMVER_SPEC_VERSION = "2.0.0";
const $fc6241934ab21f69$var$MAX_LENGTH = 256;
const $fc6241934ab21f69$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $fc6241934ab21f69$var$MAX_SAFE_COMPONENT_LENGTH = 16;
const $fc6241934ab21f69$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $fc6241934ab21f69$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $fc6241934ab21f69$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_INTEGER: $fc6241934ab21f69$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $fc6241934ab21f69$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $fc6241934ab21f69$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRequire.register("8ljiL", function(module, exports) {

var $jrD34 = parcelRequire("jrD34");
const $612f41d19c4fa527$var$debug = (typeof $jrD34 === "object" && $jrD34.env && undefined, ()=>{});
module.exports = $612f41d19c4fa527$var$debug;

});
parcelRequire.register("jrD34", function(module, exports) {
// shim for using process in browser
var $e27ed42f18a5753a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e27ed42f18a5753a$var$cachedSetTimeout;
var $e27ed42f18a5753a$var$cachedClearTimeout;
function $e27ed42f18a5753a$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e27ed42f18a5753a$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e27ed42f18a5753a$var$cachedSetTimeout = setTimeout;
        else $e27ed42f18a5753a$var$cachedSetTimeout = $e27ed42f18a5753a$var$defaultSetTimout;
    } catch (e) {
        $e27ed42f18a5753a$var$cachedSetTimeout = $e27ed42f18a5753a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e27ed42f18a5753a$var$cachedClearTimeout = clearTimeout;
        else $e27ed42f18a5753a$var$cachedClearTimeout = $e27ed42f18a5753a$var$defaultClearTimeout;
    } catch (e) {
        $e27ed42f18a5753a$var$cachedClearTimeout = $e27ed42f18a5753a$var$defaultClearTimeout;
    }
})();
function $e27ed42f18a5753a$var$runTimeout(fun) {
    if ($e27ed42f18a5753a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e27ed42f18a5753a$var$cachedSetTimeout === $e27ed42f18a5753a$var$defaultSetTimout || !$e27ed42f18a5753a$var$cachedSetTimeout) && setTimeout) {
        $e27ed42f18a5753a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e27ed42f18a5753a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e27ed42f18a5753a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e27ed42f18a5753a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e27ed42f18a5753a$var$runClearTimeout(marker) {
    if ($e27ed42f18a5753a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e27ed42f18a5753a$var$cachedClearTimeout === $e27ed42f18a5753a$var$defaultClearTimeout || !$e27ed42f18a5753a$var$cachedClearTimeout) && clearTimeout) {
        $e27ed42f18a5753a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e27ed42f18a5753a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e27ed42f18a5753a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e27ed42f18a5753a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e27ed42f18a5753a$var$queue = [];
var $e27ed42f18a5753a$var$draining = false;
var $e27ed42f18a5753a$var$currentQueue;
var $e27ed42f18a5753a$var$queueIndex = -1;
function $e27ed42f18a5753a$var$cleanUpNextTick() {
    if (!$e27ed42f18a5753a$var$draining || !$e27ed42f18a5753a$var$currentQueue) return;
    $e27ed42f18a5753a$var$draining = false;
    if ($e27ed42f18a5753a$var$currentQueue.length) $e27ed42f18a5753a$var$queue = $e27ed42f18a5753a$var$currentQueue.concat($e27ed42f18a5753a$var$queue);
    else $e27ed42f18a5753a$var$queueIndex = -1;
    if ($e27ed42f18a5753a$var$queue.length) $e27ed42f18a5753a$var$drainQueue();
}
function $e27ed42f18a5753a$var$drainQueue() {
    if ($e27ed42f18a5753a$var$draining) return;
    var timeout = $e27ed42f18a5753a$var$runTimeout($e27ed42f18a5753a$var$cleanUpNextTick);
    $e27ed42f18a5753a$var$draining = true;
    var len = $e27ed42f18a5753a$var$queue.length;
    while(len){
        $e27ed42f18a5753a$var$currentQueue = $e27ed42f18a5753a$var$queue;
        $e27ed42f18a5753a$var$queue = [];
        while(++$e27ed42f18a5753a$var$queueIndex < len)if ($e27ed42f18a5753a$var$currentQueue) $e27ed42f18a5753a$var$currentQueue[$e27ed42f18a5753a$var$queueIndex].run();
        $e27ed42f18a5753a$var$queueIndex = -1;
        len = $e27ed42f18a5753a$var$queue.length;
    }
    $e27ed42f18a5753a$var$currentQueue = null;
    $e27ed42f18a5753a$var$draining = false;
    $e27ed42f18a5753a$var$runClearTimeout(timeout);
}
$e27ed42f18a5753a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e27ed42f18a5753a$var$queue.push(new $e27ed42f18a5753a$var$Item(fun, args));
    if ($e27ed42f18a5753a$var$queue.length === 1 && !$e27ed42f18a5753a$var$draining) $e27ed42f18a5753a$var$runTimeout($e27ed42f18a5753a$var$drainQueue);
};
// v8 likes predictible objects
function $e27ed42f18a5753a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e27ed42f18a5753a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e27ed42f18a5753a$var$process.title = "browser";
$e27ed42f18a5753a$var$process.browser = true;
$e27ed42f18a5753a$var$process.env = {};
$e27ed42f18a5753a$var$process.argv = [];
$e27ed42f18a5753a$var$process.version = ""; // empty string to avoid regexp issues
$e27ed42f18a5753a$var$process.versions = {};
function $e27ed42f18a5753a$var$noop() {}
$e27ed42f18a5753a$var$process.on = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.addListener = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.once = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.off = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.removeListener = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.removeAllListeners = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.emit = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.prependListener = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.prependOnceListener = $e27ed42f18a5753a$var$noop;
$e27ed42f18a5753a$var$process.listeners = function(name) {
    return [];
};
$e27ed42f18a5753a$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e27ed42f18a5753a$var$process.cwd = function() {
    return "/";
};
$e27ed42f18a5753a$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e27ed42f18a5753a$var$process.umask = function() {
    return 0;
};

});



// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $1f237190b3823da6$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${$1f237190b3823da6$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener("resize", ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});


var $a5bce33b7b920d36$exports = {};
/** @type {import('tailwindcss').Config} */ $a5bce33b7b920d36$exports = {
    /**
     * FD content
     * **/ // content: ["./src/**/*.{html,js}"],
    /**
     * SD content
     * **/ content: [
        "./app/modules/**/*.php",
        "./app/layout/**/*.php",
        "./app/modules/!panel/**",
        "./app/public/js/*.js"
    ],
    theme: {
        screens: {
            "xs": "360px",
            // => @media (min-width: 360px) { ... }
            "sm": "640px",
            // => @media (min-width: 640px) { ... }
            "md": "768px",
            // => @media (min-width: 768px) { ... }
            "lg": "1024px",
            // => @media (min-width: 1024px) { ... }
            "xl": "1280px",
            // => @media (min-width: 1280px) { ... }
            "2xl": "1536px",
            // => @media (min-width: 1536px) { ... }
            "3xl": "1800px"
        },
        extend: {
            colors: {
                transparent: "transparent",
                current: "currentColor"
            }
        }
    },
    plugins: []
};


function $d913fe852cb14a3a$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 600,
        threshold: 0.5,
        delay: 0,
        easing: "ease",
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens;
    /* --- Merge all options --- */ const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += "ms";
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty("speed", speed, true);
    setGlobalProperty("easing", easing);
    // Setup of Intersection Observer
    const intesectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            // Show element
            if (entry.isIntersecting) entry.target.classList.add("animated");
            else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove("animated");
        });
    }, {
        threshold: 0,
        rootMargin: "0% 0% -10% 0%"
    });
    // Change animation of element on breakpoints
    function changeEffectOnResize(element, breakpoint, effect) {
        const initialEffect = element.dataset.view;
        let fixedBreakpoint = typeof breakpoint === "string" ? breakpoint.replace(/\D/g, "") : breakpoint;
        if (window.innerWidth >= fixedBreakpoint) element.dataset.view = effect;
        else element.dataset.view = initialEffect;
    }
    // Main function to observe element
    function intersectElement(element, isMutation = false) {
        element.classList.add("in-view");
        const dataset = element.dataset;
        // Set speed to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        // Set easing to current element
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        for(const key in dataset){
            const property = key.toLowerCase();
            let dataViewValue = property.match(/view(.*)/)[1].replace(/^-/, "");
            // Check if dataset value equal to breakpoint
            if (dataViewValue && dataViewValue in breakpoints) changeEffectOnResize(element, breakpoints[dataViewValue], dataset[key]);
        }
        if (!isMutation) window.addEventListener("load", ()=>{
            // Observe element with delay
            if (dataset.viewDelay) setTimeout(()=>intesectionObserver.observe(element), dataset.viewDelay);
            else intesectionObserver.observe(element);
        });
        else intesectionObserver.observe(element);
    }
    /* --- Intersect elements on init --- */ const targetElements = document.querySelectorAll("[data-view]");
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        // Callback function to handle the mutations
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                // Check if any added node has the desired class
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && "view" in target.dataset) intersectElement(target, true);
                });
            }
        };
        // Create a MutationObserver instance
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$d913fe852cb14a3a$export$74b8f1741b4483c3();
const $d913fe852cb14a3a$var$startViewAnimationArr = document.querySelectorAll(".start-view-animation");
if ($d913fe852cb14a3a$var$startViewAnimationArr.length) for(let i = 0; i < $d913fe852cb14a3a$var$startViewAnimationArr.length; i++)setTimeout(function() {
    $d913fe852cb14a3a$var$startViewAnimationArr[i].classList.add("animated");
}, 50);


function $54c6583ff500d57c$var$setParallax(element, effectSpeed) {
    element.style.opacity = 1;
    function handleScroll() {
        const defaultSpeed = 0.1;
        const originalSpeed = parseFloat(element.getAttribute("data-parallax-view-speed")) || defaultSpeed;
        const speed = originalSpeed / 10;
        const scroll = window.scrollY + window.innerHeight;
        const elPos = element.getBoundingClientRect().top + window.scrollY;
        let newPos = 0;
        /*let start = true;

    if(element.hasAttribute('data-parallax-view-not-mobile') === true && window.innerWidth <=640) {
      start = false;
    }*/ if (elPos + element.clientHeight >= window.scrollY) {
            if (window.innerHeight >= elPos) {
                newPos = window.scrollY * speed;
                if (element.hasAttribute("data-parallax-view-horizontal") === true) element.style.transform = `translateX(${-newPos}px)`;
                else {
                    element.style.transform = `translateY(${-newPos}px)`;
                    if (element.hasAttribute("data-parallax-view-custom-transformX") === true) {
                        const customTransform = parseFloat(element.getAttribute("data-parallax-view-custom-transformX")) || "-50%";
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            } else if (scroll >= elPos) {
                newPos = (elPos - (window.scrollY + window.innerHeight)) * speed;
                if (element.hasAttribute("data-parallax-view-horizontal") === true) element.style.transform = `translateX(${newPos}px)`;
                else {
                    element.style.transform = `translateY(${newPos}px)`;
                    if (element.hasAttribute("data-parallax-view-custom-transformX") === true) {
                        const customTransform = parseFloat(element.getAttribute("data-parallax-view-custom-transformX")) || "-50%";
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            }
        }
    }
    window.addEventListener("scroll", handleScroll);
    handleScroll();
}
const $54c6583ff500d57c$var$parallaxElements = document.querySelectorAll("[data-parallax-view]");
$54c6583ff500d57c$var$parallaxElements.forEach((element)=>{
    $54c6583ff500d57c$var$setParallax(element);
});


const $6e0072d6babad5b9$var$headerComponent = document.getElementsByClassName("header")[0];
// Header scroll
const $6e0072d6babad5b9$var$scrollContainer = ()=>document.documentElement || document.body;
document.addEventListener("scroll", ()=>{
    if ($6e0072d6babad5b9$var$scrollContainer().scrollTop > 50) $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
    else if ($6e0072d6babad5b9$var$scrollContainer().scrollTop == 0) $6e0072d6babad5b9$var$headerComponent.classList.remove("scrolled");
});
// menu handlers
// check mobile menu show/hide condition
const $6e0072d6babad5b9$var$mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--mobile-menu-start-point"));
let $6e0072d6babad5b9$var$isMobileMenuEnable = window.outerWidth <= $6e0072d6babad5b9$var$mobileMenuStartPoint || document.querySelector(".header-mobile");
const $6e0072d6babad5b9$var$dropdownToggle = document.querySelectorAll(".dropdown-toggle");
$6e0072d6babad5b9$var$dropdownToggle.forEach((toggle)=>{
    toggle.addEventListener("click", function(e) {
        if ($6e0072d6babad5b9$var$isMobileMenuEnable) {
            const menuItem = this.closest(".menu-item.dropdown");
            const dropdownMenu = this.nextElementSibling;
            // close all opened sub menu
            const activeDropdowns = document.querySelectorAll(".menu-item.dropdown.active .dropdown-menu");
            activeDropdowns.forEach((menu)=>{
                menu.style.display = "none";
                menu.closest(".dropdown").classList.remove("active");
            });
            // open current submenu
            menuItem.classList.toggle("active");
            if (menuItem.classList.contains("active")) {
                e.preventDefault();
                dropdownMenu.style.display = "block";
            }
        }
    });
});
// toggle menu handler
function $6e0072d6babad5b9$var$menuToggleFunc() {
    const menuToggle = document.querySelector(".menu-toggle");
    const navbarNav = document.querySelector(".navbar-nav");
    const headerCloseWrapper = document.querySelector(".header-close-wrapper");
    menuToggle.classList.toggle("active");
    navbarNav.classList.toggle("active");
    $6e0072d6babad5b9$var$headerComponent.classList.toggle("open-menu");
    headerCloseWrapper.classList.toggle("active");
    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
        scrollLock.disablePageScroll(document.querySelector(".navbar-nav .menu"));
        scrollLock.addScrollableSelector(".simplebar-content-wrapper");
    } else scrollLock.enablePageScroll();
}
// menu update function
function $6e0072d6babad5b9$var$updateMenu() {
    $6e0072d6babad5b9$var$isMobileMenuEnable = window.outerWidth <= $6e0072d6babad5b9$var$mobileMenuStartPoint || document.querySelector(".mobile-header");
    if (!$6e0072d6babad5b9$var$isMobileMenuEnable) {
        const dropdownMenus = document.querySelectorAll(".dropdown-menu");
        dropdownMenus.forEach((menu)=>{
            menu.style.display = "";
        });
        const headerCloseWrapper = document.querySelector(".header-close-wrapper");
        headerCloseWrapper.classList.remove("active");
        const activeMenuItems = document.querySelectorAll(".menu-item.active");
        activeMenuItems.forEach((item)=>{
            item.classList.remove("active");
        });
        const navbarNav = document.querySelector(".navbar-nav");
        navbarNav.classList.remove("active");
        $6e0072d6babad5b9$var$headerComponent.classList.remove("open-menu");
        const menuToggle = document.querySelector(".menu-toggle");
        menuToggle.classList.remove("active");
        // LockScroll when burger open and enable when closed
        scrollLock.enablePageScroll();
    }
}
window.addEventListener("resize", $6e0072d6babad5b9$var$updateMenu);
window.addEventListener("orientationchange", $6e0072d6babad5b9$var$updateMenu);
// end of toggle menu handler
const $6e0072d6babad5b9$var$menuToggle = document.querySelector(".menu-toggle");
const $6e0072d6babad5b9$var$headerCloseWrapper = document.querySelector(".header-close-wrapper");
$6e0072d6babad5b9$var$menuToggle.addEventListener("click", $6e0072d6babad5b9$var$menuToggleFunc);
$6e0072d6babad5b9$var$headerCloseWrapper.addEventListener("click", $6e0072d6babad5b9$var$menuToggleFunc);
// Hide and show Header when scroll up
function $6e0072d6babad5b9$var$headerSticky() {
    let prevScrollPos = window.pageYOffset;
    window.onscroll = ()=>{
        const currentScrollPos = window.pageYOffset;
        const headerHeight = $6e0072d6babad5b9$var$headerComponent.scrollHeight;
        if (window.scrollY > 0) {
            if (prevScrollPos > currentScrollPos) {
                $6e0072d6babad5b9$var$headerComponent.style.top = 0;
                $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
            } else $6e0072d6babad5b9$var$headerComponent.style.top = `-${headerHeight + 3}px`;
        }
        if (window.scrollY === 0) $6e0072d6babad5b9$var$headerComponent.classList.remove("scrolled");
        prevScrollPos = currentScrollPos;
    };
    if (window.scrollY !== 0) $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
}
$6e0072d6babad5b9$var$headerSticky();
if (document.querySelector(".navbar__language")) {
    const languageDropdownArr = document.querySelectorAll(".navbar__language");
    languageDropdownArr.forEach((languageDropdown)=>{
        if (languageDropdown) {
            languageDropdown.addEventListener("click", ()=>{
                if (window.innerWidth <= 1024) languageDropdown.classList.toggle("active");
            });
            document.addEventListener("click", (event)=>{
                if (window.innerWidth <= 1024) {
                    const targetElement = event.target;
                    const isClickInsideLanguageDropdown = languageDropdown.contains(targetElement);
                    if (!isClickInsideLanguageDropdown) languageDropdown.classList.remove("active");
                }
            });
        }
    });
}


window.uploadFile = function uploadFile1() {
    if (document.querySelector("[data-upload-file-animation]")) {
        const uploadFileBlocksArr = document.querySelectorAll("[data-upload-file-animation]");
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener("dragover", function() {
                this.classList.add("drag");
                this.classList.remove("drop", "done");
            });
            fileUpload.addEventListener("dragleave", function() {
                this.classList.remove("drag");
            });
            fileUpload.addEventListener("drop", start, false);
            fileUpload.addEventListener("change", start, false);
            function start() {
                this.classList.remove("drag");
                this.classList.add("drop");
                setTimeout(()=>this.classList.add("done"), 500);
            }
        });
    }
};
uploadFile();


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector("textarea[data-autosize]")) {
        const autosizeTextareaElements = document.querySelectorAll("textarea[data-autosize]");
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener("input", autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();
window.passwordInputs = function passwordInputs1() {
    if (document.querySelector(".password-input")) {
        const passwordInputsArr = document.querySelectorAll(".password-input");
        passwordInputsArr.forEach((password)=>{
            const btn = password.querySelector(".password-input__btn");
            const btnIcon = password.querySelector(".password-input__btn i");
            const input = password.querySelector("input");
            btn.addEventListener("click", ()=>{
                inputIconFunc();
            });
            function inputIconFunc() {
                if (!btn.classList.contains("is-password-hidden")) {
                    btn.classList.add("is-password-hidden");
                    input.type = "password";
                    btnIcon.classList.add("icon-not-show");
                    btnIcon.classList.remove("icon-show");
                } else {
                    btn.classList.remove("is-password-hidden");
                    input.type = "text";
                    btnIcon.classList.remove("icon-not-show");
                    btnIcon.classList.add("icon-show");
                }
            }
            inputIconFunc();
        });
    }
};
passwordInputs();


/*Splitting();*/ var $b804194f136cecc7$exports = {};
(function(f) {
    var g;
    $b804194f136cecc7$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1("_process"));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1("performance-now"), root = typeof window === "undefined" ? global1 : window, vendors = [
                        "moz",
                        "webkit"
                    ], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + "Request" + suffix];
                        caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1("raf");
                var objectAssign = require1("object-assign");
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            "-webkit-",
                            "webkit"
                        ],
                        [
                            "-moz-",
                            "Moz"
                        ],
                        [
                            "-o-",
                            "O"
                        ],
                        [
                            "-ms-",
                            "ms"
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute("data-" + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === "true") return true;
                        else if (value === "false") return false;
                        else if (value === "null") return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : "";
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, "transform", "translate3d(0,0,0) rotate(0.0001deg)");
                        helpers.css(element, "transform-style", "preserve-3d");
                        helpers.css(element, "backface-visibility", "hidden");
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement("div"), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + "transform";
                                jsProperty = helpers.vendors[i][1] + "Transform";
                            } else {
                                cssProperty = "transform";
                                jsProperty = "transform";
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case "2D":
                                featureSupport = propertySupport;
                                break;
                            case "3D":
                                if (propertySupport) {
                                    var body = document.body || document.createElement("body"), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = "hidden";
                                        documentElement.appendChild(body);
                                        body.style.overflow = "hidden";
                                        body.style.background = "";
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = "translate3d(1px,1px,1px)";
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== "none";
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute("style");
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + "-" + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, "calibrate-x"),
                            calibrateY: helpers.data(this.element, "calibrate-y"),
                            invertX: helpers.data(this.element, "invert-x"),
                            invertY: helpers.data(this.element, "invert-y"),
                            limitX: helpers.data(this.element, "limit-x"),
                            limitY: helpers.data(this.element, "limit-y"),
                            scalarX: helpers.data(this.element, "scalar-x"),
                            scalarY: helpers.data(this.element, "scalar-y"),
                            frictionX: helpers.data(this.element, "friction-x"),
                            frictionY: helpers.data(this.element, "friction-y"),
                            originX: helpers.data(this.element, "origin-x"),
                            originY: helpers.data(this.element, "origin-y"),
                            pointerEvents: helpers.data(this.element, "pointer-events"),
                            precision: helpers.data(this.element, "precision"),
                            relativeInput: helpers.data(this.element, "relative-input"),
                            clipRelativeInput: helpers.data(this.element, "clip-relative-input"),
                            hoverOnly: helpers.data(this.element, "hover-only"),
                            inputElement: document.querySelector(helpers.data(this.element, "input-element")),
                            selector: helpers.data(this.element, "selector")
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: "initialise",
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport("2D");
                                    this.transform3DSupport = helpers.transformSupport("3D");
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue("position") === "static") this.element.style.position = "relative";
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = "none";
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: "doReadyCallback",
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: "updateLayers",
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn("ParallaxJS: Your scene does not have any layers.");
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? "absolute" : "relative";
                                    layer.style.display = "block";
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, "depth") || 0;
                                    this.depthsX.push(helpers.data(layer, "depth-x") || depth);
                                    this.depthsY.push(helpers.data(layer, "depth-y") || depth);
                                }
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: "updateBounds",
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: "queueCalibration",
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: "enable",
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener("deviceorientation", this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener("devicemotion", this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener("mousemove", this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener("resize", this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "disable",
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener("deviceorientation", this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener("devicemotion", this.onDeviceMotion);
                                else window.removeEventListener("mousemove", this.onMouseMove);
                                window.removeEventListener("resize", this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: "calibrate",
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: "invert",
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: "friction",
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: "scalar",
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: "limit",
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: "origin",
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: "setInputElement",
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "setPosition",
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + "px";
                                y = y.toFixed(this.precision) + "px";
                                if (this.transform3DSupport) helpers.css(element, "transform", "translate3d(" + x + "," + y + ",0)");
                                else if (this.transform2DSupport) helpers.css(element, "transform", "translate(" + x + "," + y + ")");
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: "onOrientationTimer",
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onMotionTimer",
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onCalibrationTimer",
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: "onWindowResize",
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "onAnimationFrame",
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "rotate",
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: "onDeviceOrientation",
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onDeviceMotion",
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onMouseMove",
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute("style");
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute("style");
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: "version",
                            value: function version() {
                                return "3.1.0";
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


var $a4310910d91ee940$exports = {};
var $a4310910d91ee940$var$__dirname = "node_modules/sharp/lib";

var $jrD34 = parcelRequire("jrD34");
"use strict";
var $74cd6c9a79ff8a91$exports = {};
"use strict";


var $020783f940518ebd$export$edf525f30916fbb8;
var $020783f940518ebd$export$640106f6dc7d2706;
var $020783f940518ebd$export$3ea386628068cf62;
var $020783f940518ebd$export$749d472264fad440;
var $020783f940518ebd$export$8b931a48d9488767;
var $020783f940518ebd$export$9123f37609399513;
var $020783f940518ebd$export$9b60beb643db4d69;
var $020783f940518ebd$export$bf9fb029d174d554;
var $020783f940518ebd$export$23d3fad09dc44362;
var $020783f940518ebd$export$d2f3c2f7e0c7dcf5;
var $020783f940518ebd$export$3bf7c33313eba0fe;
var $020783f940518ebd$export$7925d89f138dad5b;
var $020783f940518ebd$export$722a64dea1b767dc;
var $020783f940518ebd$export$9e6c06a7d47f9af7;
var $020783f940518ebd$export$6b76988456c0292f;
var $020783f940518ebd$export$266d3b9babd1fc45;
var $020783f940518ebd$export$c1d46b5ea6262c0b;
$020783f940518ebd$export$edf525f30916fbb8 = function() {
    return "LE";
};
$020783f940518ebd$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$020783f940518ebd$export$3ea386628068cf62 = function() {
    return [];
};
$020783f940518ebd$export$749d472264fad440 = function() {
    return 0;
};
$020783f940518ebd$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$020783f940518ebd$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$020783f940518ebd$export$9b60beb643db4d69 = function() {
    return [];
};
$020783f940518ebd$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$020783f940518ebd$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$020783f940518ebd$export$d2f3c2f7e0c7dcf5 = $020783f940518ebd$export$3bf7c33313eba0fe = function() {
    return {};
};
$020783f940518ebd$export$7925d89f138dad5b = function() {
    return "javascript";
};
$020783f940518ebd$export$722a64dea1b767dc = function() {
    return "browser";
};
$020783f940518ebd$export$9e6c06a7d47f9af7 = $020783f940518ebd$export$6b76988456c0292f = function() {
    return "/tmp";
};
$020783f940518ebd$export$266d3b9babd1fc45 = "\n";
$020783f940518ebd$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $06a8745e08fb71fc$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $jrD34 = parcelRequire("jrD34");
"use strict";
function $06a8745e08fb71fc$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $06a8745e08fb71fc$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $06a8745e08fb71fc$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $06a8745e08fb71fc$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $jrD34.cwd();
                path = cwd;
            }
            $06a8745e08fb71fc$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $06a8745e08fb71fc$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $06a8745e08fb71fc$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $06a8745e08fb71fc$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $06a8745e08fb71fc$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $06a8745e08fb71fc$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $06a8745e08fb71fc$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $06a8745e08fb71fc$var$assertPath(from);
        $06a8745e08fb71fc$var$assertPath(to);
        if (from === to) return "";
        from = $06a8745e08fb71fc$var$posix.resolve(from);
        to = $06a8745e08fb71fc$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $06a8745e08fb71fc$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $06a8745e08fb71fc$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $06a8745e08fb71fc$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $06a8745e08fb71fc$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $06a8745e08fb71fc$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$06a8745e08fb71fc$var$posix.posix = $06a8745e08fb71fc$var$posix;
$06a8745e08fb71fc$exports = $06a8745e08fb71fc$var$posix;



var $a4310910d91ee940$require$spawnSync = $74cd6c9a79ff8a91$exports.spawnSync;
var $f35134ed7d1d7ed5$exports = {};
var $190420747855133e$exports = {};

var $8ljiL = parcelRequire("8ljiL");

var $lFqQT = parcelRequire("lFqQT");
var $190420747855133e$require$MAX_LENGTH = $lFqQT.MAX_LENGTH;
var $190420747855133e$require$MAX_SAFE_INTEGER = $lFqQT.MAX_SAFE_INTEGER;

var $eYBMY = parcelRequire("eYBMY");
var $190420747855133e$require$re = $eYBMY.safeRe;
var $190420747855133e$require$t = $eYBMY.t;
var $a1b8a16e1900d732$exports = {};
// parse out just the options we care about
const $a1b8a16e1900d732$var$looseOption = Object.freeze({
    loose: true
});
const $a1b8a16e1900d732$var$emptyOpts = Object.freeze({});
const $a1b8a16e1900d732$var$parseOptions = (options)=>{
    if (!options) return $a1b8a16e1900d732$var$emptyOpts;
    if (typeof options !== "object") return $a1b8a16e1900d732$var$looseOption;
    return options;
};
$a1b8a16e1900d732$exports = $a1b8a16e1900d732$var$parseOptions;


var $fa02265699013eac$exports = {};
const $fa02265699013eac$var$numeric = /^[0-9]+$/;
const $fa02265699013eac$var$compareIdentifiers = (a, b)=>{
    const anum = $fa02265699013eac$var$numeric.test(a);
    const bnum = $fa02265699013eac$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $fa02265699013eac$var$rcompareIdentifiers = (a, b)=>$fa02265699013eac$var$compareIdentifiers(b, a);
$fa02265699013eac$exports = {
    compareIdentifiers: $fa02265699013eac$var$compareIdentifiers,
    rcompareIdentifiers: $fa02265699013eac$var$rcompareIdentifiers
};


var $190420747855133e$require$compareIdentifiers = $fa02265699013eac$exports.compareIdentifiers;
class $190420747855133e$var$SemVer {
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $8ljiL("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $190420747855133e$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $190420747855133e$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $190420747855133e$var$SemVer)) other = new $190420747855133e$var$SemVer(other, this.options);
        return $190420747855133e$require$compareIdentifiers(this.major, other.major) || $190420747855133e$require$compareIdentifiers(this.minor, other.minor) || $190420747855133e$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $190420747855133e$var$SemVer)) other = new $190420747855133e$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $8ljiL("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $190420747855133e$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $190420747855133e$var$SemVer)) other = new $190420747855133e$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $8ljiL("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $190420747855133e$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($190420747855133e$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
    constructor(version, options){
        options = $a1b8a16e1900d732$exports(options);
        if (version instanceof $190420747855133e$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $190420747855133e$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$190420747855133e$require$MAX_LENGTH} characters`);
        $8ljiL("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $190420747855133e$require$re[$190420747855133e$require$t.LOOSE] : $190420747855133e$require$re[$190420747855133e$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $190420747855133e$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $190420747855133e$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $190420747855133e$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $190420747855133e$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
}
$190420747855133e$exports = $190420747855133e$var$SemVer;


var $d9858895ce5ff646$exports = {};

const $d9858895ce5ff646$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $190420747855133e$exports) return version;
    try {
        return new $190420747855133e$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$d9858895ce5ff646$exports = $d9858895ce5ff646$var$parse;



var $eYBMY = parcelRequire("eYBMY");
var $f35134ed7d1d7ed5$require$re = $eYBMY.safeRe;
var $f35134ed7d1d7ed5$require$t = $eYBMY.t;
const $f35134ed7d1d7ed5$var$coerce = (version, options)=>{
    if (version instanceof $190420747855133e$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match($f35134ed7d1d7ed5$require$re[$f35134ed7d1d7ed5$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = $f35134ed7d1d7ed5$require$re[$f35134ed7d1d7ed5$require$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $f35134ed7d1d7ed5$require$re[$f35134ed7d1d7ed5$require$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $f35134ed7d1d7ed5$require$re[$f35134ed7d1d7ed5$require$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $d9858895ce5ff646$exports(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
};
$f35134ed7d1d7ed5$exports = $f35134ed7d1d7ed5$var$coerce;


var $a7284a87a0cf7b48$exports = {};
var $07d5b62ff0459666$exports = {};

const $07d5b62ff0459666$var$compare = (a, b, loose)=>new $190420747855133e$exports(a, loose).compare(new $190420747855133e$exports(b, loose));
$07d5b62ff0459666$exports = $07d5b62ff0459666$var$compare;


const $a7284a87a0cf7b48$var$gte = (a, b, loose)=>$07d5b62ff0459666$exports(a, b, loose) >= 0;
$a7284a87a0cf7b48$exports = $a7284a87a0cf7b48$var$gte;


var $90d2174590e6b8fe$exports = {};

var $jrD34 = parcelRequire("jrD34");
"use strict";
var $57e3bb76c0539f18$exports = {};
"use strict";

var $5079dc0771bb4152$exports = {};

var $jrD34 = parcelRequire("jrD34");
"use strict";
const $5079dc0771bb4152$var$isLinux = ()=>$jrD34.platform === "linux";
let $5079dc0771bb4152$var$report = null;
const $5079dc0771bb4152$var$getReport = ()=>{
    if (!$5079dc0771bb4152$var$report) /* istanbul ignore next */ $5079dc0771bb4152$var$report = $5079dc0771bb4152$var$isLinux() && $jrD34.report ? $jrD34.report.getReport() : {};
    return $5079dc0771bb4152$var$report;
};
$5079dc0771bb4152$exports = {
    isLinux: $5079dc0771bb4152$var$isLinux,
    getReport: $5079dc0771bb4152$var$getReport
};


var $57e3bb76c0539f18$require$isLinux = $5079dc0771bb4152$exports.isLinux;
var $57e3bb76c0539f18$require$getReport = $5079dc0771bb4152$exports.getReport;
const $57e3bb76c0539f18$var$command = "getconf GNU_LIBC_VERSION 2>&1 || true; ldd --version 2>&1 || true";
let $57e3bb76c0539f18$var$commandOut = "";
const $57e3bb76c0539f18$var$safeCommand = ()=>{
    if (!$57e3bb76c0539f18$var$commandOut) return new Promise((resolve)=>{
        $74cd6c9a79ff8a91$exports.exec($57e3bb76c0539f18$var$command, (err, out)=>{
            $57e3bb76c0539f18$var$commandOut = err ? " " : out;
            resolve($57e3bb76c0539f18$var$commandOut);
        });
    });
    return $57e3bb76c0539f18$var$commandOut;
};
const $57e3bb76c0539f18$var$safeCommandSync = ()=>{
    if (!$57e3bb76c0539f18$var$commandOut) try {
        $57e3bb76c0539f18$var$commandOut = $74cd6c9a79ff8a91$exports.execSync($57e3bb76c0539f18$var$command, {
            encoding: "utf8"
        });
    } catch (_err) {
        $57e3bb76c0539f18$var$commandOut = " ";
    }
    return $57e3bb76c0539f18$var$commandOut;
};
/**
 * A String constant containing the value `glibc`.
 * @type {string}
 * @public
 */ const $57e3bb76c0539f18$var$GLIBC = "glibc";
/**
 * A String constant containing the value `musl`.
 * @type {string}
 * @public
 */ const $57e3bb76c0539f18$var$MUSL = "musl";
const $57e3bb76c0539f18$var$isFileMusl = (f)=>f.includes("libc.musl-") || f.includes("ld-musl-");
const $57e3bb76c0539f18$var$familyFromReport = ()=>{
    const report = $57e3bb76c0539f18$require$getReport();
    if (report.header && report.header.glibcVersionRuntime) return $57e3bb76c0539f18$var$GLIBC;
    if (Array.isArray(report.sharedObjects)) {
        if (report.sharedObjects.some($57e3bb76c0539f18$var$isFileMusl)) return $57e3bb76c0539f18$var$MUSL;
    }
    return null;
};
const $57e3bb76c0539f18$var$familyFromCommand = (out)=>{
    const [getconf, ldd1] = out.split(/[\r\n]+/);
    if (getconf && getconf.includes($57e3bb76c0539f18$var$GLIBC)) return $57e3bb76c0539f18$var$GLIBC;
    if (ldd1 && ldd1.includes($57e3bb76c0539f18$var$MUSL)) return $57e3bb76c0539f18$var$MUSL;
    return null;
};
/**
 * Resolves with the libc family when it can be determined, `null` otherwise.
 * @returns {Promise<?string>}
 */ const $57e3bb76c0539f18$var$family = async ()=>{
    let family = null;
    if ($57e3bb76c0539f18$require$isLinux()) {
        family = $57e3bb76c0539f18$var$familyFromReport();
        if (!family) {
            const out = await $57e3bb76c0539f18$var$safeCommand();
            family = $57e3bb76c0539f18$var$familyFromCommand(out);
        }
    }
    return family;
};
/**
 * Returns the libc family when it can be determined, `null` otherwise.
 * @returns {?string}
 */ const $57e3bb76c0539f18$var$familySync = ()=>{
    let family = null;
    if ($57e3bb76c0539f18$require$isLinux()) {
        family = $57e3bb76c0539f18$var$familyFromReport();
        if (!family) {
            const out = $57e3bb76c0539f18$var$safeCommandSync();
            family = $57e3bb76c0539f18$var$familyFromCommand(out);
        }
    }
    return family;
};
/**
 * Resolves `true` only when the platform is Linux and the libc family is not `glibc`.
 * @returns {Promise<boolean>}
 */ const $57e3bb76c0539f18$var$isNonGlibcLinux = async ()=>$57e3bb76c0539f18$require$isLinux() && await $57e3bb76c0539f18$var$family() !== $57e3bb76c0539f18$var$GLIBC;
/**
 * Returns `true` only when the platform is Linux and the libc family is not `glibc`.
 * @returns {boolean}
 */ const $57e3bb76c0539f18$var$isNonGlibcLinuxSync = ()=>$57e3bb76c0539f18$require$isLinux() && $57e3bb76c0539f18$var$familySync() !== $57e3bb76c0539f18$var$GLIBC;
const $57e3bb76c0539f18$var$versionFromReport = ()=>{
    const report = $57e3bb76c0539f18$require$getReport();
    if (report.header && report.header.glibcVersionRuntime) return report.header.glibcVersionRuntime;
    return null;
};
const $57e3bb76c0539f18$var$versionSuffix = (s)=>s.trim().split(/\s+/)[1];
const $57e3bb76c0539f18$var$versionFromCommand = (out)=>{
    const [getconf, ldd1, ldd2] = out.split(/[\r\n]+/);
    if (getconf && getconf.includes($57e3bb76c0539f18$var$GLIBC)) return $57e3bb76c0539f18$var$versionSuffix(getconf);
    if (ldd1 && ldd2 && ldd1.includes($57e3bb76c0539f18$var$MUSL)) return $57e3bb76c0539f18$var$versionSuffix(ldd2);
    return null;
};
/**
 * Resolves with the libc version when it can be determined, `null` otherwise.
 * @returns {Promise<?string>}
 */ const $57e3bb76c0539f18$var$version = async ()=>{
    let version = null;
    if ($57e3bb76c0539f18$require$isLinux()) {
        version = $57e3bb76c0539f18$var$versionFromReport();
        if (!version) {
            const out = await $57e3bb76c0539f18$var$safeCommand();
            version = $57e3bb76c0539f18$var$versionFromCommand(out);
        }
    }
    return version;
};
/**
 * Returns the libc version when it can be determined, `null` otherwise.
 * @returns {?string}
 */ const $57e3bb76c0539f18$var$versionSync = ()=>{
    let version = null;
    if ($57e3bb76c0539f18$require$isLinux()) {
        version = $57e3bb76c0539f18$var$versionFromReport();
        if (!version) {
            const out = $57e3bb76c0539f18$var$safeCommandSync();
            version = $57e3bb76c0539f18$var$versionFromCommand(out);
        }
    }
    return version;
};
$57e3bb76c0539f18$exports = {
    GLIBC: $57e3bb76c0539f18$var$GLIBC,
    MUSL: $57e3bb76c0539f18$var$MUSL,
    family: $57e3bb76c0539f18$var$family,
    familySync: $57e3bb76c0539f18$var$familySync,
    isNonGlibcLinux: $57e3bb76c0539f18$var$isNonGlibcLinux,
    isNonGlibcLinuxSync: $57e3bb76c0539f18$var$isNonGlibcLinuxSync,
    version: $57e3bb76c0539f18$var$version,
    versionSync: $57e3bb76c0539f18$var$versionSync
};


const $90d2174590e6b8fe$var$env = {};
$90d2174590e6b8fe$exports = function() {
    const arch = $90d2174590e6b8fe$var$env.npm_config_arch || $jrD34.arch;
    const platform = $90d2174590e6b8fe$var$env.npm_config_platform || $jrD34.platform;
    const libc = /* istanbul ignore next */ $57e3bb76c0539f18$exports.isNonGlibcLinuxSync() ? $57e3bb76c0539f18$exports.familySync() : "";
    const libcId = platform !== "linux" || libc === $57e3bb76c0539f18$exports.GLIBC ? "" : libc;
    const platformId = [
        `${platform}${libcId}`
    ];
    if (arch === "arm") {
        const fallback = $jrD34.versions.electron ? "7" : "6";
        platformId.push(`armv${$90d2174590e6b8fe$var$env.npm_config_arm_version || $jrD34.config.variables.arm_version || fallback}`);
    } else if (arch === "arm64") platformId.push(`arm64v${$90d2174590e6b8fe$var$env.npm_config_arm_version || "8"}`);
    else platformId.push(arch);
    return platformId.join("-");
};


var $62c6adf4e65d1d71$exports = {};
$62c6adf4e65d1d71$exports = JSON.parse('{"name":"sharp","description":"High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP, GIF, AVIF and TIFF images","version":"0.31.3","author":"Lovell Fuller <npm@lovell.info>","homepage":"https://github.com/lovell/sharp","contributors":["Pierre Inglebert <pierre.inglebert@gmail.com>","Jonathan Ong <jonathanrichardong@gmail.com>","Chanon Sajjamanochai <chanon.s@gmail.com>","Juliano Julio <julianojulio@gmail.com>","Daniel Gasienica <daniel@gasienica.ch>","Julian Walker <julian@fiftythree.com>","Amit Pitaru <pitaru.amit@gmail.com>","Brandon Aaron <hello.brandon@aaron.sh>","Andreas Lind <andreas@one.com>","Maurus Cuelenaere <mcuelenaere@gmail.com>","Linus Unneb\xe4ck <linus@folkdatorn.se>","Victor Mateevitsi <mvictoras@gmail.com>","Alaric Holloway <alaric.holloway@gmail.com>","Bernhard K. Weisshuhn <bkw@codingforce.com>","Chris Riley <criley@primedia.com>","David Carley <dacarley@gmail.com>","John Tobin <john@limelightmobileinc.com>","Kenton Gray <kentongray@gmail.com>","Felix B\xfcnemann <Felix.Buenemann@gmail.com>","Samy Al Zahrani <samyalzahrany@gmail.com>","Chintan Thakkar <lemnisk8@gmail.com>","F. Orlando Galashan <frulo@gmx.de>","Kleis Auke Wolthuizen <info@kleisauke.nl>","Matt Hirsch <mhirsch@media.mit.edu>","Matthias Thoemmes <thoemmes@gmail.com>","Patrick Paskaris <patrick@paskaris.gr>","J\xe9r\xe9my Lal <kapouer@melix.org>","Rahul Nanwani <r.nanwani@gmail.com>","Alice Monday <alice0meta@gmail.com>","Kristo Jorgenson <kristo.jorgenson@gmail.com>","YvesBos <yves_bos@outlook.com>","Guy Maliar <guy@tailorbrands.com>","Nicolas Coden <nicolas@ncoden.fr>","Matt Parrish <matt.r.parrish@gmail.com>","Marcel Bretschneider <marcel.bretschneider@gmail.com>","Matthew McEachen <matthew+github@mceachen.org>","Jarda Kotěšovec <jarda.kotesovec@gmail.com>","Kenric D\'Souza <kenric.dsouza@gmail.com>","Oleh Aleinyk <oleg.aleynik@gmail.com>","Marcel Bretschneider <marcel.bretschneider@gmail.com>","Andrea Bianco <andrea.bianco@unibas.ch>","Rik Heywood <rik@rik.org>","Thomas Parisot <hi@oncletom.io>","Nathan Graves <nathanrgraves+github@gmail.com>","Tom Lokhorst <tom@lokhorst.eu>","Espen Hovlandsdal <espen@hovlandsdal.com>","Sylvain Dumont <sylvain.dumont35@gmail.com>","Alun Davies <alun.owain.davies@googlemail.com>","Aidan Hoolachan <ajhoolachan21@gmail.com>","Axel Eirola <axel.eirola@iki.fi>","Freezy <freezy@xbmc.org>","Daiz <taneli.vatanen@gmail.com>","Julian Aubourg <j@ubourg.net>","Keith Belovay <keith@picthrive.com>","Michael B. Klein <mbklein@gmail.com>","Jordan Prudhomme <jordan@raboland.fr>","Ilya Ovdin <iovdin@gmail.com>","Andargor <andargor@yahoo.com>","Paul Neave <paul.neave@gmail.com>","Brendan Kennedy <brenwken@gmail.com>","Brychan Bennett-Odlum <git@brychan.io>","Edward Silverton <e.silverton@gmail.com>","Roman Malieiev <aromaleev@gmail.com>","Tomas Szabo <tomas.szabo@deftomat.com>","Robert O\'Rourke <robert@o-rourke.org>","Guillermo Alfonso Varela Chouci\xf1o <guillevch@gmail.com>","Christian Flintrup <chr@gigahost.dk>","Manan Jadhav <manan@motionden.com>","Leon Radley <leon@radley.se>","alza54 <alza54@thiocod.in>","Jacob Smith <jacob@frende.me>","Michael Nutt <michael@nutt.im>","Brad Parham <baparham@gmail.com>","Taneli Vatanen <taneli.vatanen@gmail.com>","Joris Dugu\xe9 <zaruike10@gmail.com>","Chris Banks <christopher.bradley.banks@gmail.com>","Ompal Singh <ompal.hitm09@gmail.com>","Brodan <christopher.hranj@gmail.com","Ankur Parihar <ankur.github@gmail.com>","Brahim Ait elhaj <brahima@gmail.com>","Mart Jansink <m.jansink@gmail.com>"],"scripts":{"install":"(node install/libvips && node install/dll-copy && prebuild-install) || (node install/can-compile && node-gyp rebuild && node install/dll-copy)","clean":"rm -rf node_modules/ build/ vendor/ .nyc_output/ coverage/ test/fixtures/output.*","test":"npm run test-lint && npm run test-unit && npm run test-licensing","test-lint":"semistandard && cpplint","test-unit":"nyc --reporter=lcov --reporter=text --check-coverage --branches=100 mocha","test-licensing":"license-checker --production --summary --onlyAllow=\\"Apache-2.0;BSD;ISC;MIT\\"","test-leak":"./test/leak/leak.sh","docs-build":"documentation lint lib && node docs/build && node docs/search-index/build","docs-serve":"cd docs && npx serve","docs-publish":"cd docs && npx firebase-tools deploy --project pixelplumbing --only hosting:pixelplumbing-sharp"},"main":"lib/index.js","files":["binding.gyp","install/**","lib/**","src/**"],"repository":{"type":"git","url":"git://github.com/lovell/sharp"},"keywords":["jpeg","png","webp","avif","tiff","gif","svg","jp2","dzi","image","resize","thumbnail","crop","embed","libvips","vips"],"dependencies":{"color":"^4.2.3","detect-libc":"^2.0.1","node-addon-api":"^5.0.0","prebuild-install":"^7.1.1","semver":"^7.3.8","simple-get":"^4.0.1","tar-fs":"^2.1.1","tunnel-agent":"^0.6.0"},"devDependencies":{"async":"^3.2.4","cc":"^3.0.1","documentation":"^14.0.1","exif-reader":"^1.0.3","extract-zip":"^2.0.1","icc":"^2.0.0","license-checker":"^25.0.1","mocha":"^10.2.0","mock-fs":"^5.2.0","nyc":"^15.1.0","prebuild":"^11.0.4","rimraf":"^3.0.2","semistandard":"^16.0.1"},"license":"Apache-2.0","config":{"libvips":"8.13.3","integrity":{"darwin-arm64v8":"sha512-xFgYt7CtQSZcWoyUdzPTDNHbioZIrZSEU+gkMxzH4Cgjhi4/N49UsonnIZhKQoTBGloAqEexHeMx4rYTQ2Kgvw==","darwin-x64":"sha512-6SivWKzu15aUMMohe0wg7sNYMPETVnOe40BuWsnKOgzl3o5FpQqNSgs+68Mi8Za3Qti9/DaR+H/fyD0x48Af2w==","linux-arm64v8":"sha512-b+iI9V/ehgDabXYRQcvqa5CEysh+1FQsgFmYc358StCrJCDahwNmsQdsiH1GOVd5WaWh5wHUGByPwMmFOO16Aw==","linux-armv6":"sha512-zRP2F+EiustLE4bXSH8AHCxwfemh9d+QuvmPjira/HL6uJOUuA7SyQgVV1TPwTQle2ioCNnKPm7FEB/MAiT+ug==","linux-armv7":"sha512-6OCChowE5lBXXXAZrnGdA9dVktg7UdODEBpE5qTroiAJYZv4yXRMgyDFYajok7du2NTgoklhxGk8d9+4vGv5hg==","linux-x64":"sha512-OTmlmP2r8ozGKdB96X+K5oQE1ojVZanqLqqKlwDpEnfixyIaDGYbVzcjWBNGU3ai/26bvkaCkjynnc2ecYcsuA==","linuxmusl-arm64v8":"sha512-Qh5Wi+bkKTohFYHzSPssfjMhIkD6z6EHbVmnwmWSsgY9zsUBStFp6+mKcNTQfP5YM5Mz06vJOkLHX2OzEr5TzA==","linuxmusl-x64":"sha512-DwB4Fs3+ISw9etaLCANkueZDdk758iOS+wNp4TKZkHdq0al6B/3Pk7OHLR8a9E3H6wYDD328u++dcJzip5tacA==","win32-arm64v8":"sha512-96r3W+O4BtX602B1MtxU5Ru4lKzRRTZqM4OQEBJ//TNL3fiCZdd9agD+RQBjaeR4KFIyBSt3F7IE425ZWmxz+w==","win32-ia32":"sha512-qfN1MsfQGek1QQd1UNW7JT+5K5Ne1suFQ2GpgpYm3JLSpIve/tz2vOGEGzvTVssOBADJvAkTDFt+yIi3PgU9pA==","win32-x64":"sha512-eb3aAmjbVVBVRbiYgebQwoxkAt69WI8nwmKlilSQ3kWqoc0pXfIe322rF2UR8ebbISCGvYRUfzD2r1k92RXISQ=="},"runtime":"napi","target":7},"engines":{"node":">=14.15.0"},"funding":{"url":"https://opencollective.com/libvips"},"binary":{"napi_versions":[7]},"semistandard":{"env":["mocha"]},"cc":{"linelength":"120","filter":["build/include"]}}');


var $a4310910d91ee940$require$config = $62c6adf4e65d1d71$exports.config;
const $a4310910d91ee940$var$env = {};
const $a4310910d91ee940$var$minimumLibvipsVersionLabelled = $a4310910d91ee940$var$env.npm_package_config_libvips || /* istanbul ignore next */ $a4310910d91ee940$require$config.libvips;
const $a4310910d91ee940$var$minimumLibvipsVersion = $f35134ed7d1d7ed5$exports($a4310910d91ee940$var$minimumLibvipsVersionLabelled).version;
const $a4310910d91ee940$var$spawnSyncOptions = {
    encoding: "utf8",
    shell: true
};
const $a4310910d91ee940$var$vendorPath = $06a8745e08fb71fc$exports.join($a4310910d91ee940$var$__dirname, "..", "vendor", $a4310910d91ee940$var$minimumLibvipsVersion, $90d2174590e6b8fe$exports());
const $a4310910d91ee940$var$mkdirSync = function(dirPath) {
    try {
        $74cd6c9a79ff8a91$exports.mkdirSync(dirPath, {
            recursive: true
        });
    } catch (err) {
        /* istanbul ignore next */ if (err.code !== "EEXIST") throw err;
    }
};
const $a4310910d91ee940$var$cachePath = function() {
    const npmCachePath = $a4310910d91ee940$var$env.npm_config_cache || /* istanbul ignore next */ ($a4310910d91ee940$var$env.APPDATA ? $06a8745e08fb71fc$exports.join($a4310910d91ee940$var$env.APPDATA, "npm-cache") : $06a8745e08fb71fc$exports.join($020783f940518ebd$export$c1d46b5ea6262c0b(), ".npm"));
    $a4310910d91ee940$var$mkdirSync(npmCachePath);
    const libvipsCachePath = $06a8745e08fb71fc$exports.join(npmCachePath, "_libvips");
    $a4310910d91ee940$var$mkdirSync(libvipsCachePath);
    return libvipsCachePath;
};
const $a4310910d91ee940$var$integrity = function(platformAndArch) {
    return $a4310910d91ee940$var$env[`npm_package_config_integrity_${platformAndArch.replace("-", "_")}`] || $a4310910d91ee940$require$config.integrity[platformAndArch];
};
const $a4310910d91ee940$var$log = function(item) {
    if (item instanceof Error) console.error(`sharp: Installation error: ${item.message}`);
    else console.log(`sharp: ${item}`);
};
const $a4310910d91ee940$var$isRosetta = function() {
    /* istanbul ignore next */ if ($jrD34.platform === "darwin" && $jrD34.arch === "x64") {
        const translated = $a4310910d91ee940$require$spawnSync("sysctl sysctl.proc_translated", $a4310910d91ee940$var$spawnSyncOptions).stdout;
        return (translated || "").trim() === "sysctl.proc_translated: 1";
    }
    return false;
};
const $a4310910d91ee940$var$globalLibvipsVersion = function() {
    if ($jrD34.platform !== "win32") {
        const globalLibvipsVersion = $a4310910d91ee940$require$spawnSync("pkg-config --modversion vips-cpp", {
            ...$a4310910d91ee940$var$spawnSyncOptions,
            env: {
                ...$a4310910d91ee940$var$env,
                PKG_CONFIG_PATH: $a4310910d91ee940$var$pkgConfigPath()
            }
        }).stdout;
        /* istanbul ignore next */ return (globalLibvipsVersion || "").trim();
    } else return "";
};
const $a4310910d91ee940$var$hasVendoredLibvips = function() {
    return $74cd6c9a79ff8a91$exports.existsSync($a4310910d91ee940$var$vendorPath);
};
/* istanbul ignore next */ const $a4310910d91ee940$var$removeVendoredLibvips = function() {
    const rm = $74cd6c9a79ff8a91$exports.rmSync ? $74cd6c9a79ff8a91$exports.rmSync : $74cd6c9a79ff8a91$exports.rmdirSync;
    rm($a4310910d91ee940$var$vendorPath, {
        recursive: true,
        maxRetries: 3,
        force: true
    });
};
/* istanbul ignore next */ const $a4310910d91ee940$var$pkgConfigPath = function() {
    if ($jrD34.platform !== "win32") {
        const brewPkgConfigPath = $a4310910d91ee940$require$spawnSync('which brew >/dev/null 2>&1 && brew environment --plain | grep PKG_CONFIG_LIBDIR | cut -d" " -f2', $a4310910d91ee940$var$spawnSyncOptions).stdout || "";
        return [
            brewPkgConfigPath.trim(),
            $a4310910d91ee940$var$env.PKG_CONFIG_PATH,
            "/usr/local/lib/pkgconfig",
            "/usr/lib/pkgconfig",
            "/usr/local/libdata/pkgconfig",
            "/usr/libdata/pkgconfig"
        ].filter(Boolean).join(":");
    } else return "";
};
const $a4310910d91ee940$var$useGlobalLibvips = function() {
    if (Boolean($a4310910d91ee940$var$env.SHARP_IGNORE_GLOBAL_LIBVIPS) === true) return false;
    /* istanbul ignore next */ if ($a4310910d91ee940$var$isRosetta()) return false;
    const globalVipsVersion = $a4310910d91ee940$var$globalLibvipsVersion();
    return !!globalVipsVersion && /* istanbul ignore next */ $a7284a87a0cf7b48$exports(globalVipsVersion, $a4310910d91ee940$var$minimumLibvipsVersion);
};
$a4310910d91ee940$exports = {
    minimumLibvipsVersion: $a4310910d91ee940$var$minimumLibvipsVersion,
    minimumLibvipsVersionLabelled: $a4310910d91ee940$var$minimumLibvipsVersionLabelled,
    cachePath: $a4310910d91ee940$var$cachePath,
    integrity: $a4310910d91ee940$var$integrity,
    log: $a4310910d91ee940$var$log,
    globalLibvipsVersion: $a4310910d91ee940$var$globalLibvipsVersion,
    hasVendoredLibvips: $a4310910d91ee940$var$hasVendoredLibvips,
    removeVendoredLibvips: $a4310910d91ee940$var$removeVendoredLibvips,
    pkgConfigPath: $a4310910d91ee940$var$pkgConfigPath,
    useGlobalLibvips: $a4310910d91ee940$var$useGlobalLibvips,
    mkdirSync: $a4310910d91ee940$var$mkdirSync
};


if (document.querySelector("[data-parallax-el]") && window.innerWidth >= 1025) {
    const parallaxContainer = document.querySelectorAll("[data-parallax-el]");
    parallaxContainer.forEach((elem)=>{
        let parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($b804194f136cecc7$exports)))(elem);
        parallaxInstance.enable();
    });
}
if (document.querySelector("[data-duplicate]")) {
    const originalArr = document.querySelectorAll("[data-original]");
    const duplicateArr = document.querySelectorAll("[data-duplicate]");
    originalArr.forEach((originalElement)=>{
        const originalValue = originalElement.dataset.original;
        duplicateArr.forEach((duplicateElement)=>{
            const duplicateValue = duplicateElement.dataset.duplicate;
            if (originalValue === duplicateValue) duplicateElement.textContent = originalElement.textContent;
        });
    });
}
if (document.querySelector("[data-splitting]")) {
    const splittingArr = document.querySelectorAll("[data-splitting]");
    splittingArr.forEach((item, i)=>{
        if (item.hasAttribute("data-splitting-char") === true) {
            const splitting = Splitting({
                target: item
            });
        } else {
            const splitting = Splitting({
                target: item,
                by: "words"
            });
        }
    });
}
window.initTilt = function initTilt1() {
    if (document.querySelector("[data-tilt-init]") && window.innerWidth > 1024) {
        const tiltInitItemsArr = document.querySelectorAll("[data-tilt-init]");
        tiltInitItemsArr.forEach((item)=>{
            VanillaTilt.init(item, {
                max: 7,
                speed: 500
            });
        });
    }
};
initTilt();
if (document.getElementsByClassName("aura-card") && window.innerWidth > 551) {
    const page = document.querySelector("#site");
    const header = document.querySelector("header");
    const headerBurger = document.querySelector(".header .burger");
    const auraContainers = document.querySelectorAll(".aura-container");
    if (window.innerWidth > 1025) auraContainers.forEach((container)=>{
        const auraCursor = container.querySelector(".cursor-aura");
        const auraCursorWidth = auraCursor.offsetWidth;
        const auraCursorHeight = auraCursor.offsetHeight;
        const initLeft = parseFloat(getComputedStyle(auraCursor).left);
        const initTop = parseFloat(getComputedStyle(auraCursor).top);
        function cursorAuraLogic(e) {
            auraCursor.classList.add("active");
            const rect = container.getBoundingClientRect();
            let x = e.clientX - rect.left - auraCursorWidth / 1.85;
            let y = e.clientY - rect.top - auraCursorHeight / 1.95;
            const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
            const currentTop = parseFloat(getComputedStyle(auraCursor).top);
            x -= currentLeft;
            y -= currentTop;
            requestAnimationFrame(()=>{
                auraCursor.style.left = 0;
                auraCursor.style.top = 0;
                auraCursor.style.transform = `translate(${x}px, ${y}px)`;
            });
        }
        function cursorAuraLeaveLogic() {
            auraCursor.classList.remove("active");
            auraCursor.style.left = `${initLeft}px`;
            auraCursor.style.top = `${initTop}px`;
            auraCursor.style.transform = `translate(0, 0)`;
        }
        container.addEventListener("mousemove", (e)=>{
            auraCursor.classList.add("is-init");
            cursorAuraLogic(e);
        });
        container.addEventListener("mouseleave", (event)=>{
            const nextElement = document.elementFromPoint(event.clientX, event.clientY);
            if (header.contains(nextElement)) return;
            cursorAuraLeaveLogic();
        });
        if (header) {
            header.addEventListener("mousemove", (e)=>{
                if (!header.classList.contains("open-menu")) {
                    auraCursor.classList.add("is-init");
                    cursorAuraLogic(e);
                }
            });
            header.addEventListener("mouseleave", (event)=>{
                const nextElement = document.elementFromPoint(event.clientX, event.clientY);
                console.log(nextElement);
                if (container.contains(nextElement)) {
                    console.log(123);
                    return;
                }
                cursorAuraLeaveLogic();
            });
            headerBurger.addEventListener("click", ()=>{
                cursorAuraLeaveLogic();
            });
        }
    /*window.addEventListener('DOMContentLoaded', (event) => {
        const isCursorOverElement = isCursorOverElementOnLoad(container);
        console.log(
          'Курсор на элементе при загрузке страницы:',
          isCursorOverElement
        );
        cursorAuraLogic(event);
      });*/ });
}
// click on btn
document.querySelectorAll(".btn").forEach((button)=>{
    button.addEventListener("mousedown", (event)=>{
        button.classList.add("clicked");
    });
    button.addEventListener("mouseup", (event)=>{
        button.classList.remove("clicked");
    });
    // Для мобільних пристроїв
    button.addEventListener("touchstart", (event)=>{
        button.classList.add("clicked");
    // event.preventDefault();
    });
    button.addEventListener("touchend", (event)=>{
        button.classList.remove("clicked");
    // event.preventDefault();
    });
});


window.saveBtn = function saveBtn(btn) {
    const isSecondSaveBtn = btn.classList.contains("btn-second-save");
    if (isSecondSaveBtn) {
        const isActive = btn.classList.contains("active");
        const allSaveButtons = document.querySelectorAll(".btn-second-save");
        allSaveButtons.forEach((saveBtn)=>{
            if (isActive) saveBtn.classList.remove("active");
            else saveBtn.classList.add("active");
            const btnSecondArr = saveBtn.querySelectorAll(".btn-second-toggle");
            btnSecondArr.forEach((btnSecond)=>{
                const icon = btnSecond.querySelector(".btn__icon");
                if (isActive) {
                    btnSecond.classList.remove("active");
                    if (icon) icon.classList.remove("active");
                } else {
                    btnSecond.classList.add("active");
                    if (icon) icon.classList.add("active");
                }
            });
        });
    } else {
        const icon = btn.querySelector(".btn__icon");
        if (icon) icon.classList.toggle("active");
        const iconSecond = btn.querySelector(".text-btn__icon");
        if (iconSecond) iconSecond.classList.toggle("active");
    }
};


const $72e71178325c7acb$var$doubleRangeFirst = document.getElementsByClassName("double-range-tooltips-1")[0];
if ($72e71178325c7acb$var$doubleRangeFirst) {
    const slider = $72e71178325c7acb$var$doubleRangeFirst.querySelector("#double-range-tooltips-1");
    const max = +slider.dataset.max;
    const min = +slider.dataset.min;
    const unit = slider.dataset?.unit || "";
    const step = +slider.dataset.step;
    const inputsHidden = $72e71178325c7acb$var$doubleRangeFirst.querySelectorAll(".double-range-hidden-input");
    const startValueMin = +inputsHidden[0].value;
    const startValueMax = +inputsHidden[1].value;
    // how many percentages limit from borders ???? is 8%
    const borderLimit = 8;
    // each step is go backward for this amount of % ???? is 5%
    const borderDiff = 40 / borderLimit;
    noUiSlider.create(slider, {
        start: [
            startValueMin,
            startValueMax
        ],
        connect: true,
        tooltips: true,
        margin: 10,
        step: step,
        range: {
            min: min,
            max: max
        }
    });
    const tooltipsArr = slider.querySelectorAll(".noUi-tooltip");
    const circlesArr = slider.querySelectorAll(".noUi-origin");
    function returnTransform(element) {
        return element.replace(/[^0-9][^\d.]/g, "").replace(")", "").split(" ").map((str)=>{
            return Number(str);
        });
    }
    function needToMerge() {
        let tooltipOnePosition = tooltipsArr[0].getBoundingClientRect();
        let tooltipTwoPosition = tooltipsArr[1].getBoundingClientRect();
        if (tooltipsArr[0].classList.contains("hidden") || tooltipsArr[1].classList.contains("hidden")) return true;
        return tooltipOnePosition.left + tooltipOnePosition.width - tooltipTwoPosition.left > 0;
    }
    function resetTooltips(values) {
        mergeDiff = null;
        tooltipsArr.forEach((elem, index)=>{
            elem.textContent = unit + Math.round(values[index]).toLocaleString("en-GB");
            elem.classList.remove("hidden");
        });
    }
    let trueTooltip = false;
    let mergeDiff = null;
    slider.noUiSlider.on("update", function(values, handle) {
        // translate of noUISlider -> 0% is start, 100% is end
        let translate = returnTransform(circlesArr[handle].style.transform)[0];
        // min value of double range slider
        let valueMin = returnTransform(circlesArr[0].style.transform)[0];
        // max value of double range slider
        let valueMax = returnTransform(circlesArr[1].style.transform)[0];
        // difference between min and max value of double range slider
        let difference = valueMax - valueMin;
        inputsHidden[handle].value = Math.round(values[handle]);
        // if tooltips are close to each other
        if (needToMerge()) {
            if (!tooltipsArr[+!handle].classList.contains("hidden") && !tooltipsArr[handle].classList.contains("hidden")) {
                trueTooltip = handle;
                mergeDiff = difference;
                tooltipsArr[+!handle].classList.add("hidden");
            }
            if (trueTooltip) {
                // limit left merged tooltip from overflowing
                // borderLimit * 3 === need for 3 times faster limitation because of merged tooltip
                if (translate <= -100 + borderLimit * 3) tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference + Math.abs(translate + 100 - borderLimit * 3) * borderDiff / 2.5}%,100%)`;
                else // position of tooltip in the middle of range
                tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference}%,100%)`;
            } else // if left tooltip is grabbed
            if (translate >= -borderLimit * 4) // limit right merged tooltip from overflowing
            tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference - Math.abs(translate + borderLimit * 3) * borderDiff / 2.5}%,100%)`;
            else tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference}%,100%)`;
            tooltipsArr[trueTooltip].textContent = `${unit + Math.round(values[0]).toLocaleString("en-GB")} - ${unit + Math.round(values[1]).toLocaleString("en-GB")}`;
            if (mergeDiff - difference < 0) {
                mergeDiff = null;
                resetTooltips(values);
            }
        } else {
            // limit left solo tooltip from overflowing
            if (translate <= -100 + borderLimit) tooltipsArr[0].style.transform = `translate(${-50 + Math.abs(translate + 100 - borderLimit) * borderDiff}%,100%)`;
            else if (translate >= -borderLimit) // limit right solo tooltip from overflowing
            tooltipsArr[1].style.transform = `translate(${-50 - Math.abs(translate + borderLimit) * borderDiff}%,100%)`;
            else // position of tooltip in the middle of range
            tooltipsArr[handle].style.transform = "translate(-50%,100%)";
            tooltipsArr[handle].textContent = `${unit + Math.round(values[handle]).toLocaleString("en-GB")}`;
        }
    });
}
const $72e71178325c7acb$var$doubleRangeSecond = document.getElementsByClassName("double-range-tooltips-2")[0];
if ($72e71178325c7acb$var$doubleRangeSecond) {
    const slider = $72e71178325c7acb$var$doubleRangeSecond.querySelector("#double-range-tooltips-2");
    const max = +slider.dataset.max;
    const min = +slider.dataset.min;
    const unit = slider.dataset?.unit || "";
    const step = +slider.dataset.step;
    const inputsHidden = $72e71178325c7acb$var$doubleRangeSecond.querySelectorAll(".double-range-hidden-input");
    const startValueMin = +inputsHidden[0].value;
    const startValueMax = +inputsHidden[1].value;
    // how many percentages limit from borders ???? is 8%
    const borderLimit = 8;
    // each step is go backward for this amount of % ???? is 5%
    const borderDiff = 40 / borderLimit;
    noUiSlider.create(slider, {
        start: [
            startValueMin,
            startValueMax
        ],
        connect: true,
        tooltips: true,
        margin: 10,
        step: step,
        range: {
            min: min,
            max: max
        }
    });
    const tooltipsArr = slider.querySelectorAll(".noUi-tooltip");
    const circlesArr = slider.querySelectorAll(".noUi-origin");
    function returnTransformSecond(element) {
        return element.replace(/[^0-9][^\d.]/g, "").replace(")", "").split(" ").map((str)=>{
            return Number(str);
        });
    }
    function needToMergeSecond() {
        let tooltipOnePosition = tooltipsArr[0].getBoundingClientRect();
        let tooltipTwoPosition = tooltipsArr[1].getBoundingClientRect();
        if (tooltipsArr[0].classList.contains("hidden") || tooltipsArr[1].classList.contains("hidden")) return true;
        return tooltipOnePosition.left + tooltipOnePosition.width - tooltipTwoPosition.left > 0;
    }
    function resetTooltipsSecond(values) {
        mergeDiff = null;
        tooltipsArr.forEach((elem, index)=>{
            elem.textContent = unit + Math.round(values[index]).toLocaleString("en-GB");
            elem.classList.remove("hidden");
        });
    }
    let trueTooltip = false;
    let mergeDiff = null;
    slider.noUiSlider.on("update", function(values, handle) {
        // translate of noUISlider -> 0% is start, 100% is end
        let translate = returnTransformSecond(circlesArr[handle].style.transform)[0];
        // min value of double range slider
        let valueMin = returnTransformSecond(circlesArr[0].style.transform)[0];
        // max value of double range slider
        let valueMax = returnTransformSecond(circlesArr[1].style.transform)[0];
        // difference between min and max value of double range slider
        let difference = valueMax - valueMin;
        inputsHidden[handle].value = Math.round(values[handle]);
        // if tooltips are close to each other
        if (needToMergeSecond()) {
            if (!tooltipsArr[+!handle].classList.contains("hidden") && !tooltipsArr[handle].classList.contains("hidden")) {
                trueTooltip = handle;
                mergeDiff = difference;
                tooltipsArr[+!handle].classList.add("hidden");
            }
            if (trueTooltip) {
                // limit left merged tooltip from overflowing
                // borderLimit * 3 === need for 3 times faster limitation because of merged tooltip
                if (translate <= -100 + borderLimit * 3) tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference + Math.abs(translate + 100 - borderLimit * 3) * borderDiff / 2.5}%,100%)`;
                else // position of tooltip in the middle of range
                tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference}%,100%)`;
            } else // if left tooltip is grabbed
            if (translate >= -borderLimit * 4) // limit right merged tooltip from overflowing
            tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference - Math.abs(translate + borderLimit * 3) * borderDiff / 2.5}%,100%)`;
            else tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference}%,100%)`;
            tooltipsArr[trueTooltip].textContent = `${unit + Math.round(values[0]).toLocaleString("en-GB")} - ${unit + Math.round(values[1]).toLocaleString("en-GB")}`;
            if (mergeDiff - difference < 0) {
                mergeDiff = null;
                resetTooltipsSecond(values);
            }
        } else {
            // limit left solo tooltip from overflowing
            if (translate <= -100 + borderLimit) tooltipsArr[0].style.transform = `translate(${-50 + Math.abs(translate + 100 - borderLimit) * borderDiff}%,100%)`;
            else if (translate >= -borderLimit) // limit right solo tooltip from overflowing
            tooltipsArr[1].style.transform = `translate(${-50 - Math.abs(translate + borderLimit) * borderDiff}%,100%)`;
            else // position of tooltip in the middle of range
            tooltipsArr[handle].style.transform = "translate(-50%,100%)";
            tooltipsArr[handle].textContent = `${unit + Math.round(values[handle]).toLocaleString("en-GB")}`;
        }
    });
}
const $72e71178325c7acb$var$doubleRangeThird = document.getElementsByClassName("double-range-tooltips-3")[0];
if ($72e71178325c7acb$var$doubleRangeThird) {
    const slider = $72e71178325c7acb$var$doubleRangeThird.querySelector("#double-range-tooltips-3");
    const max = +slider.dataset.max;
    const min = +slider.dataset.min;
    const unit = slider.dataset?.unit || "";
    const step = +slider.dataset.step;
    const inputsHidden = $72e71178325c7acb$var$doubleRangeThird.querySelectorAll(".double-range-hidden-input");
    const startValueMin = +inputsHidden[0].value;
    const startValueMax = +inputsHidden[1].value;
    // how many percentages limit from borders ???? is 8%
    const borderLimit = 8;
    // each step is go backward for this amount of % ???? is 5%
    const borderDiff = 40 / borderLimit;
    noUiSlider.create(slider, {
        start: [
            startValueMin,
            startValueMax
        ],
        connect: true,
        tooltips: true,
        margin: 10,
        step: step,
        range: {
            min: min,
            max: max
        }
    });
    const tooltipsArr = slider.querySelectorAll(".noUi-tooltip");
    const circlesArr = slider.querySelectorAll(".noUi-origin");
    function returnTransformThird(element) {
        return element.replace(/[^0-9][^\d.]/g, "").replace(")", "").split(" ").map((str)=>{
            return Number(str);
        });
    }
    function needToMergeThird() {
        let tooltipOnePosition = tooltipsArr[0].getBoundingClientRect();
        let tooltipTwoPosition = tooltipsArr[1].getBoundingClientRect();
        if (tooltipsArr[0].classList.contains("hidden") || tooltipsArr[1].classList.contains("hidden")) return true;
        return tooltipOnePosition.left + tooltipOnePosition.width - tooltipTwoPosition.left > 0;
    }
    function resetTooltipsThird(values) {
        mergeDiff = null;
        tooltipsArr.forEach((elem, index)=>{
            elem.textContent = unit + Math.round(values[index]).toLocaleString("en-GB");
            elem.classList.remove("hidden");
        });
    }
    let trueTooltip = false;
    let mergeDiff = null;
    slider.noUiSlider.on("update", function(values, handle) {
        // translate of noUISlider -> 0% is start, 100% is end
        let translate = returnTransformThird(circlesArr[handle].style.transform)[0];
        // min value of double range slider
        let valueMin = returnTransformThird(circlesArr[0].style.transform)[0];
        // max value of double range slider
        let valueMax = returnTransformThird(circlesArr[1].style.transform)[0];
        // difference between min and max value of double range slider
        let difference = valueMax - valueMin;
        inputsHidden[handle].value = Math.round(values[handle]);
        // if tooltips are close to each other
        if (needToMergeThird()) {
            if (!tooltipsArr[+!handle].classList.contains("hidden") && !tooltipsArr[handle].classList.contains("hidden")) {
                trueTooltip = handle;
                mergeDiff = difference;
                tooltipsArr[+!handle].classList.add("hidden");
            }
            if (trueTooltip) {
                // limit left merged tooltip from overflowing
                // borderLimit * 3 === need for 3 times faster limitation because of merged tooltip
                if (translate <= -100 + borderLimit * 3) tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference + Math.abs(translate + 100 - borderLimit * 3) * borderDiff / 2.5}%,100%)`;
                else // position of tooltip in the middle of range
                tooltipsArr[trueTooltip].style.transform = `translate(${-50 - difference}%,100%)`;
            } else // if left tooltip is grabbed
            if (translate >= -borderLimit * 4) // limit right merged tooltip from overflowing
            tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference - Math.abs(translate + borderLimit * 3) * borderDiff / 2.5}%,100%)`;
            else tooltipsArr[trueTooltip].style.transform = `translate(${-50 + difference}%,100%)`;
            tooltipsArr[trueTooltip].textContent = `${unit + Math.round(values[0]).toLocaleString("en-GB")} - ${unit + Math.round(values[1]).toLocaleString("en-GB")}`;
            if (mergeDiff - difference < 0) {
                mergeDiff = null;
                resetTooltipsThird(values);
            }
        } else {
            // limit left solo tooltip from overflowing
            if (translate <= -100 + borderLimit) tooltipsArr[0].style.transform = `translate(${-50 + Math.abs(translate + 100 - borderLimit) * borderDiff}%,100%)`;
            else if (translate >= -borderLimit) // limit right solo tooltip from overflowing
            tooltipsArr[1].style.transform = `translate(${-50 - Math.abs(translate + borderLimit) * borderDiff}%,100%)`;
            else // position of tooltip in the middle of range
            tooltipsArr[handle].style.transform = "translate(-50%,100%)";
            tooltipsArr[handle].textContent = `${unit + Math.round(values[handle]).toLocaleString("en-GB")}`;
        }
    });
}
const $72e71178325c7acb$var$singleRangeSlider = ()=>{
    const singleRange = document.getElementsByClassName("single-range-default")[0];
    if (singleRange) {
        const slider = singleRange.querySelector("#single-range-default");
        const inputsHidden = singleRange.querySelector(".single-range-hidden-input");
        const inputInfo = singleRange.querySelector(".single-range-info");
        const unit = slider.dataset?.unit || "";
        const fixedPoints = [
            10,
            20,
            30,
            40,
            50,
            75,
            100,
            250,
            500,
            1000,
            2500,
            5000
        ];
        let isUpdating = false;
        noUiSlider.create(slider, {
            start: [
                fixedPoints[0]
            ],
            connect: "lower",
            range: {
                min: fixedPoints[0],
                max: fixedPoints[fixedPoints.length - 1]
            },
            step: 1,
            pips: {
                mode: "positions",
                values: fixedPoints.map((_, index)=>index / (fixedPoints.length - 1) * 100),
                density: 4
            }
        });
        // Привязка к ближайшему значению
        slider.noUiSlider.on("update", function(values, handle) {
            if (isUpdating) return;
            const currentValue = +values[handle];
            const closestValue = fixedPoints.reduce((prev, curr)=>Math.abs(curr - currentValue) < Math.abs(prev - currentValue) ? curr : prev);
            if (currentValue !== closestValue) {
                isUpdating = true;
                slider.noUiSlider.set(closestValue);
                isUpdating = false;
            }
            if (inputInfo) inputInfo.textContent = `Radius: ${closestValue} ${unit}`;
            if (inputsHidden) inputsHidden.value = closestValue;
        });
    }
};
$72e71178325c7acb$var$singleRangeSlider();
if (document.querySelector(".range-checkbox")) {
    const rangeCheckboxes = document.querySelectorAll(".range-checkbox");
    rangeCheckboxes.forEach((rangeCheckbox)=>{
        const range = rangeCheckbox.nextElementSibling;
        const checkbox = rangeCheckbox.querySelector("input");
        checkbox.addEventListener("click", ()=>{
            if (checkbox.checked) range.classList.add("is-open");
            else range.classList.remove("is-open");
        });
        if (checkbox.checked) range.classList.add("is-open");
        else range.classList.remove("is-open");
    });
}


// @ts-check
/**
 * Shorthand for `document.getElementsByClassName`
 *
 * @param {String} selClass - The selector's class
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {HTMLCollectionOf<Element>} - The selected elements
 */ function $68067f5faa1735de$var$byClass(selClass, parent = document) {
    return parent.getElementsByClassName(selClass);
}
/**
 * Shorthand for `document.querySelector`
 *
 * @param {String} selector - Selector
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {Element|HTMLElementTagNameMap|SVGElementTagNameMap|null} - The selected element
 */ function $68067f5faa1735de$var$query(selector, parent = document) {
    return parent.querySelector(selector);
}
/**
 * Shorthand for `document.querySelectorAll`
 *
 * @param {String} selector - Selector
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {NodeList} - The selected element
 */ function $68067f5faa1735de$var$queryAll(selector, parent = document) {
    return parent.querySelectorAll(selector);
}
// @ts-check
/**
 * Foreach polyfill for NodeList and HTMLCollection
 * https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
 *
 * @param {Array<any>|NodeList|HTMLCollection} els - A list of elements
 * @param {foreachCB} fn - Callback containing ( value, index ) as arguments
 * @param {Function} [scope] - Scope
 */ function $68067f5faa1735de$var$forEachHTML(els, fn, scope) {
    for(let i = 0, numEls = els.length; i < numEls; i++)fn.call(scope, els[i], i);
}
// @ts-check
/**
 * Shorthand for `element.classList.add`, works with multiple nodes
 *
 * @param {Element|HTMLElement|HTMLCollection|NodeList} el - A list of elements
 * @param {...String} classes - Classes to add
 */ function $68067f5faa1735de$var$addClass(el, ...classes) {
    // @ts-ignore
    if (el.length === undefined) // @ts-ignore
    addClassEl(el, ...classes);
    else // @ts-ignore
    $68067f5faa1735de$var$forEachHTML(el, (currEl)=>{
        addClassEl(currEl, ...classes);
    });
    /**
   * Adds classes to a single element
   *
   * @param {Element|HTMLElement} elem - An HTML element
   * @param {...String} remClass - Classes to add
   */ function addClassEl(elem, ...remClass) {
        remClass.forEach((singleClass)=>{
            elem.classList.add(singleClass);
        });
    }
}
// @ts-check
/**
 * Shorthand for `element.addEventListener`
 *
 * @param {Element|HTMLElement|Window|Document|MediaQueryList} el - A list of elements
 * @param {String} ev - Event's name
 * @param {EventListenerOrEventListenerObject} fn - Event's function
 * @param {Object} [opts] - Optional event options
 */ function $68067f5faa1735de$var$addEvent(el, ev, fn, opts) {
    el.addEventListener(ev, fn, opts);
}
/**
 * Shorthand for `element.removeEventListener`
 *
 * @param {Element|HTMLElement|Window|Document|MediaQueryList} el - A list of elements
 * @param {String} ev - Event's name
 * @param {EventListenerOrEventListenerObject} fn - Event's function
 * @param {Object} [opts] - Optional event options
 */ function $68067f5faa1735de$var$removeEvent(el, ev, fn, opts) {
    el.removeEventListener(ev, fn, opts);
}
// @ts-check
/**
 * Shorthand for `element.getAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to retrieve
 *
 * @returns {String|null} - The attribute's value
 */ function $68067f5faa1735de$var$getAttr(el, attr) {
    return el.getAttribute(attr);
}
/**
 * Shorthand for `element.setAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to retrieve
 * @param {String} val - The value to set to the attribute
 */ function $68067f5faa1735de$var$setAttr(el, attr, val) {
    el.setAttribute(attr, val);
}
/**
 * Shorthand for `element.removeAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to remove
 */ function $68067f5faa1735de$var$remAttr(el, attr) {
    el.removeAttribute(attr);
}
/**
 * @typedef defaultOptions
 * @property {String} [css3easing='linear'] - A css3 transtion timing
 * @property {Number} [delayBeforeStart=1000] - Time in milliseconds before the marquee starts animating
 * @property {String} [direction='left'] - Direction towards which the marquee will animate ` 'left' | 'right' | 'up' | 'down'`
 * @property {Boolean} [duplicated=false] - Should the marquee be duplicated to show an effect of continuous flow. Use this only when the text is shorter than the container
 * @property {Number} [duration=5000] - Duration in milliseconds in which you want your element to travel
 * @property {Number} [gap=20] - Gap in pixels between the tickers. Will work only when the `duplicated` option is set to `true`
 * @property {Boolean} [pauseOnHover=false] - Pause the marquee on hover
 * @property {Boolean} [recalcResize=false] - Recalculate the marquee position on resize (breaks compatibility with jquery.marquee)
 * @property {Number} [speed=0] - Speed will override duration. Speed allows you to set a relatively constant marquee speed regardless of the width of the containing element. Speed is measured in pixels/second
 * @property {Boolean} [startVisible=false] - The marquee will be visible from the start if set to `true`
 */ const $68067f5faa1735de$var$defOpts = {
    css3easing: "linear",
    delayBeforeStart: 1000,
    direction: "left",
    duplicated: false,
    duration: 5000,
    gap: 20,
    pauseOnHover: false,
    recalcResize: false,
    speed: 0,
    startVisible: false
};
let $68067f5faa1735de$var$instances = 0;
/**
 * Vanilla js marquee based on jQuery.marquee
 * https://github.com/aamirafridi/jQuery.Marquee
 */ class $68067f5faa1735de$export$2e2bcd8739ae039 {
    /**
   * Build the css string for the animation
   *
   * @privte
   * @param {String} [name=''] - animation name
   * @param {Number} [duration=0] - Animation duration (in s)
   * @param {Number} [delay=0] - Animation delay before starting (in s)
   * @param {String} [loops=''] - Animation iterations
   *
   * @returns {String} css animation string
   */ _animationStr(name = "", duration = 0, delay = 0, loops = "") {
        return `${name} ${duration}s ${delay}s ${loops} ${this._opts.css3easing}`;
    }
    /**
   * Animation of the marquee
   *
   * @private
   * @param {Boolean} vertical - Vertical direction
   */ _animate(vertical = false) {
        const opts = this._opts;
        if (opts.duplicated) {
            // When duplicated, the first loop will be scroll longer so double the duration
            if (this._loopCount === 1) {
                let duration = opts.duration;
                if (vertical) duration = opts.direction === "up" ? duration + this._contHeight / (this._elHeight / duration) : duration * 2;
                else duration = opts.direction === "left" ? duration + this._contWidth / (this._elWidth / duration) : duration * 2;
                this._animStr = this._animationStr(this._animName, duration / 1000, opts.delayBeforeStart / 1000);
            // On 2nd loop things back to normal, normal duration for the rest of animations
            } else if (this._loopCount === 2) {
                this._animName = `${this._animName}0`;
                this._animStr = this._animationStr(this._animName, opts.duration / 1000, 0, "infinite");
            }
            this._loopCount++;
        }
        let animationCss = "";
        if (vertical) {
            if (opts.duplicated) {
                // Adjust the starting point of animation only when first loops finishes
                if (this._loopCount > 2) this._marqWrap.style.transform = `translateY(${opts.direction === "up" ? 0 : -1 * this._elHeight}px)`;
                animationCss = `translateY(${opts.direction === "up" ? -1 * this._elHeight : 0}px)`;
            } else if (opts.startVisible) {
                // This loop moves the marquee out of the container
                if (this._loopCount === 2) {
                    // Adjust the css3 animation as well
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, opts.delayBeforeStart / 1000);
                    animationCss = `translateY(${opts.direction === "up" ? -1 * this._elHeight : this._contHeight}px)`;
                    this._loopCount++;
                } else if (this._loopCount === 3) {
                    this._animName = `${this._animName}0`;
                    this._animStr = this._animationStr(this._animName, this._completeDuration / 1000, 0, "infinite");
                    this._repositionVert();
                }
            } else {
                this._repositionVert();
                animationCss = `translateY(${opts.direction === "up" ? -1 * this._marqWrap.clientHeight : this._contHeight}px)`;
            }
        } else {
            if (opts.duplicated) {
                // Adjust the starting point of animation only when first loops finishes
                if (this._loopCount > 2) this._marqWrap.style.transform = `translateX(${opts.direction === "left" ? 0 : -1 * this._elWidth}px)`;
                animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : 0}px)`;
            } else if (opts.startVisible) {
                // This loop moves the marquee out of the container
                if (this._loopCount === 2) {
                    // Adjust the css3 animation as well
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, opts.delayBeforeStart / 1000);
                    animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : this._contWidth}px)`;
                    this._loopCount++;
                } else if (this._loopCount === 3) {
                    // Adjust the animation
                    this._animName = `${this._animName}0`;
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, 0, "infinite");
                    this._repositionHor();
                }
            } else {
                this._repositionHor();
                animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : this._contWidth}px)`;
            }
        }
        // fire event
        this.el.dispatchEvent(new CustomEvent("beforeStarting"));
        // Append animation
        this._marqWrap.style.animation = this._animStr;
        const keyFrameCss = `@keyframes ${this._animName} {
        100% {
          transform: ${animationCss};
        }
      }`, styles = $68067f5faa1735de$var$queryAll("style", this._marqWrap);
        if (styles.length) styles[styles.length - 1].innerHTML = keyFrameCss;
        else if ($68067f5faa1735de$var$byClass(`marq-wrap-style-${this._instance}`).length) $68067f5faa1735de$var$byClass(`marq-wrap-style-${this._instance}`)[0].innerHTML = keyFrameCss;
        else {
            const styleEl = document.createElement("style");
            $68067f5faa1735de$var$addClass(styleEl, `marq-wrap-style-${this._instance}`);
            styleEl.innerHTML = keyFrameCss;
            $68067f5faa1735de$var$query("head").appendChild(styleEl);
        }
        // Animation iteration event
        $68067f5faa1735de$var$addEvent(this._marqWrap, "animationiteration", this._animIter.bind(this), {
            once: true
        });
        // Animation stopped
        $68067f5faa1735de$var$addEvent(this._marqWrap, "animationend", this._animEnd.bind(this), {
            once: true
        });
        this._status = "running";
        $68067f5faa1735de$var$setAttr(this.el, "data-runningStatus", "resumed");
    }
    /**
   * Event fired on Animation iteration
   *
   * @private
   */ _animIter() {
        this.el.dispatchEvent(new CustomEvent("finished"));
    }
    /**
   * Reposition the Wrapper vertically
   *
   * @private
   */ _repositionVert() {
        this._marqWrap.style.transform = `translateY(${this._opts.direction === "up" ? this._contHeight : this._elHeight * -1}px)`;
    }
    /**
   * Reposition the Wrapper horizontally
   *
   * @private
   */ _repositionHor() {
        this._marqWrap.style.transform = `translateX(${this._opts.direction === "left" ? this._contWidth : this._elWidth * -1}px)`;
    }
    /**
   * Calculates the speed and the dimension of the marquee
   *
   * @private
   */ _calcSizes() {
        const el = this.el, opts = this._opts;
        // If direction is up or down, get the height of main element
        if (this._vertical) {
            const contHeight = el.clientHeight;
            this._contHeight = contHeight;
            $68067f5faa1735de$var$remAttr(this._marqWrap, "style");
            el.style.clientHeight = `${contHeight}px`;
            const marqs = $68067f5faa1735de$var$byClass("js-marquee", el), marqNums = marqs.length - 1;
            // Change the CSS for js-marquee element
            $68067f5faa1735de$var$forEachHTML(marqs, (currEl, ind)=>{
                currEl.style.float = "none";
                currEl.style.marginRight = "0px";
                // Remove bottom margin from 2nd element if duplicated
                if (opts.duplicated && ind === marqNums) currEl.style.marginBottom = "0px";
                else currEl.style.marginBottom = `${opts.gap}px`;
            });
            const elHeight = parseInt(marqs[0].clientHeight + opts.gap);
            this._elHeight = elHeight;
            // adjust the animation duration according to the text length
            if (opts.startVisible && !opts.duplicated) {
                // Compute the complete animation duration and save it for later reference
                // formula is to: (Height of the text node + height of the main container / Height of the main container) * duration;
                this._completeDuration = (elHeight + contHeight) / parseInt(contHeight) * this._duration; // eslint-disable-line max-len
                opts.duration = elHeight / parseInt(contHeight) * this._duration;
            } else opts.duration = elHeight / parseInt(contHeight) / parseInt(contHeight) * this._duration;
        } else {
            // Save the width of the each element so we can use it in animation
            const elWidth = parseInt($68067f5faa1735de$var$byClass("js-marquee", el)[0].clientWidth + opts.gap), contWidth = el.clientWidth;
            this._contWidth = contWidth;
            this._elWidth = elWidth;
            // adjust the animation duration according to the text length
            if (opts.startVisible && !opts.duplicated) {
                // Compute the complete animation duration and save it for later reference
                // formula is to: (Width of the text node + width of the main container / Width of the main container) * duration;
                this._completeDuration = (elWidth + contWidth) / parseInt(contWidth) * this._duration;
                // (Width of the text node / width of the main container) * duration
                opts.duration = elWidth / parseInt(contWidth) * this._duration;
            } else opts.duration = (elWidth + parseInt(contWidth)) / parseInt(contWidth) * this._duration; // eslint-disable-line max-len
        }
        // if duplicated then reduce the duration
        if (opts.duplicated) opts.duration = opts.duration / 2;
    }
    /**
   * Recalculates the dimensions and positon of the marquee on page resize
   *
   * @private
   */ _recalcResize() {
        this._calcSizes();
        this._loopCount = 2;
        this._animEnd();
    }
    /**
   * Pause the animation
   */ pause() {
        this._marqWrap.style.animationPlayState = "paused";
        this._status = "paused";
        $68067f5faa1735de$var$setAttr(this.el, "data-runningStatus", "paused");
        this.el.dispatchEvent(new CustomEvent("paused"));
    }
    /**
   * Resume the animation
   */ resume() {
        this._marqWrap.style.animationPlayState = "running";
        this._status = "running";
        $68067f5faa1735de$var$setAttr(this.el, "data-runningStatus", "resumed");
        this.el.dispatchEvent(new CustomEvent("resumed"));
    }
    /**
   * Toggle animation playing status
   */ toggle() {
        if (this._status === "paused") this.resume();
        else if (this._status === "running") this.pause();
    }
    /**
   * Destorys the instance and removes events
   */ destroy() {
        $68067f5faa1735de$var$removeEvent(this.el, "pause", this.pause.bind(this));
        $68067f5faa1735de$var$removeEvent(this.el, "resume", this.resume.bind(this));
        if (this._opts.pauseOnHover) {
            $68067f5faa1735de$var$removeEvent(this.el, "mouseover", this.pause.bind(this));
            $68067f5faa1735de$var$removeEvent(this.el, "mouseout", this.resume.bind(this));
        }
        $68067f5faa1735de$var$removeEvent(this._marqWrap, "animationiteration", this._animIter.bind(this), {
            once: true
        });
        $68067f5faa1735de$var$removeEvent(this._marqWrap, "animationend", this._animEnd.bind(this), {
            once: true
        });
        if (this._opts.recalcResize) $68067f5faa1735de$var$removeEvent(window, "resize", this._recalcResize.bind(this));
    }
    /**
   * Forces a refresh (like recalcResize) but done manually
   */ refresh() {
        this._recalcResize();
    }
    /**
   * Constructor
   *
   * @param {Element} el - The element where the marquee is applied
   * @param {defaultOptions} opts - the options
   */ constructor(el, opts){
        if (typeof el === "undefined") throw new Error("el cannot be undefined");
        if (typeof el === "string") throw new Error("el cannot be just a selector");
        if (el === null) throw new Error("el cannot be null");
        opts = {
            ...$68067f5faa1735de$var$defOpts,
            ...opts
        };
        this.el = el;
        this._loopCount = 3;
        // Check for data-option since they have top priority
        for(const option in $68067f5faa1735de$var$defOpts){
            let currData = $68067f5faa1735de$var$getAttr(el, `data-${$68067f5faa1735de$var$defOpts[option]}`);
            if (currData !== null && currData !== "") {
                if (currData === "true" || currData === "false") currData = Boolean(currData);
                opts[option] = currData;
            }
        }
        // Reintroduce speed as an option. It calculates duration as a factor of the container width
        // measured in pixels per second.
        if (opts.speed) opts.duration = parseInt(el.clientWidth) / opts.speed * 1000;
        // no gap if not duplicated
        opts.gap = opts.duplicated ? parseInt(opts.gap) : 0;
        // wrap inner content into a div
        el.innerHTML = `<div class="js-marquee">${el.innerHTML}</div>`;
        // Make a copy of the element
        const marq = $68067f5faa1735de$var$byClass("js-marquee", el)[0];
        marq.style.marginRight = `${opts.gap}px`;
        marq.style.willChange = "transform";
        marq.style.float = "left";
        if (opts.duplicated) el.appendChild(marq.cloneNode(true));
        // wrap both inner elements into one div
        el.innerHTML = `<div style="width:100000px" class="js-marquee-wrapper">${el.innerHTML}</div>`;
        // Save the reference of the wrapper
        const marqWrap = $68067f5faa1735de$var$byClass("js-marquee-wrapper", el)[0], vertical = opts.direction === "up" || opts.direction === "down";
        this._marqWrap = marqWrap;
        this._vertical = vertical;
        this._duration = opts.duration;
        this._opts = opts;
        this._calcSizes();
        const animationName = `marqueeAnimation-${Math.floor(Math.random() * 10000000)}`, animStr = this._animationStr(animationName, opts.duration / 1000, opts.delayBeforeStart / 1000, "infinite");
        this._animName = animationName;
        this._animStr = animStr;
        // if duplicated option is set to true than position the wrapper
        if (opts.duplicated) {
            if (vertical) {
                if (opts.startVisible) this._marqWrap.style.transform = "translateY(0px)";
                else this._marqWrap.style.transform = `translateY(${opts.direction === "up" ? this._contHeight : -1 * (this._elHeight * 2 - opts.gap)}px)`;
            } else if (opts.startVisible) this._marqWrap.style.transform = "translateX(0px)";
            else this._marqWrap.style.transform = `translateX(${opts.direction === "left" ? this._contWidth : -1 * (this._elWidth * 2 - opts.gap)}px)`;
            // If the text starts out visible we can skip the two initial loops
            if (!opts.startVisible) this._loopCount = 1;
        } else if (opts.startVisible) // We only have two different loops if marquee is duplicated and starts visible
        this._loopCount = 2;
        else if (vertical) this._repositionVert();
        else this._repositionHor();
        $68067f5faa1735de$var$addEvent(this.el, "pause", this.pause.bind(this));
        $68067f5faa1735de$var$addEvent(this.el, "resume", this.resume.bind(this));
        if (opts.pauseOnHover) {
            $68067f5faa1735de$var$addEvent(this.el, "mouseover", this.pause.bind(this));
            $68067f5faa1735de$var$addEvent(this.el, "mouseout", this.resume.bind(this));
        }
        /**
     * Method for animation end event
     */ this._animEnd = ()=>{
            this._animate(vertical);
            this.el.dispatchEvent(new CustomEvent("finished"));
        };
        this._instance = $68067f5faa1735de$var$instances;
        $68067f5faa1735de$var$instances++;
        this._animate(vertical);
        if (opts.recalcResize) $68067f5faa1735de$var$addEvent(window, "resize", this._recalcResize.bind(this));
    }
}


/*let speedMarque = 20;

if (document.getElementById('marquee_1')) {
  if (window.innerWidth <= 640) {
    speedMarque = 10;
  }
  new marquee(document.getElementById('marquee_1'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    recalcResize: false,
    startVisible: true,
  });
}

if (document.getElementById('marquee_2')) {
  new marquee(document.getElementById('marquee_2'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    direction: 'right',
    recalcResize: false,
    startVisible: true,
  });
}*/ if (document.querySelector(".clients__marquee")) {
    const marqueeArray = [];
    const marqueeArr = document.querySelectorAll(".clients__marquee");
    marqueeArr.forEach((marqueeEl, i)=>{
        const itemsArr = marqueeEl.querySelectorAll(".clients__logo");
        itemsArr.forEach((itemEl)=>{
            const clone = itemEl.cloneNode(true);
            marqueeEl.appendChild(clone);
        });
        itemsArr.forEach((itemEl)=>{
            const clone = itemEl.cloneNode(true);
            marqueeEl.appendChild(clone);
        });
        itemsArr.forEach((itemEl)=>{
            const clone = itemEl.cloneNode(true);
            marqueeEl.appendChild(clone);
        });
        const container = 1440;
        const finalItemsArr = marqueeEl.querySelectorAll(".clients__logo");
        let duration = 5800;
        const totalWidth = finalItemsArr.length * (finalItemsArr[0].clientWidth + 12);
        let baseSpeed = 4;
        let scalingFactor = window.innerWidth < 768 ? 1.1 : 1.5;
        if (window.innerWidth >= 1921) scalingFactor = 2.5;
        baseSpeed *= scalingFactor;
        duration = totalWidth / window.innerWidth * baseSpeed;
        let direction = "up";
        let pauseOnHover = true;
        if (window.innerWidth <= 1024) pauseOnHover = false;
        direction = "left";
        if (i % 2) direction = "right";
        const mq = new (0, $68067f5faa1735de$export$2e2bcd8739ae039)(marqueeEl, {
            delayBeforeStart: 0,
            direction: direction,
            pauseOnHover: pauseOnHover,
            duplicated: true,
            recalcResize: window.innerWidth >= 768,
            startVisible: true,
            gap: 12,
            duration: duration * 1000
        });
        marqueeArray.push(mq);
        if (window.innerWidth <= 1024) setTimeout(function() {
            const itemsArr = marqueeEl.querySelectorAll(".clients__logo");
            itemsArr.forEach((item)=>{
                item.addEventListener("click", (e)=>{
                    if (item.classList.contains("is-hover")) {
                        item.classList.remove("is-hover");
                        mq.resume();
                    } else {
                        const newArr = document.querySelectorAll(".clients__logo");
                        for(let j = 0; j < newArr.length; j++)newArr[j].classList.remove("is-hover");
                        item.classList.add("is-hover");
                        for(let j = 0; j < marqueeArray.length; j++)marqueeArray[j].resume();
                        mq.pause();
                    }
                });
            });
        }, 100);
    });
    document.addEventListener("click", function(event) {
        if (!marqueeArr[0].parentElement.contains(event.target)) {
            const newArr = document.querySelectorAll(".clients__logo");
            for(let j = 0; j < newArr.length; j++)newArr[j].classList.remove("is-hover");
            for(let j = 0; j < marqueeArray.length; j++)marqueeArray[j].resume();
        }
    });
}


const $0ccaa1c6c17cf942$var$togetherList = document.querySelector(".together-section__list");
if ($0ccaa1c6c17cf942$var$togetherList) {
    const togetherItemsArr = $0ccaa1c6c17cf942$var$togetherList.querySelectorAll(".together-section__item");
    togetherItemsArr.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            if (!item.classList.contains("active")) {
                for(let i = 0; i < togetherItemsArr.length; i++)togetherItemsArr[i].classList.remove("active");
                item.classList.add("active");
            }
        });
    });
}


// accordion
const $73e2b54c20f9b155$var$accordions = document.querySelectorAll(".our-services-section__accordion");
const $73e2b54c20f9b155$var$closeAllAccordions = ()=>{
    $73e2b54c20f9b155$var$accordions.forEach((accordion)=>{
        const bodyAccordion = accordion.querySelector(".our-services-section__accordion-body");
        accordion.classList.remove("our-services-section__accordion--active");
        bodyAccordion.style.maxHeight = "0px";
    });
};
const $73e2b54c20f9b155$var$openFirstAccordion = ()=>{
    if ($73e2b54c20f9b155$var$accordions.length > 0) {
        const firstAccordion = $73e2b54c20f9b155$var$accordions[0];
        const bodyAccordion = firstAccordion?.querySelector(".our-services-section__accordion-body");
        firstAccordion.classList?.add("our-services-section__accordion--active");
        bodyAccordion.style.maxHeight = `${bodyAccordion.scrollHeight + 120}px`;
    }
};
$73e2b54c20f9b155$var$accordions.forEach((accordion)=>{
    const navAccordion = accordion.querySelector(".our-services-section__accordion-nav");
    const bodyAccordion = accordion.querySelector(".our-services-section__accordion-body");
    const accrodionParen = bodyAccordion.parentElement;
    const toggleAccordion = ()=>{
        if (!accordion.classList.contains("our-services-section__accordion--active")) $73e2b54c20f9b155$var$closeAllAccordions();
        accordion.classList.toggle("our-services-section__accordion--active");
        if (accordion.classList.contains("our-services-section__accordion--active")) bodyAccordion.style.maxHeight = `${bodyAccordion.scrollHeight + 120}px`;
        else bodyAccordion.style.maxHeight = "0px";
    };
    navAccordion.addEventListener("click", toggleAccordion);
    window.addEventListener("resize", ()=>{
        if (accordion.classList.contains("our-services-section__accordion--active")) {
            bodyAccordion.style.maxHeight = `${bodyAccordion.scrollHeight + 120}px`;
            console.log("resize");
        }
    });
});
$73e2b54c20f9b155$var$openFirstAccordion();


if (document.querySelector(".contact-form-section__toggle-btn")) {
    const toggleButtons = document.querySelectorAll(".contact-form-section__toggle-btn");
    const toggleBg = document.querySelector(".contact-form-section__toggle-bg");
    const tabContents = document.querySelectorAll(".contact-form-section__form");
    toggleButtons?.forEach((item)=>{
        item.addEventListener("click", ()=>{
            toggleButtons.forEach((btn)=>{
                btn.classList.remove("contact-form-section__toggle-btn--active");
            });
            item.classList.add("contact-form-section__toggle-btn--active");
            if (item.classList.contains("contact-form-section__toggle-2")) toggleBg.classList.add("contact-form-section__toggle-bg-2");
            else toggleBg.classList.remove("contact-form-section__toggle-bg-2");
            let tabId = item.getAttribute("data-contact-tab");
            tabContents.forEach(function(content) {
                content.classList.remove("contact-form-section__form--active");
            });
            const activeForm = document.getElementById("contact-form-" + tabId);
            activeForm.classList.add("contact-form-section__form--active");
            if (window.innerWidth <= 992) activeForm.scrollIntoView({
                behavior: "smooth"
            });
        });
    });
// toggleButtons[0].classList.add('contact-form-section__toggle-btn--active');
// tabContents[0].classList.add('contact-form-section__form--active');
}


let $48ae03d565013cb5$var$tabs = document.querySelectorAll(".our-location-section__tab");
let $48ae03d565013cb5$var$tabContents = document.querySelectorAll(".our-location-section__content");
$48ae03d565013cb5$var$tabs?.forEach(function(tab) {
    tab.addEventListener("click", function() {
        let tabId = this.getAttribute("data-tab-location");
        $48ae03d565013cb5$var$tabs.forEach(function(tab) {
            tab.classList.remove("our-location-section__tab--active");
        });
        $48ae03d565013cb5$var$tabContents.forEach(function(content) {
            content.classList.remove("our-location-section__content--active");
        });
        this.classList.add("our-location-section__tab--active");
        const activeContent = document.getElementById("our-location-" + tabId);
        activeContent.classList.add("our-location-section__content--active");
        if (window.innerWidth < 992) activeContent.scrollIntoView({
            behavior: "smooth"
        });
    });
});
// Активуємо перший таб і його контент за замовчуванням
$48ae03d565013cb5$var$tabs[0]?.classList.add("our-location-section__tab--active");
$48ae03d565013cb5$var$tabContents[0]?.classList.add("our-location-section__content--active");


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $d2c7c4b5956f03f7$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $d2c7c4b5956f03f7$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($d2c7c4b5956f03f7$var$isObject(src[key]) && $d2c7c4b5956f03f7$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $d2c7c4b5956f03f7$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $d2c7c4b5956f03f7$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $d2c7c4b5956f03f7$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $d2c7c4b5956f03f7$export$8b58be045bf06082(doc, $d2c7c4b5956f03f7$export$3fdcb9b4d81368d8);
    return doc;
}
const $d2c7c4b5956f03f7$export$8582633f185c62bb = {
    document: $d2c7c4b5956f03f7$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $d2c7c4b5956f03f7$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $d2c7c4b5956f03f7$export$8b58be045bf06082(win, $d2c7c4b5956f03f7$export$8582633f185c62bb);
    return win;
}


/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
/* eslint-disable no-proto */ function $ee8b19d713a703ac$var$makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class $ee8b19d713a703ac$var$Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            $ee8b19d713a703ac$var$makeReactive(this);
        }
    }
}
function $ee8b19d713a703ac$var$arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...$ee8b19d713a703ac$var$arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function $ee8b19d713a703ac$var$arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function $ee8b19d713a703ac$var$arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function $ee8b19d713a703ac$var$toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function $ee8b19d713a703ac$var$qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(selector, context) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    let arr = [];
    if (!context && selector instanceof $ee8b19d713a703ac$var$Dom7) return selector;
    if (!selector) return new $ee8b19d713a703ac$var$Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = $ee8b19d713a703ac$var$qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof $ee8b19d713a703ac$var$Dom7) return selector;
        arr = selector;
    }
    return new $ee8b19d713a703ac$var$Dom7($ee8b19d713a703ac$var$arrayUnique(arr));
}
$ee8b19d713a703ac$export$3d8c2f653ac9d0b9.fn = $ee8b19d713a703ac$var$Dom7.prototype;
// eslint-disable-next-line
function $ee8b19d713a703ac$export$d2cf6cd1dc7067d3(...classes) {
    const classNames = $ee8b19d713a703ac$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function $ee8b19d713a703ac$export$c2255604a80b4506(...classes) {
    const classNames = $ee8b19d713a703ac$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function $ee8b19d713a703ac$export$4a80062ca50b57c7(...classes) {
    const classNames = $ee8b19d713a703ac$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function $ee8b19d713a703ac$export$4ea3d958472af68f(...classes) {
    const classNames = $ee8b19d713a703ac$var$arrayFlat(classes.map((c)=>c.split(" ")));
    return $ee8b19d713a703ac$var$arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function $ee8b19d713a703ac$export$7aabe8b3a840d2fd(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function $ee8b19d713a703ac$export$842f2b51efdcb631(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function $ee8b19d713a703ac$export$977f3f6a9323c0f6(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function $ee8b19d713a703ac$export$4051a07651545597(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function $ee8b19d713a703ac$export$33f1b464f736cf21(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function $ee8b19d713a703ac$export$ff416b0d33795a06() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[$ee8b19d713a703ac$var$toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function $ee8b19d713a703ac$export$b02c28252f48c6ac(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function $ee8b19d713a703ac$export$2ab9a8f9f1186f14(value) {
    return this.val(value);
}
function $ee8b19d713a703ac$export$51186ad6e864892a(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function $ee8b19d713a703ac$export$66bb15e2994e6a26(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function $ee8b19d713a703ac$export$af631764ddc44097(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function $ee8b19d713a703ac$export$8c8705df4a2dcec9(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function $ee8b19d713a703ac$export$d2de3aaeafa91619(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function $ee8b19d713a703ac$export$e614dc9140f7ae71(...args) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function $ee8b19d713a703ac$export$1f5f3fbd0c021f73(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function $ee8b19d713a703ac$export$358dc01d65cad417(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function $ee8b19d713a703ac$export$70f051812b89bf32(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function $ee8b19d713a703ac$export$7e3df82ee760448c() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function $ee8b19d713a703ac$export$e823f88e4111159a(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function $ee8b19d713a703ac$export$ac607276a8fe9f0a() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function $ee8b19d713a703ac$export$fc5b8aac72846d1e(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function $ee8b19d713a703ac$export$cc800923e997bb8() {
    if (this.length > 0) {
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function $ee8b19d713a703ac$export$fe8985bb6374093c() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function $ee8b19d713a703ac$export$57bf213be019eeb0() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function $ee8b19d713a703ac$export$9dd6ff9ea0189349() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function $ee8b19d713a703ac$export$dbf350e5966cf602(props, value) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function $ee8b19d713a703ac$export$79b2f7037acddd43(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function $ee8b19d713a703ac$export$3dea766d36a8935f(callback) {
    const result = $ee8b19d713a703ac$var$arrayFilter(this, callback);
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(result);
}
function $ee8b19d713a703ac$export$c0bb0b647f701bb5(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function $ee8b19d713a703ac$export$6f093cfa640b7166(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function $ee8b19d713a703ac$export$226b3eccf92c9ed9(selector) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof $ee8b19d713a703ac$var$Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function $ee8b19d713a703ac$export$b610b8812bbcded9() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $ee8b19d713a703ac$export$9663ddc1cf085b32(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
        return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
            this[returnIndex]
        ]);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
        this[index]
    ]);
}
function $ee8b19d713a703ac$export$10d8903dec122b9d(...els) {
    let newChild;
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof $ee8b19d713a703ac$var$Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function $ee8b19d713a703ac$export$9ceefe31f12a3778(parent) {
    $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parent).append(this);
    return this;
}
function $ee8b19d713a703ac$export$68159836694e22c1(newChild) {
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof $ee8b19d713a703ac$var$Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function $ee8b19d713a703ac$export$44da2b52169043ea(parent) {
    $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parent).prepend(this);
    return this;
}
function $ee8b19d713a703ac$export$86b68c7dbeb53c22(selector) {
    const before = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function $ee8b19d713a703ac$export$c4f94c8b3850a5a9(selector) {
    const after = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function $ee8b19d713a703ac$export$48cfd1e771a65c4f(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(this[0].nextElementSibling).is(selector)) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
                this[0].nextElementSibling
            ]);
            return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
        }
        if (this[0].nextElementSibling) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
            this[0].nextElementSibling
        ]);
        return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
}
function $ee8b19d713a703ac$export$3cd99760d81ede63(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(nextEls);
}
function $ee8b19d713a703ac$export$232faf9add678146(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(el.previousElementSibling).is(selector)) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
                el.previousElementSibling
            ]);
            return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
        }
        if (el.previousElementSibling) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([
            el.previousElementSibling
        ]);
        return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
}
function $ee8b19d713a703ac$export$5a01ccd45552d0b4(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(prevEls);
}
function $ee8b19d713a703ac$export$9866dd70b0dcd4c3(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function $ee8b19d713a703ac$export$91124bb58bc04465(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parents);
}
function $ee8b19d713a703ac$export$7901f6cd558b9a93(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(parents);
}
function $ee8b19d713a703ac$export$ff7f7c97cdce86e(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function $ee8b19d713a703ac$export$71aa6c912b956294(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(foundElements);
}
function $ee8b19d713a703ac$export$bacb5cc5a11aef16(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(children);
}
function $ee8b19d713a703ac$export$cd7f480d6b8286c3() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function $ee8b19d713a703ac$export$3f780019ff766da6() {
    return this.remove();
}
function $ee8b19d713a703ac$export$e16d8520af44a096(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function $ee8b19d713a703ac$export$6e22c362a0406a2c() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function $ee8b19d713a703ac$export$3f99968195accfaf(...args) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function $ee8b19d713a703ac$export$3e0c8fa3b5e4b3b9(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function $ee8b19d713a703ac$export$6eddf9bc7f2b7d80(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function $ee8b19d713a703ac$export$e3607ec2d7a891c4(initialProps, initialParams) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue: initialValue, finalValue: finalValue, unit: unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function $ee8b19d713a703ac$export$fa6813432f753b0d() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const $ee8b19d713a703ac$var$noTrigger = "resize scroll".split(" ");
function $ee8b19d713a703ac$var$shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if ($ee8b19d713a703ac$var$noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $ee8b19d713a703ac$export$3d8c2f653ac9d0b9(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const $ee8b19d713a703ac$export$64ef1bee2b9504c1 = $ee8b19d713a703ac$var$shortcut("click");
const $ee8b19d713a703ac$export$2cc7ff91bcacba5e = $ee8b19d713a703ac$var$shortcut("blur");
const $ee8b19d713a703ac$export$d7ddd398f22d79ef = $ee8b19d713a703ac$var$shortcut("focus");
const $ee8b19d713a703ac$export$e7fa4ea7f1bfcb53 = $ee8b19d713a703ac$var$shortcut("focusin");
const $ee8b19d713a703ac$export$d0dc5134b51e78ad = $ee8b19d713a703ac$var$shortcut("focusout");
const $ee8b19d713a703ac$export$d26052c770f81a55 = $ee8b19d713a703ac$var$shortcut("keyup");
const $ee8b19d713a703ac$export$e65a0c4970da3025 = $ee8b19d713a703ac$var$shortcut("keydown");
const $ee8b19d713a703ac$export$563caf6ae76a8875 = $ee8b19d713a703ac$var$shortcut("keypress");
const $ee8b19d713a703ac$export$853c27de4ce0f746 = $ee8b19d713a703ac$var$shortcut("submit");
const $ee8b19d713a703ac$export$d8a7b8f475ec0161 = $ee8b19d713a703ac$var$shortcut("change");
const $ee8b19d713a703ac$export$8b0cb8993e7a9391 = $ee8b19d713a703ac$var$shortcut("mousedown");
const $ee8b19d713a703ac$export$6d0a9e0f4f73830a = $ee8b19d713a703ac$var$shortcut("mousemove");
const $ee8b19d713a703ac$export$c367b5bd9b361db9 = $ee8b19d713a703ac$var$shortcut("mouseup");
const $ee8b19d713a703ac$export$474cd8abd87e2f89 = $ee8b19d713a703ac$var$shortcut("mouseenter");
const $ee8b19d713a703ac$export$996a190879e3098b = $ee8b19d713a703ac$var$shortcut("mouseleave");
const $ee8b19d713a703ac$export$c3a736a37c400eb8 = $ee8b19d713a703ac$var$shortcut("mouseout");
const $ee8b19d713a703ac$export$41b161f130dc7f9 = $ee8b19d713a703ac$var$shortcut("mouseover");
const $ee8b19d713a703ac$export$9f22968b38117503 = $ee8b19d713a703ac$var$shortcut("touchstart");
const $ee8b19d713a703ac$export$3c6ab5207a63e8f7 = $ee8b19d713a703ac$var$shortcut("touchend");
const $ee8b19d713a703ac$export$3086217c4efdbcc9 = $ee8b19d713a703ac$var$shortcut("touchmove");
const $ee8b19d713a703ac$export$4380c87abf28fdf = $ee8b19d713a703ac$var$shortcut("resize");
const $ee8b19d713a703ac$export$209876d7b1ac8f3 = $ee8b19d713a703ac$var$shortcut("scroll");
var $ee8b19d713a703ac$export$2e2bcd8739ae039 = $ee8b19d713a703ac$export$3d8c2f653ac9d0b9;


const $39da613bf6b2d727$var$Methods = {
    addClass: $ee8b19d713a703ac$export$d2cf6cd1dc7067d3,
    removeClass: $ee8b19d713a703ac$export$c2255604a80b4506,
    hasClass: $ee8b19d713a703ac$export$4ea3d958472af68f,
    toggleClass: $ee8b19d713a703ac$export$4a80062ca50b57c7,
    attr: $ee8b19d713a703ac$export$7aabe8b3a840d2fd,
    removeAttr: $ee8b19d713a703ac$export$842f2b51efdcb631,
    transform: $ee8b19d713a703ac$export$51186ad6e864892a,
    transition: $ee8b19d713a703ac$export$66bb15e2994e6a26,
    on: $ee8b19d713a703ac$export$af631764ddc44097,
    off: $ee8b19d713a703ac$export$8c8705df4a2dcec9,
    trigger: $ee8b19d713a703ac$export$e614dc9140f7ae71,
    transitionEnd: $ee8b19d713a703ac$export$358dc01d65cad417,
    outerWidth: $ee8b19d713a703ac$export$e823f88e4111159a,
    outerHeight: $ee8b19d713a703ac$export$fc5b8aac72846d1e,
    styles: $ee8b19d713a703ac$export$9dd6ff9ea0189349,
    offset: $ee8b19d713a703ac$export$cc800923e997bb8,
    css: $ee8b19d713a703ac$export$dbf350e5966cf602,
    each: $ee8b19d713a703ac$export$79b2f7037acddd43,
    html: $ee8b19d713a703ac$export$c0bb0b647f701bb5,
    text: $ee8b19d713a703ac$export$6f093cfa640b7166,
    is: $ee8b19d713a703ac$export$226b3eccf92c9ed9,
    index: $ee8b19d713a703ac$export$b610b8812bbcded9,
    eq: $ee8b19d713a703ac$export$9663ddc1cf085b32,
    append: $ee8b19d713a703ac$export$10d8903dec122b9d,
    prepend: $ee8b19d713a703ac$export$68159836694e22c1,
    next: $ee8b19d713a703ac$export$48cfd1e771a65c4f,
    nextAll: $ee8b19d713a703ac$export$3cd99760d81ede63,
    prev: $ee8b19d713a703ac$export$232faf9add678146,
    prevAll: $ee8b19d713a703ac$export$5a01ccd45552d0b4,
    parent: $ee8b19d713a703ac$export$91124bb58bc04465,
    parents: $ee8b19d713a703ac$export$7901f6cd558b9a93,
    closest: $ee8b19d713a703ac$export$ff7f7c97cdce86e,
    find: $ee8b19d713a703ac$export$71aa6c912b956294,
    children: $ee8b19d713a703ac$export$bacb5cc5a11aef16,
    filter: $ee8b19d713a703ac$export$3dea766d36a8935f,
    remove: $ee8b19d713a703ac$export$cd7f480d6b8286c3
};
Object.keys($39da613bf6b2d727$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $ee8b19d713a703ac$export$3d8c2f653ac9d0b9).fn, methodName, {
        value: $39da613bf6b2d727$var$Methods[methodName],
        writable: true
    });
});
var $39da613bf6b2d727$export$2e2bcd8739ae039 = (0, $ee8b19d713a703ac$export$3d8c2f653ac9d0b9);



function $f91623451aeeb5c4$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $f91623451aeeb5c4$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $f91623451aeeb5c4$export$461939dd4422153() {
    return Date.now();
}
function $f91623451aeeb5c4$export$3735103072e4a80(el) {
    const window1 = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f91623451aeeb5c4$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $f91623451aeeb5c4$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f91623451aeeb5c4$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $f91623451aeeb5c4$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f91623451aeeb5c4$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$f91623451aeeb5c4$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f91623451aeeb5c4$export$a6cdc56e425d0d0a(to[nextKey]) && $f91623451aeeb5c4$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f91623451aeeb5c4$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$f91623451aeeb5c4$export$a6cdc56e425d0d0a(to[nextKey]) && $f91623451aeeb5c4$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f91623451aeeb5c4$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $f91623451aeeb5c4$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f91623451aeeb5c4$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



let $47a00e83d87557e5$var$support;
function $47a00e83d87557e5$var$calcSupport() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $47a00e83d87557e5$export$d61c7b85ff180578() {
    if (!$47a00e83d87557e5$var$support) $47a00e83d87557e5$var$support = $47a00e83d87557e5$var$calcSupport();
    return $47a00e83d87557e5$var$support;
}




let $fe605f7e52046ded$var$deviceCached;
function $fe605f7e52046ded$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $47a00e83d87557e5$export$d61c7b85ff180578)();
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $fe605f7e52046ded$export$30c823bc834d6ab4(overrides = {}) {
    if (!$fe605f7e52046ded$var$deviceCached) $fe605f7e52046ded$var$deviceCached = $fe605f7e52046ded$var$calcDevice(overrides);
    return $fe605f7e52046ded$var$deviceCached;
}



let $d274e7a3dd247815$var$browser;
function $d274e7a3dd247815$var$calcBrowser() {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $d274e7a3dd247815$export$89e15fc796a4a429() {
    if (!$d274e7a3dd247815$var$browser) $d274e7a3dd247815$var$browser = $d274e7a3dd247815$var$calcBrowser();
    return $d274e7a3dd247815$var$browser;
}



function $6e8ccbb78c63fc33$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}



function $2b1536c1c92d61bc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ var $10f2192da13a2412$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $b1eddda5dd55d750$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $60cbfe1f14d572e8$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f91623451aeeb5c4$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $f91623451aeeb5c4$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f91623451aeeb5c4$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $f91623451aeeb5c4$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $6d01c1571e88cd4a$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $39da613bf6b2d727$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}


function $274afc159ae558cc$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $0a6bd3693a494218$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $24cd677841317dfe$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}


function $c8ea84e8ad544477$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $5d13077289a33bd9$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}



function $287e7b2194f08f55$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $13d8ae09db654dec$export$2e2bcd8739ae039 = {
    updateSize: $b1eddda5dd55d750$export$2e2bcd8739ae039,
    updateSlides: $60cbfe1f14d572e8$export$2e2bcd8739ae039,
    updateAutoHeight: $6d01c1571e88cd4a$export$2e2bcd8739ae039,
    updateSlidesOffset: $274afc159ae558cc$export$2e2bcd8739ae039,
    updateSlidesProgress: $0a6bd3693a494218$export$2e2bcd8739ae039,
    updateProgress: $24cd677841317dfe$export$2e2bcd8739ae039,
    updateSlidesClasses: $c8ea84e8ad544477$export$2e2bcd8739ae039,
    updateActiveIndex: $5d13077289a33bd9$export$2e2bcd8739ae039,
    updateClickedSlide: $287e7b2194f08f55$export$2e2bcd8739ae039
};



function $20bac3db39ffa34d$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $f91623451aeeb5c4$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $0a3e1498ff26d4cb$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $4165d9e64118bd99$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $eaa68da55aeda5fe$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $7efb807cdab7241e$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f91623451aeeb5c4$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $250e9fdb507394d5$export$2e2bcd8739ae039 = {
    getTranslate: $20bac3db39ffa34d$export$2e2bcd8739ae039,
    setTranslate: $0a3e1498ff26d4cb$export$2e2bcd8739ae039,
    minTranslate: $4165d9e64118bd99$export$2e2bcd8739ae039,
    maxTranslate: $eaa68da55aeda5fe$export$2e2bcd8739ae039,
    translateTo: $7efb807cdab7241e$export$2e2bcd8739ae039
};


function $cc3fd8c81b31b61c$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}


function $533787f24c760ce4$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $b4403c4d4db51121$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $533787f24c760ce4$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $21e6d8e4fadaef9b$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $533787f24c760ce4$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $062eebdc90caae05$export$2e2bcd8739ae039 = {
    setTransition: $cc3fd8c81b31b61c$export$2e2bcd8739ae039,
    transitionStart: $b4403c4d4db51121$export$2e2bcd8739ae039,
    transitionEnd: $21e6d8e4fadaef9b$export$2e2bcd8739ae039
};



function $1c777d26c0652ae0$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f91623451aeeb5c4$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $8c7cc180f7cbe277$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $958880b2d1df6adc$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $af08465ef529f03a$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $4c31841f42ec859a$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $58cae704f3a66678$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $447136095559322e$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $11d6e4da14d91109$export$2e2bcd8739ae039 = {
    slideTo: $1c777d26c0652ae0$export$2e2bcd8739ae039,
    slideToLoop: $8c7cc180f7cbe277$export$2e2bcd8739ae039,
    slideNext: $958880b2d1df6adc$export$2e2bcd8739ae039,
    slidePrev: $af08465ef529f03a$export$2e2bcd8739ae039,
    slideReset: $4c31841f42ec859a$export$2e2bcd8739ae039,
    slideToClosest: $58cae704f3a66678$export$2e2bcd8739ae039,
    slideToClickedSlide: $447136095559322e$export$2e2bcd8739ae039
};




function $adcaa1feffdc2fa4$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $39da613bf6b2d727$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $2d7d0d24deb1675f$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}


function $8bd00f155a9a00c9$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}


var $c777b8cee729389e$export$2e2bcd8739ae039 = {
    loopCreate: $adcaa1feffdc2fa4$export$2e2bcd8739ae039,
    loopFix: $2d7d0d24deb1675f$export$2e2bcd8739ae039,
    loopDestroy: $8bd00f155a9a00c9$export$2e2bcd8739ae039
};


function $130d2334b7cd9283$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
}


function $31ddaa8415e843af$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}


var $d705ce76b9ee2d18$export$2e2bcd8739ae039 = {
    setGrabCursor: $130d2334b7cd9283$export$2e2bcd8739ae039,
    unsetGrabCursor: $31ddaa8415e843af$export$2e2bcd8739ae039
};






function $83656eea8e521da8$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)() || el === (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $83656eea8e521da8$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $83656eea8e521da8$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === "SELECT") data.isTouched = false;
        }
        if (document.activeElement && (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}





function $4230421b5dce83df$export$2e2bcd8739ae039(event) {
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $efeadb9cda49abe5$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
    (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $b3a9fd862d97510b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $22d5a3d12e4defca$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $e3643f5c079e5547$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}


let $2e8b81de4f9dd917$var$dummyEventAttached = false;
function $2e8b81de4f9dd917$var$dummyEventListener() {}
const $2e8b81de4f9dd917$var$events = (swiper, method)=>{
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $b3a9fd862d97510b$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $b3a9fd862d97510b$export$2e2bcd8739ae039), true);
};
function $2e8b81de4f9dd917$var$attachEvents() {
    const swiper = this;
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $83656eea8e521da8$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $4230421b5dce83df$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $efeadb9cda49abe5$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $e3643f5c079e5547$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $22d5a3d12e4defca$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$2e8b81de4f9dd917$var$dummyEventAttached) {
        document.addEventListener("touchstart", $2e8b81de4f9dd917$var$dummyEventListener);
        $2e8b81de4f9dd917$var$dummyEventAttached = true;
    }
    $2e8b81de4f9dd917$var$events(swiper, "on");
}
function $2e8b81de4f9dd917$var$detachEvents() {
    const swiper = this;
    $2e8b81de4f9dd917$var$events(swiper, "off");
}
var $2e8b81de4f9dd917$export$2e2bcd8739ae039 = {
    attachEvents: $2e8b81de4f9dd917$var$attachEvents,
    detachEvents: $2e8b81de4f9dd917$var$detachEvents
};



const $e84584041497b29b$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $e84584041497b29b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $e84584041497b29b$var$isGridEnabled(swiper, params);
    const isMultiRow = $e84584041497b29b$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f91623451aeeb5c4$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}



function $c5301cbbbc44f6b6$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $a6d76fe448563ff2$export$2e2bcd8739ae039 = {
    setBreakpoint: $e84584041497b29b$export$2e2bcd8739ae039,
    getBreakpoint: $c5301cbbbc44f6b6$export$2e2bcd8739ae039
};


function $0899c87bc7f0883b$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $0899c87bc7f0883b$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $0899c87bc7f0883b$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}


function $c186d7ba0ddf99c9$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}


var $d8e65a1a606188fa$export$2e2bcd8739ae039 = {
    addClasses: $0899c87bc7f0883b$export$2e2bcd8739ae039,
    removeClasses: $c186d7ba0ddf99c9$export$2e2bcd8739ae039
};




function $7ccda343ec26d5f3$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $c252b73c8f375bba$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}


var $fb71d47350bf6640$export$2e2bcd8739ae039 = {
    loadImage: $7ccda343ec26d5f3$export$2e2bcd8739ae039,
    preloadImages: $c252b73c8f375bba$export$2e2bcd8739ae039
};


function $a967e1e011c36015$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $a967e1e011c36015$export$2e2bcd8739ae039 = {
    checkOverflow: $a967e1e011c36015$var$checkOverflow
};


var $c3483a5a38b226a3$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $a639542d4690d627$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $f91623451aeeb5c4$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $f91623451aeeb5c4$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f91623451aeeb5c4$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $c7744d2fb3eefccf$var$prototypes = {
    eventsEmitter: $10f2192da13a2412$export$2e2bcd8739ae039,
    update: $13d8ae09db654dec$export$2e2bcd8739ae039,
    translate: $250e9fdb507394d5$export$2e2bcd8739ae039,
    transition: $062eebdc90caae05$export$2e2bcd8739ae039,
    slide: $11d6e4da14d91109$export$2e2bcd8739ae039,
    loop: $c777b8cee729389e$export$2e2bcd8739ae039,
    grabCursor: $d705ce76b9ee2d18$export$2e2bcd8739ae039,
    events: $2e8b81de4f9dd917$export$2e2bcd8739ae039,
    breakpoints: $a6d76fe448563ff2$export$2e2bcd8739ae039,
    checkOverflow: $a967e1e011c36015$export$2e2bcd8739ae039,
    classes: $d8e65a1a606188fa$export$2e2bcd8739ae039,
    images: $fb71d47350bf6640$export$2e2bcd8739ae039
};
const $c7744d2fb3eefccf$var$extendedDefaults = {};
class $c7744d2fb3eefccf$var$Swiper {
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $39da613bf6b2d727$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $f91623451aeeb5c4$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $f91623451aeeb5c4$export$8b58be045bf06082)($c7744d2fb3eefccf$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $c7744d2fb3eefccf$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $c3483a5a38b226a3$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$c7744d2fb3eefccf$var$Swiper.prototype.__modules__) $c7744d2fb3eefccf$var$Swiper.prototype.__modules__ = [];
        const modules = $c7744d2fb3eefccf$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$c7744d2fb3eefccf$var$Swiper.installModule(m));
            return $c7744d2fb3eefccf$var$Swiper;
        }
        $c7744d2fb3eefccf$var$Swiper.installModule(module);
        return $c7744d2fb3eefccf$var$Swiper;
    }
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $c7744d2fb3eefccf$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $47a00e83d87557e5$export$d61c7b85ff180578)();
        swiper.device = (0, $fe605f7e52046ded$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $d274e7a3dd247815$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $a639542d4690d627$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, (0, $c3483a5a38b226a3$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, swiperParams, $c7744d2fb3eefccf$var$extendedDefaults, params);
        swiper.originalParams = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $f91623451aeeb5c4$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $39da613bf6b2d727$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $f91623451aeeb5c4$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
}
Object.keys($c7744d2fb3eefccf$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($c7744d2fb3eefccf$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $c7744d2fb3eefccf$var$Swiper.prototype[protoMethod] = $c7744d2fb3eefccf$var$prototypes[prototypeGroup][protoMethod];
    });
});
$c7744d2fb3eefccf$var$Swiper.use([
    (0, $6e8ccbb78c63fc33$export$2e2bcd8739ae039),
    (0, $2b1536c1c92d61bc$export$2e2bcd8739ae039)
]);
var $c7744d2fb3eefccf$export$2e2bcd8739ae039 = $c7744d2fb3eefccf$var$Swiper;




function $a0920ef46d087bc9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $f91623451aeeb5c4$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 

function $b2483743fd75eed0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 


function $5975156400beb270$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $f91623451aeeb5c4$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $f91623451aeeb5c4$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $f91623451aeeb5c4$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $f91623451aeeb5c4$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $49438ebde3f867a8$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $4d479dbb1d20a353$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $49438ebde3f867a8$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $39da613bf6b2d727$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $39da613bf6b2d727$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $dd022fb6b3f7a132$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}



function $790dff2f2e9fa291$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $49438ebde3f867a8$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $39da613bf6b2d727$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $4570fd101a93bdce$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $49438ebde3f867a8$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $c3d63d71bd5bcfb3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}





function $86b27c78745de9e9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $f91623451aeeb5c4$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $f91623451aeeb5c4$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}




function $29864d0efb9ca415$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index");
            return (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index") : (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on("destroy", ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $aceb8f318c37b562$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $1fc88d65ef7c030a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $dd022fb6b3f7a132$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $dfdf13dcf529bec0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $2ce55d75a8253eb3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
    const window = (0, $d2c7c4b5956f03f7$export$38b2d434cce3ea22)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 

function $09ecf76cc200f66c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $f91623451aeeb5c4$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit("autoplayPause");
            pause();
        }
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $d2c7c4b5956f03f7$export$f65ca476c09acec0)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $f6bd15e84b469256$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $f91623451aeeb5c4$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $02ba54acc58d2f8b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $f91623451aeeb5c4$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $f91623451aeeb5c4$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $f91623451aeeb5c4$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $c951b52b1b21a8fd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $b3a86c1f5256d8d9$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $445965e21e30dc2a$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $25434b04731de7e0$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $a9b92e01d4757e74$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $295ae53ab719e980$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $a8d2b7d110e0ca8a$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $b3a86c1f5256d8d9$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $445965e21e30dc2a$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $25434b04731de7e0$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $a9b92e01d4757e74$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $295ae53ab719e980$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $3806d7aa2c89bf6a$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $27d83406c7fc18ee$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}


function $5723a6b739c3c109$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $3b2cbf3f4fe14265$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $27d83406c7fc18ee$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $5723a6b739c3c109$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $fd590d45800f3b1d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $c50957b66ce783b5$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $a735a56f5c26a4a5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) shadowBefore = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
        if (shadowAfter.length === 0) shadowAfter = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $39da613bf6b2d727$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $27d83406c7fc18ee$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $5723a6b739c3c109$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $7c7e2b42dd0c6f6e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $27d83406c7fc18ee$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $122c57004122847f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $27d83406c7fc18ee$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $5723a6b739c3c109$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $c13a7dc6529a0bf6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $c50957b66ce783b5$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $27d83406c7fc18ee$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $5723a6b739c3c109$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $3806d7aa2c89bf6a$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


if (document.getElementsByClassName("team-section__slider")[0]) {
    const teamsSlidersArr = document.querySelectorAll(".team-section__slider");
    teamsSlidersArr.forEach((sliderEl, sliderIdx)=>{
        const slides = sliderEl.querySelectorAll(".swiper-slide");
        /*let loop = false;
    let loopedSlides = false;*/ /*if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/ let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(sliderEl.querySelector(".swiper"), {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            navigation: {
                prevEl: sliderEl.querySelector(".swiper-button-prev"),
                nextEl: sliderEl.querySelector(".swiper-button-next")
            },
            breakpoints: {
                551: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                651: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                901: {
                    spaceBetween: 16,
                    slidesPerView: 3
                },
                1025: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1100: {
                    spaceBetween: 30,
                    slidesPerView: 4
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
        function setMinWidth() {
            slides.forEach((slide)=>{
                const width = slide.style.width;
                slide.style.minWidth = width;
            });
        }
        setTimeout(function() {
            setMinWidth();
        }, 250);
        window.addEventListener("resize", setMinWidth);
    });
}




if (document.getElementsByClassName("markets-section__slider")[0]) {
    const marketsSlidersArr = document.querySelectorAll(".markets-section__slider");
    marketsSlidersArr.forEach((sliderEl, sliderIdx)=>{
        const slides = sliderEl.querySelectorAll(".swiper-slide");
        /*let loop = false;
    let loopedSlides = false;*/ /*if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/ let marketsSwiper;
        function initSwiper() {
            marketsSwiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(sliderEl, {
                modules: [
                    (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                    (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                    (0, $c951b52b1b21a8fd$export$2e2bcd8739ae039)
                ],
                slidesPerView: 1,
                spaceBetween: 20,
                threshold: 10,
                grid: {
                    rows: 3
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                navigation: {
                    prevEl: sliderEl.querySelector(".slider-buttons .slider-btn.prev"),
                    nextEl: sliderEl.querySelector(".slider-buttons .slider-btn.next")
                },
                breakpoints: {
                    591: {
                        slidesPerView: 2
                    }
                }
            });
        /*if (!sliderEl.classList.contains('init-observer')) {
        sliderEl.classList.add('init-observer');
        swiperObserver(foundationsSwiper);
      }*/ }
        function handleResize() {
            if (window.innerWidth <= 1020) initSwiper();
            else if (marketsSwiper) marketsSwiper.destroy();
        }
        initSwiper();
        handleResize();
        window.addEventListener("resize", handleResize);
    });
}




if (document.getElementsByClassName("services-section__slider")[0]) {
    const servicesSlidersArr = document.querySelectorAll(".services-section__slider");
    servicesSlidersArr.forEach((sliderEl, sliderIdx)=>{
        const pagination = sliderEl.querySelector(".swiper-pagination");
        /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/ let pauseOnMouseEnter = window.innerWidth > 1024;
        const servicesSwiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(sliderEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $790dff2f2e9fa291$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            /*loop: loop,
      loopedSlides: loopedSlides,*/ autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            navigation: {
                prevEl: sliderEl.querySelector(".slider-buttons .slider-btn.prev"),
                nextEl: sliderEl.querySelector(".slider-buttons .slider-btn.next")
            },
            breakpoints: {
                451: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                651: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                901: {
                    spaceBetween: 30,
                    slidesPerView: 3
                },
                1100: {
                    spaceBetween: 16,
                    slidesPerView: 4
                },
                1200: {
                    spaceBetween: 30,
                    slidesPerView: 4
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(servicesSwiper);
    });
}


window.choicesArray = [];
window.initChoices = function initChoices(elementsArr) {
    const choicesDOM = document.querySelector(elementsArr);
    if (choicesDOM) {
        const choicesArr = document.querySelectorAll(`${elementsArr}`);
        for(let i = 0; i < choicesArr.length; i++){
            console.log("init");
            const parentContainer = choicesArr[i].parentNode;
            /*const list = parentContainer.querySelector(".default-select__list");*/ let multiple = false;
            if (choicesArr[i].multiple && choicesArr[i].hasAttribute("multiple")) multiple = true;
            const choices = new Choices(choicesArr[i], {
                searchEnabled: false,
                itemSelectText: "",
                placeholder: true,
                searchPlaceholderValue: "Search",
                removeItems: true,
                removeItemButton: multiple,
                shouldSort: false
            });
            choicesArray.push(choices);
            const choicesMultipleElement = parentContainer.querySelector(".choices[data-type='select-multiple']");
            if (choicesMultipleElement) choicesMultipleElement.classList.add("is-multiple");
        }
    }
};
window.initChoices("[data-choices]");
window.getChoice = function getChoice1(select) {
    let selectEl = typeof select === "object" ? select : document.querySelector(select);
    let choicesArr = window.choicesArray;
    let targetChoice;
    if (choicesArr) window.choicesArray.forEach((choices)=>{
        let choicesSelect = choices.passedElement.element;
        if (choicesSelect == selectEl) targetChoice = choices;
    });
    return targetChoice;
};
window.resetChoice = function resetChoice(select) {
    let choice = getChoice(select);
    if (choice) {
        let startValue = choice.config.choices[0].value;
        choice.setChoiceByValue(startValue);
    }
};


/**
 * Function to getPosition of element in DOM
 * **/ function $0d3ea76a08c19ef7$export$1690e12b840569b9(element) {
    var xPosition = 0;
    var yPosition = 0;
    while(element){
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }
    return {
        x: xPosition,
        y: yPosition
    };
}
function $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element, classname) {
    if (element.className.split(" ").indexOf(classname) >= 0) return true;
    return element.parentNode && $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element.parentNode, classname);
}
function $0d3ea76a08c19ef7$export$ff7f7c97cdce86e(arr, needle) {
    return arr.reduce((a, b)=>{
        return Math.abs(b - needle) < Math.abs(a - needle) ? b : a;
    });
}
const $0d3ea76a08c19ef7$export$ef7b59bbfcfa5534 = (defaultValue, callback, callAfterInit = false)=>{
    const proxyHandler = {
        set (obj, prop, value) {
            if (prop === "value") {
                obj[prop] = value;
                callback(value);
                return true;
            }
            return true;
        }
    };
    if (callAfterInit) callback(defaultValue);
    return new Proxy({
        value: defaultValue
    }, proxyHandler);
};


const $a502e768f184a449$export$7d21786059c86dc = ({ sidebar: sidebar, contentSticky: contentSticky, sidebarInnerSelector: sidebarInnerSelector = ".following-sidebar-inner", isHeaderCalc: // calc header height for top side gap
isHeaderCalc = false, gap: // gap on top and bottom of sticky sidebar
gap = 30 })=>{
    console.log(sidebar);
    const sidebarInner = sidebar.querySelector(sidebarInnerSelector);
    const sidebarBuffer = document.createElement("DIV");
    sidebarBuffer.classList.add("following-sidebar-buffer");
    sidebarInner.style.position = "sticky";
    const header = document.querySelector("header");
    sidebar.insertAdjacentElement("afterbegin", sidebarBuffer);
    const headerHeight = isHeaderCalc && header ? header.offsetHeight : 0;
    let lastScrollTop = 0;
    // if flag true === scrolling down else scrolling up
    let isScrollingDown = null;
    // if isSidebarHigherViewport true === sidebar is higher than viewport height
    let isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    function calcHeightOfSidebar(isScrollingDown) {
        const contentStickyTop = (0, $0d3ea76a08c19ef7$export$1690e12b840569b9)(contentSticky).y;
        const sidebarInnerTop = (0, $0d3ea76a08c19ef7$export$1690e12b840569b9)(sidebarInner).y;
        sidebarBuffer.style.height = `${sidebarInnerTop - contentStickyTop}px`;
        if (isScrollingDown) {
            // scroll down
            sidebarInner.style.top = "";
            sidebarInner.style.bottom = `${-headerHeight - gap + window.innerHeight - sidebarInner.getBoundingClientRect().height}px`;
        } else {
            // scroll up
            sidebarInner.style.bottom = "";
            sidebarInner.style.top = `${Math.min(window.innerHeight - sidebarInner.getBoundingClientRect().height, headerHeight) - gap}px`;
        }
        isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    }
    function resetSticky() {
        sidebarInner.style.bottom = "";
        sidebarInner.style.top = `${headerHeight + gap}px`;
        sidebarBuffer.style.height = "0";
    }
    if (!isSidebarHigherViewport) resetSticky();
    else calcHeightOfSidebar(false);
    window.addEventListener("scroll", function() {
        let st = window.scrollY || document.documentElement.scrollTop;
        if (!isSidebarHigherViewport) resetSticky();
        if (st > lastScrollTop && !isScrollingDown) {
            // scroll down
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = true;
        } else if (st < lastScrollTop && isScrollingDown) {
            // scroll up
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = false;
        }
        lastScrollTop = st <= 0 ? 0 : st;
    });
    const updateSidebar = ()=>{
        if (!isSidebarHigherViewport) resetSticky();
        calcHeightOfSidebar(true);
        calcHeightOfSidebar(false);
    };
    let windowWidth = window.innerWidth;
    window.addEventListener("resize", ()=>{
        if (windowWidth !== window.innerWidth) {
            windowWidth = window.innerWidth;
            updateSidebar();
        }
    });
};


if (document.querySelector(".job-search-section")) {
    const sidebar = document.querySelector("#sidebar");
    const contentSticky = document.querySelector("#content-sticky");
    const filtersBtn = document.querySelector(".filters-btn");
    const btnClose = sidebar.querySelector(".job-search-section__sidebar .btn-close");
    const contentResult = document.querySelector(".job-search-section__result-bg");
    const sidebarItemsArr = document.querySelectorAll(".job-search-section__sidebar-item.with-accordion");
    sidebarItemsArr.forEach((item, i)=>{
        item.addEventListener("click", ()=>{
            item.classList.toggle("active");
        });
    });
    if (sidebar && window.innerWidth >= 640) (0, $a502e768f184a449$export$7d21786059c86dc)({
        sidebar: sidebar,
        contentSticky: contentSticky
    });
    if (filtersBtn) {
        filtersBtn.addEventListener("click", ()=>{
            filtersBtn.classList.toggle("active");
            contentSticky.classList.toggle("active");
            contentResult.classList.toggle("active");
        });
        contentResult.addEventListener("click", ()=>{
            if (contentResult.classList.contains("active")) {
                filtersBtn.classList.remove("active");
                contentSticky.classList.remove("active");
                contentResult.classList.remove("active");
            }
        });
        btnClose.addEventListener("click", (e)=>{
            if (contentResult.classList.contains("active")) {
                e.preventDefault();
                filtersBtn.classList.remove("active");
                contentSticky.classList.remove("active");
                contentResult.classList.remove("active");
            }
        });
    }
}
const $feb91ca644b68c12$var$btnShowHideArr = document.querySelectorAll(".btn-show-hide");
const $feb91ca644b68c12$var$showHideContentArr = document.querySelectorAll(".show-hide-content");
function $feb91ca644b68c12$var$itemCalcMaxHeight(item, content) {
    const children = Array.from(content.children);
    const totalHeight = children.reduce((acc, child)=>{
        const childHeight = child.offsetHeight;
        return acc + childHeight;
    }, 0);
    return totalHeight + 100;
}
$feb91ca644b68c12$var$showHideContentArr.forEach((content, i)=>{
    const items = content.querySelectorAll(".meta-checkbox");
    console.log(items);
    const maxVisibleItems = content.dataset.visible ? parseInt(content.dataset.visible) : 6;
    console.log(maxVisibleItems);
    items.forEach((item, index)=>{
        if (index > maxVisibleItems - 1) item.classList.add("is-hidden");
    });
    if (items.length > maxVisibleItems) {
        const btnShowHide = $feb91ca644b68c12$var$btnShowHideArr[i];
        btnShowHide.classList.add("is-visible");
        btnShowHide.addEventListener("click", ()=>{
            btnShowHide.classList.toggle("active");
            items.forEach((item, index)=>{
                if (index > maxVisibleItems - 1) item.classList.toggle("is-hidden");
            });
            content.parentElement.style.maxHeight = `${$feb91ca644b68c12$var$itemCalcMaxHeight(content.parentElement.parentElement, content.parentElement)}px`;
        });
    }
});
if (document.getElementsByClassName("job-search-section__sidebar-accordion")[0]) {
    const jobsAccordionArr = document.querySelectorAll(".job-search-section__sidebar-accordion");
    jobsAccordionArr.forEach((jobsAccordion)=>{
        const jobsItemsArr = jobsAccordion.querySelectorAll(".job-search-section__sidebar-accordion-item");
        jobsItemsArr.forEach((item, i)=>{
            const btn = item.querySelector(".job-search-section__sidebar-accordion-item-top");
            const content = item.querySelector(".job-search-section__sidebar-accordion-item-content");
            /*item.addEventListener('click', (event) => {
        if (event.target !== btn) {
          openAccordion(item);
        } else if (event.target === btn && item.classList.contains('active')) {
          item.classList.remove('active');
        } else {
          openAccordion(item);
        }
      });*/ btn.addEventListener("click", ()=>{
                if (item.classList.contains("active")) item.classList.remove("active");
                else openAccordion(item);
            });
            function openAccordion(item) {
                // for (let j = 0; j < jobsItemsArr.length; j++) {
                //   jobsItemsArr[j].classList.remove('active');
                // }
                item.classList.add("active");
                content.style.maxHeight = `${$feb91ca644b68c12$var$itemCalcMaxHeight(item, content)}px`;
            }
        });
    });
}


const $14f9e779c354fabb$var$portalComponent = document.querySelector(".profile");
if ($14f9e779c354fabb$var$portalComponent) {
    const portalContainer = $14f9e779c354fabb$var$portalComponent.querySelector(".profile__wrap");
    const portalMenuBtn = $14f9e779c354fabb$var$portalComponent.querySelector(".profile__filters-btn");
    portalMenuBtn.addEventListener("click", ()=>{
        if (!portalMenuBtn.classList.contains("active")) {
            portalMenuBtn.classList.add("active");
            portalContainer.classList.add("active");
        } else {
            portalMenuBtn.classList.remove("active");
            portalContainer.classList.remove("active");
        }
    });
}


document.querySelectorAll(".login-section__input-icon").forEach((icon)=>{
    icon.addEventListener("click", ()=>{
        const input = icon.previousElementSibling;
        if (input.type === "password") {
            icon.classList.add("opacity-50");
            input.type = "text";
        } else {
            icon.classList.remove("opacity-50");
            input.type = "password";
        }
    });
});




let $3e9cc4bc96346159$var$clientsSaySwiperWr = document.querySelectorAll(".bulettins-slider-swiper-wr");
$3e9cc4bc96346159$var$clientsSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector(".swiper-button-next");
        let prevEl = parentEl.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $790dff2f2e9fa291$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 10,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                formatFractionCurrent: function(number) {
                    return number;
                },
                formatFractionTotal: function(number) {
                    return number;
                }
            }
        });
    /*swiperObserver(swiper);*/ }
});




let $f1a79f105d95c524$var$clientsSwiperWr = document.querySelectorAll(".clients-swiper-wr");
$f1a79f105d95c524$var$clientsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $c951b52b1b21a8fd$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 2,
            spaceBetween: 16,
            grid: {
                rows: 2
            },
            threshold: 10,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                421: {
                    slidesPerView: 2,
                    spaceBetween: 18,
                    grid: {
                        rows: 2
                    }
                },
                652: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    grid: {
                        rows: 2
                    }
                },
                902: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    grid: {
                        rows: 2
                    }
                },
                1100: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    grid: {
                        rows: 2
                    }
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $39f7aeb1b65b34f6$var$clientsSaySwiperWr = document.querySelectorAll(".clients-say-swiper-wr");
$39f7aeb1b65b34f6$var$clientsSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let parentEl = el.parentElement;
        let nextEls = Array.from(el.querySelectorAll(".swiper-button-next"));
        let prevEls = Array.from(el.querySelectorAll(".swiper-button-prev"));
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEls,
                prevEl: prevEls
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 1
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 1
                },
                1200: {
                    spaceBetween: 20,
                    slidesPerView: 1
                }
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
    /*swiperObserver(swiper);*/ }
});






const $9cb5cf8bde55ff38$export$f16e6af5a274aa5b = (breakpoint, swiperClass, swiperSettings, startOnView)=>{
    let swiper;
    breakpoint = window.matchMedia(breakpoint);
    const enableSwiper = function(className, settings) {
        swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(className, settings);
        if (startOnView) (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    };
    const checker = function() {
        if (breakpoint.matches) return enableSwiper(swiperClass, swiperSettings);
        else {
            if (swiper !== undefined) swiper.destroy(true, true);
            return;
        }
    };
    breakpoint.addEventListener("change", checker);
    checker();
};


let $ac9626c11281bd15$var$trustedSwiperWr = document.querySelectorAll(".trusted-swiper-wr");
$ac9626c11281bd15$var$trustedSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        if (!el.classList.contains("trusted-section__slider-second")) (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 951px)", swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 12,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                500: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 20
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
        else {
            let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
                modules: [
                    (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                    (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
                ],
                slidesPerView: 1,
                spaceBetween: 20,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 3.1
                    }
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                }
            });
        }
    }
});




let $0bb1de3c5e11b6a5$var$clientsSaySwiperWr = document.querySelectorAll(".case-studies-swiper-wr");
$0bb1de3c5e11b6a5$var$clientsSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector(".swiper-button-next");
        let prevEl = parentEl.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $790dff2f2e9fa291$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            // spaceBetween: 10,
            slidesPerView: 1,
            threshold: 10,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                formatFractionCurrent: function(number) {
                    return number;
                },
                formatFractionTotal: function(number) {
                    return number;
                }
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
    /*swiperObserver(swiper);*/ }
});




let $5ea65a41decd7223$var$trustedSwiperWr = document.querySelectorAll(".our-values-swiper-wr");
$5ea65a41decd7223$var$trustedSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 992px)", swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 12,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                // >=
                500: {
                    slidesPerView: 1.8
                },
                768: {
                    slidesPerView: 2
                },
                820: {
                    slidesPerView: 2.5
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
    }
});




let $7bcdb672b89e4712$var$clientsSaySwiperWr = document.querySelectorAll(".gallery-swiper-wr");
$7bcdb672b89e4712$var$clientsSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector(".swiper-button-next");
        let prevEl = parentEl.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let reverse = swiperEl.getAttribute("data-reverseDirection") === "true";
        console.log(reverse);
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039)
            ],
            spaceBetween: 20,
            slidesPerView: "auto",
            centeredSlides: true,
            loop: slidesCount > 2,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                reverseDirection: reverse
            },
            breakpoints: {
                768: {
                    spaceBetween: 30,
                    centeredSlides: false
                }
            }
        });
    }
});



let $b0077e9adbcd7cda$var$clientsSaySwiperWr = document.querySelectorAll(".logos-swiper-wr");
$b0077e9adbcd7cda$var$clientsSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let parentEl = el.parentElement;
        let nextEl = parentEl.querySelector(".swiper-button-next");
        let prevEl = parentEl.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039)
            ],
            spaceBetween: 12,
            slidesPerView: 1.75,
            loop: slidesCount > 2,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                500: {
                    slidesPerView: 2.2
                },
                700: {
                    slidesPerView: "auto"
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: "auto"
                }
            }
        });
    }
});




let $57fa783e5aeb100c$var$historySwiperWr = document.querySelectorAll(".history-swiper-wr");
$57fa783e5aeb100c$var$historySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039),
                (0, $122c57004122847f$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            speed: 800,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            effect: "creative",
            creativeEffect: {
                limitProgress: 3,
                prev: {
                    translate: [
                        0,
                        0,
                        -320
                    ],
                    opacity: 0,
                    effect: "scale",
                    scale: 0.6
                },
                next: {
                    /*translate: ['calc(100% - 20px)', 0, 0],*/ translate: [
                        "calc(45% + 20px)",
                        0,
                        0
                    ],
                    opacity: 1,
                    effect: "scale",
                    scale: 0.8
                }
            },
            breakpoints: {
                851: {
                    creativeEffect: {
                        limitProgress: 3,
                        prev: {
                            translate: [
                                0,
                                0,
                                -320
                            ],
                            opacity: 0,
                            effect: "scale",
                            scale: 0.6
                        },
                        next: {
                            /*translate: ['calc(100% - 20px)', 0, 0],*/ translate: [
                                "calc(60% + 20px)",
                                0,
                                0
                            ],
                            opacity: 1,
                            effect: "scale",
                            scale: 0.8
                        }
                    }
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            }
        });
    /*swiperObserver(swiper);*/ }
});




let $bf8e075137fcacfb$var$jobsSwiperWr = document.querySelectorAll(".jobs-swiper-wr");
$bf8e075137fcacfb$var$jobsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $c7744d2fb3eefccf$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $09ecf76cc200f66c$export$2e2bcd8739ae039),
                (0, $4d479dbb1d20a353$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 12,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2.5
                },
                951: {
                    spaceBetween: 20,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
}); /*function setBottomHeight() {
  if (document.getElementsByClassName('job-card')[0]) {
    const jobsCardsArr = document.querySelectorAll('.job-card');

    jobsCardsArr.forEach((card) => {
      const bottomEl = card.querySelector('.job-card__bottom');

      const bottomElHeight = bottomEl.clientHeight - 5;

      card.style.setProperty('--bottom-height', `${bottomElHeight}px`);
    });
  }
}*/  /*window.addEventListener('load', setBottomHeight);
window.addEventListener('resize', setBottomHeight);*/ 


/*!
 * OverlayScrollbars
 * Version: 2.10.0
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ const $2cd21d6115f08437$var$createCache = (t, n)=>{
    const { o: o, i: s, u: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const l = t;
        const i = n || (s ? !s(o, l) : o !== l);
        if (i || e) {
            c = l;
            r = o;
        }
        return [
            c,
            i,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $2cd21d6115f08437$var$t = typeof window !== "undefined" && typeof HTMLElement !== "undefined" && !!window.document;
const $2cd21d6115f08437$var$n = $2cd21d6115f08437$var$t ? window : {};
const $2cd21d6115f08437$var$o = Math.max;
const $2cd21d6115f08437$var$s = Math.min;
const $2cd21d6115f08437$var$e = Math.round;
const $2cd21d6115f08437$var$c = Math.abs;
const $2cd21d6115f08437$var$r = Math.sign;
const $2cd21d6115f08437$var$l = $2cd21d6115f08437$var$n.cancelAnimationFrame;
const $2cd21d6115f08437$var$i = $2cd21d6115f08437$var$n.requestAnimationFrame;
const $2cd21d6115f08437$var$a = $2cd21d6115f08437$var$n.setTimeout;
const $2cd21d6115f08437$var$u = $2cd21d6115f08437$var$n.clearTimeout;
const $2cd21d6115f08437$var$getApi = (t)=>typeof $2cd21d6115f08437$var$n[t] !== "undefined" ? $2cd21d6115f08437$var$n[t] : void 0;
const $2cd21d6115f08437$var$_ = $2cd21d6115f08437$var$getApi("MutationObserver");
const $2cd21d6115f08437$var$d = $2cd21d6115f08437$var$getApi("IntersectionObserver");
const $2cd21d6115f08437$var$f = $2cd21d6115f08437$var$getApi("ResizeObserver");
const $2cd21d6115f08437$var$v = $2cd21d6115f08437$var$getApi("ScrollTimeline");
const $2cd21d6115f08437$var$isUndefined = (t)=>t === void 0;
const $2cd21d6115f08437$var$isNull = (t)=>t === null;
const $2cd21d6115f08437$var$isNumber = (t)=>typeof t === "number";
const $2cd21d6115f08437$var$isString = (t)=>typeof t === "string";
const $2cd21d6115f08437$var$isBoolean = (t)=>typeof t === "boolean";
const $2cd21d6115f08437$var$isFunction = (t)=>typeof t === "function";
const $2cd21d6115f08437$var$isArray = (t)=>Array.isArray(t);
const $2cd21d6115f08437$var$isObject = (t)=>typeof t === "object" && !$2cd21d6115f08437$var$isArray(t) && !$2cd21d6115f08437$var$isNull(t);
const $2cd21d6115f08437$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $2cd21d6115f08437$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $2cd21d6115f08437$var$isArray(t) || !$2cd21d6115f08437$var$isFunction(t) && o ? n > 0 && $2cd21d6115f08437$var$isObject(t) ? n - 1 in t : true : false;
};
const $2cd21d6115f08437$var$isPlainObject = (t)=>!!t && t.constructor === Object;
const $2cd21d6115f08437$var$isHTMLElement = (t)=>t instanceof HTMLElement;
const $2cd21d6115f08437$var$isElement = (t)=>t instanceof Element;
const $2cd21d6115f08437$var$animationCurrentTime = ()=>performance.now();
const $2cd21d6115f08437$var$animateNumber = (t, n, s, e, c)=>{
    let r = 0;
    const a = $2cd21d6115f08437$var$animationCurrentTime();
    const u = $2cd21d6115f08437$var$o(0, s);
    const frame = (s)=>{
        const l = $2cd21d6115f08437$var$animationCurrentTime();
        const _ = l - a;
        const d = _ >= u;
        const f = s ? 1 : 1 - ($2cd21d6115f08437$var$o(0, a + u - l) / u || 0);
        const v = (n - t) * ($2cd21d6115f08437$var$isFunction(c) ? c(f, f * u, 0, 1, u) : f) + t;
        const p = d || f === 1;
        e && e(v, f, p);
        r = p ? 0 : $2cd21d6115f08437$var$i(()=>frame());
    };
    frame();
    return (t)=>{
        $2cd21d6115f08437$var$l(r);
        t && frame(t);
    };
};
function $2cd21d6115f08437$var$each(t, n) {
    if ($2cd21d6115f08437$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (n(t[o], o, t) === false) break;
    }
    else if (t) $2cd21d6115f08437$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
const $2cd21d6115f08437$var$inArray = (t, n)=>t.indexOf(n) >= 0;
const $2cd21d6115f08437$var$concat = (t, n)=>t.concat(n);
const $2cd21d6115f08437$var$push = (t, n, o)=>{
    !o && !$2cd21d6115f08437$var$isString(n) && $2cd21d6115f08437$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $2cd21d6115f08437$var$from = (t)=>Array.from(t || []);
const $2cd21d6115f08437$var$createOrKeepArray = (t)=>{
    if ($2cd21d6115f08437$var$isArray(t)) return t;
    return !$2cd21d6115f08437$var$isString(t) && $2cd21d6115f08437$var$isArrayLike(t) ? $2cd21d6115f08437$var$from(t) : [
        t
    ];
};
const $2cd21d6115f08437$var$isEmptyArray = (t)=>!!t && !t.length;
const $2cd21d6115f08437$var$deduplicateArray = (t)=>$2cd21d6115f08437$var$from(new Set(t));
const $2cd21d6115f08437$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t ? t.apply(void 0, n || []) : true;
    $2cd21d6115f08437$var$each(t, runFn);
    !o && (t.length = 0);
};
const $2cd21d6115f08437$var$p = "paddingTop";
const $2cd21d6115f08437$var$h = "paddingRight";
const $2cd21d6115f08437$var$g = "paddingLeft";
const $2cd21d6115f08437$var$b = "paddingBottom";
const $2cd21d6115f08437$var$w = "marginLeft";
const $2cd21d6115f08437$var$y = "marginRight";
const $2cd21d6115f08437$var$S = "marginBottom";
const $2cd21d6115f08437$var$m = "overflowX";
const $2cd21d6115f08437$var$O = "overflowY";
const $2cd21d6115f08437$var$$ = "width";
const $2cd21d6115f08437$var$C = "height";
const $2cd21d6115f08437$var$x = "visible";
const $2cd21d6115f08437$var$H = "hidden";
const $2cd21d6115f08437$var$E = "scroll";
const $2cd21d6115f08437$var$capitalizeFirstLetter = (t)=>{
    const n = String(t || "");
    return n ? n[0].toUpperCase() + n.slice(1) : "";
};
const $2cd21d6115f08437$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $2cd21d6115f08437$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $2cd21d6115f08437$var$equalWH = (t, n)=>$2cd21d6115f08437$var$equal(t, n, [
        "w",
        "h"
    ]);
const $2cd21d6115f08437$var$equalXY = (t, n)=>$2cd21d6115f08437$var$equal(t, n, [
        "x",
        "y"
    ]);
const $2cd21d6115f08437$var$equalTRBL = (t, n)=>$2cd21d6115f08437$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $2cd21d6115f08437$var$noop = ()=>{};
const $2cd21d6115f08437$var$bind = (t, ...n)=>t.bind(0, ...n);
const $2cd21d6115f08437$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $2cd21d6115f08437$var$a : $2cd21d6115f08437$var$i;
    const s = t ? $2cd21d6115f08437$var$u : $2cd21d6115f08437$var$l;
    return [
        (e)=>{
            s(n);
            n = o(()=>e(), $2cd21d6115f08437$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $2cd21d6115f08437$var$debounce = (t, n)=>{
    const { _: o, v: s, p: e, S: c } = n || {};
    let r;
    let _;
    let d;
    let f;
    let v = $2cd21d6115f08437$var$noop;
    const p = function invokeFunctionToDebounce(n) {
        v();
        $2cd21d6115f08437$var$u(r);
        f = r = _ = void 0;
        v = $2cd21d6115f08437$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>c && _ ? c(_, t) : t;
    const flush = ()=>{
        if (v !== $2cd21d6115f08437$var$noop) p(mergeParms(d) || d);
    };
    const h = function debouncedFn() {
        const t = $2cd21d6115f08437$var$from(arguments);
        const n = $2cd21d6115f08437$var$isFunction(o) ? o() : o;
        const c = $2cd21d6115f08437$var$isNumber(n) && n >= 0;
        if (c) {
            const o = $2cd21d6115f08437$var$isFunction(s) ? s() : s;
            const c = $2cd21d6115f08437$var$isNumber(o) && o >= 0;
            const h = n > 0 ? $2cd21d6115f08437$var$a : $2cd21d6115f08437$var$i;
            const g = n > 0 ? $2cd21d6115f08437$var$u : $2cd21d6115f08437$var$l;
            const b = mergeParms(t);
            const w = b || t;
            const y = p.bind(0, w);
            let S;
            v();
            if (e && !f) {
                y();
                f = true;
                S = h(()=>f = void 0, n);
            } else {
                S = h(y, n);
                if (c && !r) r = $2cd21d6115f08437$var$a(flush, o);
            }
            v = ()=>g(S);
            _ = d = w;
        } else p(t);
    };
    h.m = flush;
    return h;
};
const $2cd21d6115f08437$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $2cd21d6115f08437$var$keys = (t)=>t ? Object.keys(t) : [];
const $2cd21d6115f08437$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const l = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if ((typeof t !== "object" || $2cd21d6115f08437$var$isNull(t)) && !$2cd21d6115f08437$var$isFunction(t)) t = {};
    $2cd21d6115f08437$var$each(l, (n)=>{
        $2cd21d6115f08437$var$each(n, (o, s)=>{
            const e = n[s];
            if (t === e) return true;
            const c = $2cd21d6115f08437$var$isArray(e);
            if (e && $2cd21d6115f08437$var$isPlainObject(e)) {
                const n = t[s];
                let o = n;
                if (c && !$2cd21d6115f08437$var$isArray(n)) o = [];
                else if (!c && !$2cd21d6115f08437$var$isPlainObject(n)) o = {};
                t[s] = $2cd21d6115f08437$var$assignDeep(o, e);
            } else t[s] = c ? e.slice() : e;
        });
    });
    return t;
};
const $2cd21d6115f08437$var$removeUndefinedProperties = (t, n)=>$2cd21d6115f08437$var$each($2cd21d6115f08437$var$assignDeep({}, t), (t, o, s)=>{
        if (t === void 0) delete s[o];
        else if (n && t && $2cd21d6115f08437$var$isPlainObject(t)) s[o] = $2cd21d6115f08437$var$removeUndefinedProperties(t, n);
    });
const $2cd21d6115f08437$var$isEmptyObject = (t)=>!$2cd21d6115f08437$var$keys(t).length;
const $2cd21d6115f08437$var$capNumber = (t, n, e)=>$2cd21d6115f08437$var$o(t, $2cd21d6115f08437$var$s(n, e));
const $2cd21d6115f08437$var$getDomTokensArray = (t)=>$2cd21d6115f08437$var$deduplicateArray(($2cd21d6115f08437$var$isArray(t) ? t : (t || "").split(" ")).filter((t)=>t));
const $2cd21d6115f08437$var$getAttr = (t, n)=>t && t.getAttribute(n);
const $2cd21d6115f08437$var$hasAttr = (t, n)=>t && t.hasAttribute(n);
const $2cd21d6115f08437$var$setAttrs = (t, n, o)=>{
    $2cd21d6115f08437$var$each($2cd21d6115f08437$var$getDomTokensArray(n), (n)=>{
        t && t.setAttribute(n, String(o || ""));
    });
};
const $2cd21d6115f08437$var$removeAttrs = (t, n)=>{
    $2cd21d6115f08437$var$each($2cd21d6115f08437$var$getDomTokensArray(n), (n)=>t && t.removeAttribute(n));
};
const $2cd21d6115f08437$var$domTokenListAttr = (t, n)=>{
    const o = $2cd21d6115f08437$var$getDomTokensArray($2cd21d6115f08437$var$getAttr(t, n));
    const s = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$setAttrs, t, n);
    const domTokenListOperation = (t, n)=>{
        const s = new Set(o);
        $2cd21d6115f08437$var$each($2cd21d6115f08437$var$getDomTokensArray(t), (t)=>{
            s[n](t);
        });
        return $2cd21d6115f08437$var$from(s).join(" ");
    };
    return {
        O: (t)=>s(domTokenListOperation(t, "delete")),
        $: (t)=>s(domTokenListOperation(t, "add")),
        C: (t)=>{
            const n = $2cd21d6115f08437$var$getDomTokensArray(t);
            return n.reduce((t, n)=>t && o.includes(n), n.length > 0);
        }
    };
};
const $2cd21d6115f08437$var$removeAttrClass = (t, n, o)=>{
    $2cd21d6115f08437$var$domTokenListAttr(t, n).O(o);
    return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$addAttrClass, t, n, o);
};
const $2cd21d6115f08437$var$addAttrClass = (t, n, o)=>{
    $2cd21d6115f08437$var$domTokenListAttr(t, n).$(o);
    return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeAttrClass, t, n, o);
};
const $2cd21d6115f08437$var$addRemoveAttrClass = (t, n, o, s)=>(s ? $2cd21d6115f08437$var$addAttrClass : $2cd21d6115f08437$var$removeAttrClass)(t, n, o);
const $2cd21d6115f08437$var$hasAttrClass = (t, n, o)=>$2cd21d6115f08437$var$domTokenListAttr(t, n).C(o);
const $2cd21d6115f08437$var$createDomTokenListClass = (t)=>$2cd21d6115f08437$var$domTokenListAttr(t, "class");
const $2cd21d6115f08437$var$removeClass = (t, n)=>{
    $2cd21d6115f08437$var$createDomTokenListClass(t).O(n);
};
const $2cd21d6115f08437$var$addClass = (t, n)=>{
    $2cd21d6115f08437$var$createDomTokenListClass(t).$(n);
    return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeClass, t, n);
};
const $2cd21d6115f08437$var$find = (t, n)=>{
    const o = n ? $2cd21d6115f08437$var$isElement(n) && n : document;
    return o ? $2cd21d6115f08437$var$from(o.querySelectorAll(t)) : [];
};
const $2cd21d6115f08437$var$findFirst = (t, n)=>{
    const o = n ? $2cd21d6115f08437$var$isElement(n) && n : document;
    return o && o.querySelector(t);
};
const $2cd21d6115f08437$var$is = (t, n)=>$2cd21d6115f08437$var$isElement(t) && t.matches(n);
const $2cd21d6115f08437$var$isBodyElement = (t)=>$2cd21d6115f08437$var$is(t, "body");
const $2cd21d6115f08437$var$contents = (t)=>t ? $2cd21d6115f08437$var$from(t.childNodes) : [];
const $2cd21d6115f08437$var$parent = (t)=>t && t.parentElement;
const $2cd21d6115f08437$var$closest = (t, n)=>$2cd21d6115f08437$var$isElement(t) && t.closest(n);
const $2cd21d6115f08437$var$getFocusedElement = (t)=>(t || document).activeElement;
const $2cd21d6115f08437$var$liesBetween = (t, n, o)=>{
    const s = $2cd21d6115f08437$var$closest(t, n);
    const e = t && $2cd21d6115f08437$var$findFirst(o, s);
    const c = $2cd21d6115f08437$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $2cd21d6115f08437$var$closest($2cd21d6115f08437$var$closest(t, o), n) !== s : false;
};
const $2cd21d6115f08437$var$removeElements = (t)=>{
    $2cd21d6115f08437$var$each($2cd21d6115f08437$var$createOrKeepArray(t), (t)=>{
        const n = $2cd21d6115f08437$var$parent(t);
        t && n && n.removeChild(t);
    });
};
const $2cd21d6115f08437$var$appendChildren = (t, n)=>$2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeElements, t && n && $2cd21d6115f08437$var$each($2cd21d6115f08437$var$createOrKeepArray(n), (n)=>{
        n && t.appendChild(n);
    }));
const $2cd21d6115f08437$var$createDiv = (t)=>{
    const n = document.createElement("div");
    $2cd21d6115f08437$var$setAttrs(n, "class", t);
    return n;
};
const $2cd21d6115f08437$var$createDOM = (t)=>{
    const n = $2cd21d6115f08437$var$createDiv();
    n.innerHTML = t.trim();
    return $2cd21d6115f08437$var$each($2cd21d6115f08437$var$contents(n), (t)=>$2cd21d6115f08437$var$removeElements(t));
};
const $2cd21d6115f08437$var$getCSSVal = (t, n)=>t.getPropertyValue(n) || t[n] || "";
const $2cd21d6115f08437$var$validFiniteNumber = (t)=>{
    const n = t || 0;
    return isFinite(n) ? n : 0;
};
const $2cd21d6115f08437$var$parseToZeroOrNumber = (t)=>$2cd21d6115f08437$var$validFiniteNumber(parseFloat(t || ""));
const $2cd21d6115f08437$var$roundCssNumber = (t)=>Math.round(t * 1e4) / 1e4;
const $2cd21d6115f08437$var$numberToCssPx = (t)=>`${$2cd21d6115f08437$var$roundCssNumber($2cd21d6115f08437$var$validFiniteNumber(t))}px`;
function $2cd21d6115f08437$var$setStyles(t, n) {
    t && n && $2cd21d6115f08437$var$each(n, (n, o)=>{
        try {
            const s = t.style;
            const e = $2cd21d6115f08437$var$isNull(n) || $2cd21d6115f08437$var$isBoolean(n) ? "" : $2cd21d6115f08437$var$isNumber(n) ? $2cd21d6115f08437$var$numberToCssPx(n) : n;
            if (o.indexOf("--") === 0) s.setProperty(o, e);
            else s[o] = e;
        } catch (s) {}
    });
}
function $2cd21d6115f08437$var$getStyles(t, o, s) {
    const e = $2cd21d6115f08437$var$isString(o);
    let c = e ? "" : {};
    if (t) {
        const r = $2cd21d6115f08437$var$n.getComputedStyle(t, s) || t.style;
        c = e ? $2cd21d6115f08437$var$getCSSVal(r, o) : $2cd21d6115f08437$var$from(o).reduce((t, n)=>{
            t[n] = $2cd21d6115f08437$var$getCSSVal(r, n);
            return t;
        }, c);
    }
    return c;
}
const $2cd21d6115f08437$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const l = `${s}bottom${e}`;
    const i = `${s}left${e}`;
    const a = $2cd21d6115f08437$var$getStyles(t, [
        c,
        r,
        l,
        i
    ]);
    return {
        t: $2cd21d6115f08437$var$parseToZeroOrNumber(a[c]),
        r: $2cd21d6115f08437$var$parseToZeroOrNumber(a[r]),
        b: $2cd21d6115f08437$var$parseToZeroOrNumber(a[l]),
        l: $2cd21d6115f08437$var$parseToZeroOrNumber(a[i])
    };
};
const $2cd21d6115f08437$var$getTrasformTranslateValue = (t, n)=>`translate${$2cd21d6115f08437$var$isObject(t) ? `(${t.x},${t.y})` : `${n ? "X" : "Y"}(${t})`}`;
const $2cd21d6115f08437$var$elementHasDimensions = (t)=>!!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
const $2cd21d6115f08437$var$z = {
    w: 0,
    h: 0
};
const $2cd21d6115f08437$var$getElmWidthHeightProperty = (t, n)=>n ? {
        w: n[`${t}Width`],
        h: n[`${t}Height`]
    } : $2cd21d6115f08437$var$z;
const $2cd21d6115f08437$var$getWindowSize = (t)=>$2cd21d6115f08437$var$getElmWidthHeightProperty("inner", t || $2cd21d6115f08437$var$n);
const $2cd21d6115f08437$var$I = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getElmWidthHeightProperty, "offset");
const $2cd21d6115f08437$var$A = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getElmWidthHeightProperty, "client");
const $2cd21d6115f08437$var$D = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getElmWidthHeightProperty, "scroll");
const $2cd21d6115f08437$var$getFractionalSize = (t)=>{
    const n = parseFloat($2cd21d6115f08437$var$getStyles(t, $2cd21d6115f08437$var$$)) || 0;
    const o = parseFloat($2cd21d6115f08437$var$getStyles(t, $2cd21d6115f08437$var$C)) || 0;
    return {
        w: n - $2cd21d6115f08437$var$e(n),
        h: o - $2cd21d6115f08437$var$e(o)
    };
};
const $2cd21d6115f08437$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
const $2cd21d6115f08437$var$hasDimensions = (t)=>!!t && $2cd21d6115f08437$var$elementHasDimensions(t);
const $2cd21d6115f08437$var$domRectHasDimensions = (t)=>!!(t && (t[$2cd21d6115f08437$var$C] || t[$2cd21d6115f08437$var$$]));
const $2cd21d6115f08437$var$domRectAppeared = (t, n)=>{
    const o = $2cd21d6115f08437$var$domRectHasDimensions(t);
    const s = $2cd21d6115f08437$var$domRectHasDimensions(n);
    return !s && o;
};
const $2cd21d6115f08437$var$removeEventListener = (t, n, o, s)=>{
    $2cd21d6115f08437$var$each($2cd21d6115f08437$var$getDomTokensArray(n), (n)=>{
        t && t.removeEventListener(n, o, s);
    });
};
const $2cd21d6115f08437$var$addEventListener = (t, n, o, s)=>{
    var e;
    const c = (e = s && s.H) != null ? e : true;
    const r = s && s.I || false;
    const l = s && s.A || false;
    const i = {
        passive: c,
        capture: r
    };
    return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, $2cd21d6115f08437$var$getDomTokensArray(n).map((n)=>{
        const s = l ? (e)=>{
            $2cd21d6115f08437$var$removeEventListener(t, n, s, r);
            o && o(e);
        } : o;
        t && t.addEventListener(n, s, i);
        return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeEventListener, t, n, s, r);
    }));
};
const $2cd21d6115f08437$var$stopPropagation = (t)=>t.stopPropagation();
const $2cd21d6115f08437$var$preventDefault = (t)=>t.preventDefault();
const $2cd21d6115f08437$var$stopAndPrevent = (t)=>$2cd21d6115f08437$var$stopPropagation(t) || $2cd21d6115f08437$var$preventDefault(t);
const $2cd21d6115f08437$var$scrollElementTo = (t, n)=>{
    const { x: o, y: s } = $2cd21d6115f08437$var$isNumber(n) ? {
        x: n,
        y: n
    } : n || {};
    $2cd21d6115f08437$var$isNumber(o) && (t.scrollLeft = o);
    $2cd21d6115f08437$var$isNumber(s) && (t.scrollTop = s);
};
const $2cd21d6115f08437$var$getElementScroll = (t)=>({
        x: t.scrollLeft,
        y: t.scrollTop
    });
const $2cd21d6115f08437$var$getZeroScrollCoordinates = ()=>({
        D: {
            x: 0,
            y: 0
        },
        M: {
            x: 0,
            y: 0
        }
    });
const $2cd21d6115f08437$var$sanitizeScrollCoordinates = (t, n)=>{
    const { D: o, M: s } = t;
    const { w: e, h: l } = n;
    const sanitizeAxis = (t, n, o)=>{
        let s = $2cd21d6115f08437$var$r(t) * o;
        let e = $2cd21d6115f08437$var$r(n) * o;
        if (s === e) {
            const o = $2cd21d6115f08437$var$c(t);
            const r = $2cd21d6115f08437$var$c(n);
            e = o > r ? 0 : e;
            s = o < r ? 0 : s;
        }
        s = s === e ? 0 : s;
        return [
            s + 0,
            e + 0
        ];
    };
    const [i, a] = sanitizeAxis(o.x, s.x, e);
    const [u, _] = sanitizeAxis(o.y, s.y, l);
    return {
        D: {
            x: i,
            y: u
        },
        M: {
            x: a,
            y: _
        }
    };
};
const $2cd21d6115f08437$var$isDefaultDirectionScrollCoordinates = ({ D: t, M: n })=>{
    const getAxis = (t, n)=>t === 0 && t <= n;
    return {
        x: getAxis(t.x, n.x),
        y: getAxis(t.y, n.y)
    };
};
const $2cd21d6115f08437$var$getScrollCoordinatesPercent = ({ D: t, M: n }, o)=>{
    const getAxis = (t, n, o)=>$2cd21d6115f08437$var$capNumber(0, 1, (t - o) / (t - n) || 0);
    return {
        x: getAxis(t.x, n.x, o.x),
        y: getAxis(t.y, n.y, o.y)
    };
};
const $2cd21d6115f08437$var$focusElement = (t)=>{
    if (t && t.focus) t.focus({
        preventScroll: true
    });
};
const $2cd21d6115f08437$var$manageListener = (t, n)=>{
    $2cd21d6115f08437$var$each($2cd21d6115f08437$var$createOrKeepArray(n), t);
};
const $2cd21d6115f08437$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $2cd21d6115f08437$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($2cd21d6115f08437$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $2cd21d6115f08437$var$manageListener((t)=>{
                $2cd21d6115f08437$var$isFunction(t) && s.add(t);
            }, o);
            return $2cd21d6115f08437$var$bind(removeEvent, t, o);
        }
        if ($2cd21d6115f08437$var$isBoolean(o) && o) removeEvent();
        const s = $2cd21d6115f08437$var$keys(t);
        const e = [];
        $2cd21d6115f08437$var$each(s, (n)=>{
            const o = t[n];
            o && $2cd21d6115f08437$var$push(e, addEvent(n, o));
        });
        return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, e);
    };
    const triggerEvent = (t, o)=>{
        $2cd21d6115f08437$var$each($2cd21d6115f08437$var$from(n.get(t)), (t)=>{
            if (o && !$2cd21d6115f08437$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $2cd21d6115f08437$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($2cd21d6115f08437$var$isFunction(n)) throw 0;
        return n;
    });
const $2cd21d6115f08437$var$getPropByPath = (t, n)=>t ? `${n}`.split(".").reduce((t, n)=>t && $2cd21d6115f08437$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $2cd21d6115f08437$var$M = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        autoHideSuspend: false,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $2cd21d6115f08437$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $2cd21d6115f08437$var$concat($2cd21d6115f08437$var$keys(n), $2cd21d6115f08437$var$keys(t));
    $2cd21d6115f08437$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($2cd21d6115f08437$var$isObject(e) && $2cd21d6115f08437$var$isObject(c)) {
            $2cd21d6115f08437$var$assignDeep(o[s] = {}, $2cd21d6115f08437$var$getOptionsDiff(e, c));
            if ($2cd21d6115f08437$var$isEmptyObject(o[s])) delete o[s];
        } else if ($2cd21d6115f08437$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($2cd21d6115f08437$var$isArray(e) || $2cd21d6115f08437$var$isArray(c)) try {
                if ($2cd21d6115f08437$var$opsStringify(e) === $2cd21d6115f08437$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $2cd21d6115f08437$var$createOptionCheck = (t, n, o)=>(s)=>[
            $2cd21d6115f08437$var$getPropByPath(t, s),
            o || $2cd21d6115f08437$var$getPropByPath(n, s) !== void 0
        ];
const $2cd21d6115f08437$var$T = `data-overlayscrollbars`;
const $2cd21d6115f08437$var$k = "os-environment";
const $2cd21d6115f08437$var$R = `${$2cd21d6115f08437$var$k}-scrollbar-hidden`;
const $2cd21d6115f08437$var$V = `${$2cd21d6115f08437$var$T}-initialize`;
const $2cd21d6115f08437$var$L = "noClipping";
const $2cd21d6115f08437$var$U = `${$2cd21d6115f08437$var$T}-body`;
const $2cd21d6115f08437$var$P = $2cd21d6115f08437$var$T;
const $2cd21d6115f08437$var$N = "host";
const $2cd21d6115f08437$var$q = `${$2cd21d6115f08437$var$T}-viewport`;
const $2cd21d6115f08437$var$B = $2cd21d6115f08437$var$m;
const $2cd21d6115f08437$var$F = $2cd21d6115f08437$var$O;
const $2cd21d6115f08437$var$j = "arrange";
const $2cd21d6115f08437$var$X = "measuring";
const $2cd21d6115f08437$var$Y = "scrolling";
const $2cd21d6115f08437$var$W = "scrollbarHidden";
const $2cd21d6115f08437$var$J = "noContent";
const $2cd21d6115f08437$var$G = `${$2cd21d6115f08437$var$T}-padding`;
const $2cd21d6115f08437$var$K = `${$2cd21d6115f08437$var$T}-content`;
const $2cd21d6115f08437$var$Q = "os-size-observer";
const $2cd21d6115f08437$var$Z = `${$2cd21d6115f08437$var$Q}-appear`;
const $2cd21d6115f08437$var$tt = `${$2cd21d6115f08437$var$Q}-listener`;
const $2cd21d6115f08437$var$nt = `${$2cd21d6115f08437$var$tt}-scroll`;
const $2cd21d6115f08437$var$ot = `${$2cd21d6115f08437$var$tt}-item`;
const $2cd21d6115f08437$var$st = `${$2cd21d6115f08437$var$ot}-final`;
const $2cd21d6115f08437$var$et = "os-trinsic-observer";
const $2cd21d6115f08437$var$ct = "os-theme-none";
const $2cd21d6115f08437$var$rt = "os-scrollbar";
const $2cd21d6115f08437$var$lt = `${$2cd21d6115f08437$var$rt}-rtl`;
const $2cd21d6115f08437$var$it = `${$2cd21d6115f08437$var$rt}-horizontal`;
const $2cd21d6115f08437$var$at = `${$2cd21d6115f08437$var$rt}-vertical`;
const $2cd21d6115f08437$var$ut = `${$2cd21d6115f08437$var$rt}-track`;
const $2cd21d6115f08437$var$_t = `${$2cd21d6115f08437$var$rt}-handle`;
const $2cd21d6115f08437$var$dt = `${$2cd21d6115f08437$var$rt}-visible`;
const $2cd21d6115f08437$var$ft = `${$2cd21d6115f08437$var$rt}-cornerless`;
const $2cd21d6115f08437$var$vt = `${$2cd21d6115f08437$var$rt}-interaction`;
const $2cd21d6115f08437$var$pt = `${$2cd21d6115f08437$var$rt}-unusable`;
const $2cd21d6115f08437$var$ht = `${$2cd21d6115f08437$var$rt}-auto-hide`;
const $2cd21d6115f08437$var$gt = `${$2cd21d6115f08437$var$ht}-hidden`;
const $2cd21d6115f08437$var$bt = `${$2cd21d6115f08437$var$rt}-wheel`;
const $2cd21d6115f08437$var$wt = `${$2cd21d6115f08437$var$ut}-interactive`;
const $2cd21d6115f08437$var$yt = `${$2cd21d6115f08437$var$_t}-interactive`;
let $2cd21d6115f08437$var$St;
const $2cd21d6115f08437$var$getNonce = ()=>$2cd21d6115f08437$var$St;
const $2cd21d6115f08437$var$setNonce = (t)=>{
    $2cd21d6115f08437$var$St = t;
};
let $2cd21d6115f08437$var$mt;
const $2cd21d6115f08437$var$createEnvironment = ()=>{
    const getNativeScrollbarSize = (t, n, o)=>{
        $2cd21d6115f08437$var$appendChildren(document.body, t);
        $2cd21d6115f08437$var$appendChildren(document.body, t);
        const s = $2cd21d6115f08437$var$A(t);
        const e = $2cd21d6115f08437$var$I(t);
        const c = $2cd21d6115f08437$var$getFractionalSize(n);
        o && $2cd21d6115f08437$var$removeElements(t);
        return {
            x: e.h - s.h + c.h,
            y: e.w - s.w + c.w
        };
    };
    const getNativeScrollbarsHiding = (t)=>{
        let n = false;
        const o = $2cd21d6115f08437$var$addClass(t, $2cd21d6115f08437$var$R);
        try {
            n = $2cd21d6115f08437$var$getStyles(t, "scrollbar-width") === "none" || $2cd21d6115f08437$var$getStyles(t, "display", "::-webkit-scrollbar") === "none";
        } catch (s) {}
        o();
        return n;
    };
    const t = `.${$2cd21d6115f08437$var$k}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${$2cd21d6115f08437$var$k} div{width:200%;height:200%;margin:10px 0}.${$2cd21d6115f08437$var$R}{scrollbar-width:none!important}.${$2cd21d6115f08437$var$R}::-webkit-scrollbar,.${$2cd21d6115f08437$var$R}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`;
    const o = $2cd21d6115f08437$var$createDOM(`<div class="${$2cd21d6115f08437$var$k}"><div></div><style>${t}</style></div>`);
    const s = o[0];
    const e = s.firstChild;
    const c = s.lastChild;
    const r = $2cd21d6115f08437$var$getNonce();
    if (r) c.nonce = r;
    const [l, , i] = $2cd21d6115f08437$var$createEventListenerHub();
    const [a, u] = $2cd21d6115f08437$var$createCache({
        o: getNativeScrollbarSize(s, e),
        i: $2cd21d6115f08437$var$equalXY
    }, $2cd21d6115f08437$var$bind(getNativeScrollbarSize, s, e, true));
    const [_] = u();
    const d = getNativeScrollbarsHiding(s);
    const f = {
        x: _.x === 0,
        y: _.y === 0
    };
    const p = {
        elements: {
            host: null,
            padding: !d,
            viewport: (t)=>d && $2cd21d6115f08437$var$isBodyElement(t) && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const h = $2cd21d6115f08437$var$assignDeep({}, $2cd21d6115f08437$var$M);
    const g = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$assignDeep, {}, h);
    const b = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$assignDeep, {}, p);
    const w = {
        T: _,
        k: f,
        R: d,
        V: !!$2cd21d6115f08437$var$v,
        L: $2cd21d6115f08437$var$bind(l, "r"),
        U: b,
        P: (t)=>$2cd21d6115f08437$var$assignDeep(p, t) && b(),
        N: g,
        q: (t)=>$2cd21d6115f08437$var$assignDeep(h, t) && g(),
        B: $2cd21d6115f08437$var$assignDeep({}, p),
        F: $2cd21d6115f08437$var$assignDeep({}, h)
    };
    $2cd21d6115f08437$var$removeAttrs(s, "style");
    $2cd21d6115f08437$var$removeElements(s);
    $2cd21d6115f08437$var$addEventListener($2cd21d6115f08437$var$n, "resize", ()=>{
        i("r", []);
    });
    if ($2cd21d6115f08437$var$isFunction($2cd21d6115f08437$var$n.matchMedia) && !d && (!f.x || !f.y)) {
        const addZoomListener = (t)=>{
            const o = $2cd21d6115f08437$var$n.matchMedia(`(resolution: ${$2cd21d6115f08437$var$n.devicePixelRatio}dppx)`);
            $2cd21d6115f08437$var$addEventListener(o, "change", ()=>{
                t();
                addZoomListener(t);
            }, {
                A: true
            });
        };
        addZoomListener(()=>{
            const [t, n] = a();
            $2cd21d6115f08437$var$assignDeep(w.T, t);
            i("r", [
                n
            ]);
        });
    }
    return w;
};
const $2cd21d6115f08437$var$getEnvironment = ()=>{
    if (!$2cd21d6115f08437$var$mt) $2cd21d6115f08437$var$mt = $2cd21d6115f08437$var$createEnvironment();
    return $2cd21d6115f08437$var$mt;
};
const $2cd21d6115f08437$var$resolveInitialization = (t, n)=>$2cd21d6115f08437$var$isFunction(n) ? n.apply(0, t) : n;
const $2cd21d6115f08437$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $2cd21d6115f08437$var$isUndefined(s) ? o : s;
    const c = $2cd21d6115f08437$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $2cd21d6115f08437$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $2cd21d6115f08437$var$isUndefined(s) ? o : s;
    const c = $2cd21d6115f08437$var$resolveInitialization(t, e);
    return !!c && ($2cd21d6115f08437$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $2cd21d6115f08437$var$cancelInitialization = (t, n)=>{
    const { nativeScrollbarsOverlaid: o, body: s } = n || {};
    const { k: e, R: c, U: r } = $2cd21d6115f08437$var$getEnvironment();
    const { nativeScrollbarsOverlaid: l, body: i } = r().cancel;
    const a = o != null ? o : l;
    const u = $2cd21d6115f08437$var$isUndefined(s) ? i : s;
    const _ = (e.x || e.y) && a;
    const d = t && ($2cd21d6115f08437$var$isNull(u) ? !c : u);
    return !!_ || !!d;
};
const $2cd21d6115f08437$var$Ot = new WeakMap;
const $2cd21d6115f08437$var$addInstance = (t, n)=>{
    $2cd21d6115f08437$var$Ot.set(t, n);
};
const $2cd21d6115f08437$var$removeInstance = (t)=>{
    $2cd21d6115f08437$var$Ot.delete(t);
};
const $2cd21d6115f08437$var$getInstance = (t)=>$2cd21d6115f08437$var$Ot.get(t);
const $2cd21d6115f08437$var$createEventContentChange = (t, n, o)=>{
    let s = false;
    const e = o ? new WeakMap : false;
    const destroy = ()=>{
        s = true;
    };
    const updateElements = (c)=>{
        if (e && o) {
            const r = o.map((n)=>{
                const [o, s] = n || [];
                const e = s && o ? (c || $2cd21d6115f08437$var$find)(o, t) : [];
                return [
                    e,
                    s
                ];
            });
            $2cd21d6115f08437$var$each(r, (o)=>$2cd21d6115f08437$var$each(o[0], (c)=>{
                    const r = o[1];
                    const l = e.get(c) || [];
                    const i = t.contains(c);
                    if (i && r) {
                        const t = $2cd21d6115f08437$var$addEventListener(c, r, (o)=>{
                            if (s) {
                                t();
                                e.delete(c);
                            } else n(o);
                        });
                        e.set(c, $2cd21d6115f08437$var$push(l, t));
                    } else {
                        $2cd21d6115f08437$var$runEachAndClear(l);
                        e.delete(c);
                    }
                }));
        }
    };
    updateElements();
    return [
        destroy,
        updateElements
    ];
};
const $2cd21d6115f08437$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { j: c, X: r, Y: l, W: i, J: a, G: u } = s || {};
    const d = $2cd21d6115f08437$var$debounce(()=>e && o(true), {
        _: 33,
        v: 99
    });
    const [f, v] = $2cd21d6115f08437$var$createEventContentChange(t, d, l);
    const p = c || [];
    const h = r || [];
    const g = $2cd21d6115f08437$var$concat(p, h);
    const observerCallback = (e, c)=>{
        if (!$2cd21d6115f08437$var$isEmptyArray(c)) {
            const r = a || $2cd21d6115f08437$var$noop;
            const l = u || $2cd21d6115f08437$var$noop;
            const _ = [];
            const d = [];
            let f = false;
            let p = false;
            $2cd21d6115f08437$var$each(c, (o)=>{
                const { attributeName: e, target: c, type: a, oldValue: u, addedNodes: v, removedNodes: g } = o;
                const b = a === "attributes";
                const w = a === "childList";
                const y = t === c;
                const S = b && e;
                const m = S && $2cd21d6115f08437$var$getAttr(c, e || "");
                const O = $2cd21d6115f08437$var$isString(m) ? m : null;
                const $ = S && u !== O;
                const C = $2cd21d6115f08437$var$inArray(h, e) && $;
                if (n && (w || !y)) {
                    const n = b && $;
                    const a = n && i && $2cd21d6115f08437$var$is(c, i);
                    const d = a ? !r(c, e, u, O) : !b || n;
                    const f = d && !l(o, !!a, t, s);
                    $2cd21d6115f08437$var$each(v, (t)=>$2cd21d6115f08437$var$push(_, t));
                    $2cd21d6115f08437$var$each(g, (t)=>$2cd21d6115f08437$var$push(_, t));
                    p = p || f;
                }
                if (!n && y && $ && !r(c, e, u, O)) {
                    $2cd21d6115f08437$var$push(d, e);
                    f = f || C;
                }
            });
            v((t)=>$2cd21d6115f08437$var$deduplicateArray(_).reduce((n, o)=>{
                    $2cd21d6115f08437$var$push(n, $2cd21d6115f08437$var$find(t, o));
                    return $2cd21d6115f08437$var$is(o, t) ? $2cd21d6115f08437$var$push(n, o) : n;
                }, []));
            if (n) {
                !e && p && o(false);
                return [
                    false
                ];
            }
            if (!$2cd21d6115f08437$var$isEmptyArray(d) || f) {
                const t = [
                    $2cd21d6115f08437$var$deduplicateArray(d),
                    f
                ];
                !e && o.apply(0, t);
                return t;
            }
        }
    };
    const b = new $2cd21d6115f08437$var$_($2cd21d6115f08437$var$bind(observerCallback, false));
    return [
        ()=>{
            b.observe(t, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: g,
                subtree: n,
                childList: n,
                characterData: n
            });
            e = true;
            return ()=>{
                if (e) {
                    f();
                    b.disconnect();
                    e = false;
                }
            };
        },
        ()=>{
            if (e) {
                d.m();
                return observerCallback(true, b.takeRecords());
            }
        }
    ];
};
const $2cd21d6115f08437$var$$t = {};
const $2cd21d6115f08437$var$Ct = {};
const $2cd21d6115f08437$var$addPlugins = (t)=>{
    $2cd21d6115f08437$var$each(t, (t)=>$2cd21d6115f08437$var$each(t, (n, o)=>{
            $2cd21d6115f08437$var$$t[o] = t[o];
        }));
};
const $2cd21d6115f08437$var$registerPluginModuleInstances = (t, n, o)=>$2cd21d6115f08437$var$keys(t).map((s)=>{
        const { static: e, instance: c } = t[s];
        const [r, l, i] = o || [];
        const a = o ? c : e;
        if (a) {
            const t = o ? a(r, l, n) : a(n);
            return (i || $2cd21d6115f08437$var$Ct)[s] = t;
        }
    });
const $2cd21d6115f08437$var$getStaticPluginModuleInstance = (t)=>$2cd21d6115f08437$var$Ct[t];
const $2cd21d6115f08437$var$xt = "__osOptionsValidationPlugin";
const $2cd21d6115f08437$var$Ht = "__osSizeObserverPlugin";
const $2cd21d6115f08437$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$2cd21d6115f08437$var$Ht]: {
            static: ()=>(t, n, o)=>{
                    const s = 3333333;
                    const e = "scroll";
                    const c = $2cd21d6115f08437$var$createDOM(`<div class="${$2cd21d6115f08437$var$ot}" dir="ltr"><div class="${$2cd21d6115f08437$var$ot}"><div class="${$2cd21d6115f08437$var$st}"></div></div><div class="${$2cd21d6115f08437$var$ot}"><div class="${$2cd21d6115f08437$var$st}" style="width: 200%; height: 200%"></div></div></div>`);
                    const r = c[0];
                    const a = r.lastChild;
                    const u = r.firstChild;
                    const _ = u == null ? void 0 : u.firstChild;
                    let d = $2cd21d6115f08437$var$I(r);
                    let f = d;
                    let v = false;
                    let p;
                    const reset = ()=>{
                        $2cd21d6115f08437$var$scrollElementTo(u, s);
                        $2cd21d6115f08437$var$scrollElementTo(a, s);
                    };
                    const onResized = (t)=>{
                        p = 0;
                        if (v) {
                            d = f;
                            n(t === true);
                        }
                    };
                    const onScroll = (t)=>{
                        f = $2cd21d6115f08437$var$I(r);
                        v = !t || !$2cd21d6115f08437$var$equalWH(f, d);
                        if (t) {
                            $2cd21d6115f08437$var$stopPropagation(t);
                            if (v && !p) {
                                $2cd21d6115f08437$var$l(p);
                                p = $2cd21d6115f08437$var$i(onResized);
                            }
                        } else onResized(t === false);
                        reset();
                    };
                    const h = [
                        $2cd21d6115f08437$var$appendChildren(t, c),
                        $2cd21d6115f08437$var$addEventListener(u, e, onScroll),
                        $2cd21d6115f08437$var$addEventListener(a, e, onScroll)
                    ];
                    $2cd21d6115f08437$var$addClass(t, $2cd21d6115f08437$var$nt);
                    $2cd21d6115f08437$var$setStyles(_, {
                        [$2cd21d6115f08437$var$$]: s,
                        [$2cd21d6115f08437$var$C]: s
                    });
                    $2cd21d6115f08437$var$i(reset);
                    return [
                        o ? $2cd21d6115f08437$var$bind(onScroll, false) : reset,
                        h
                    ];
                }
        }
    }))();
const $2cd21d6115f08437$var$getShowNativeOverlaidScrollbars = (t, n)=>{
    const { k: o } = n;
    const [s, e] = t("showNativeOverlaidScrollbars");
    return [
        s && o.x && o.y,
        e
    ];
};
const $2cd21d6115f08437$var$overflowIsVisible = (t)=>t.indexOf($2cd21d6115f08437$var$x) === 0;
const $2cd21d6115f08437$var$createViewportOverflowState = (t, n)=>{
    const getAxisOverflowStyle = (t, n, o, s)=>{
        const e = t === $2cd21d6115f08437$var$x ? $2cd21d6115f08437$var$H : t.replace(`${$2cd21d6115f08437$var$x}-`, "");
        const c = $2cd21d6115f08437$var$overflowIsVisible(t);
        const r = $2cd21d6115f08437$var$overflowIsVisible(o);
        if (!n && !s) return $2cd21d6115f08437$var$H;
        if (c && r) return $2cd21d6115f08437$var$x;
        if (c) {
            const t = n ? $2cd21d6115f08437$var$x : $2cd21d6115f08437$var$H;
            return n && s ? e : t;
        }
        const l = r && s ? $2cd21d6115f08437$var$x : $2cd21d6115f08437$var$H;
        return n ? e : l;
    };
    const o = {
        x: getAxisOverflowStyle(n.x, t.x, n.y, t.y),
        y: getAxisOverflowStyle(n.y, t.y, n.x, t.x)
    };
    return {
        K: o,
        Z: {
            x: o.x === $2cd21d6115f08437$var$E,
            y: o.y === $2cd21d6115f08437$var$E
        }
    };
};
const $2cd21d6115f08437$var$zt = "__osScrollbarsHidingPlugin";
const $2cd21d6115f08437$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$2cd21d6115f08437$var$zt]: {
            static: ()=>({
                    tt: (t, n, o, s, e)=>{
                        const { nt: c, ot: r } = t;
                        const { R: l, k: i, T: a } = s;
                        const u = !c && !l && (i.x || i.y);
                        const [_] = $2cd21d6115f08437$var$getShowNativeOverlaidScrollbars(e, s);
                        const readViewportOverflowState = ()=>{
                            const getStatePerAxis = (t)=>{
                                const n = $2cd21d6115f08437$var$getStyles(r, t);
                                const o = n === $2cd21d6115f08437$var$E;
                                return [
                                    n,
                                    o
                                ];
                            };
                            const [t, n] = getStatePerAxis($2cd21d6115f08437$var$m);
                            const [o, s] = getStatePerAxis($2cd21d6115f08437$var$O);
                            return {
                                K: {
                                    x: t,
                                    y: o
                                },
                                Z: {
                                    x: n,
                                    y: s
                                }
                            };
                        };
                        const _getViewportOverflowHideOffset = (t)=>{
                            const { Z: n } = t;
                            const o = l || _ ? 0 : 42;
                            const getHideOffsetPerAxis = (t, n, s)=>{
                                const e = t ? o : s;
                                const c = n && !l ? e : 0;
                                const r = t && !!o;
                                return [
                                    c,
                                    r
                                ];
                            };
                            const [s, e] = getHideOffsetPerAxis(i.x, n.x, a.x);
                            const [c, r] = getHideOffsetPerAxis(i.y, n.y, a.y);
                            return {
                                st: {
                                    x: s,
                                    y: c
                                },
                                et: {
                                    x: e,
                                    y: r
                                }
                            };
                        };
                        const _hideNativeScrollbars = (t, { ct: o }, s)=>{
                            if (!c) {
                                const e = $2cd21d6115f08437$var$assignDeep({}, {
                                    [$2cd21d6115f08437$var$y]: 0,
                                    [$2cd21d6115f08437$var$S]: 0,
                                    [$2cd21d6115f08437$var$w]: 0
                                });
                                const { st: c, et: r } = _getViewportOverflowHideOffset(t);
                                const { x: l, y: i } = r;
                                const { x: a, y: u } = c;
                                const { rt: _ } = n;
                                const d = o ? $2cd21d6115f08437$var$w : $2cd21d6115f08437$var$y;
                                const f = o ? $2cd21d6115f08437$var$g : $2cd21d6115f08437$var$h;
                                const v = _[d];
                                const p = _[$2cd21d6115f08437$var$S];
                                const m = _[f];
                                const O = _[$2cd21d6115f08437$var$b];
                                e[$2cd21d6115f08437$var$$] = `calc(100% + ${u + v * -1}px)`;
                                e[d] = -u + v;
                                e[$2cd21d6115f08437$var$S] = -a + p;
                                if (s) {
                                    e[f] = m + (i ? u : 0);
                                    e[$2cd21d6115f08437$var$b] = O + (l ? a : 0);
                                }
                                return e;
                            }
                        };
                        const _arrangeViewport = (t, s, e)=>{
                            if (u) {
                                const { rt: c } = n;
                                const { st: l, et: i } = _getViewportOverflowHideOffset(t);
                                const { x: a, y: u } = i;
                                const { x: _, y: d } = l;
                                const { ct: f } = o;
                                const v = f ? $2cd21d6115f08437$var$h : $2cd21d6115f08437$var$g;
                                const p = c[v];
                                const b = c.paddingTop;
                                const w = s.w + e.w;
                                const y = s.h + e.h;
                                const S = {
                                    w: d && u ? `${d + w - p}px` : "",
                                    h: _ && a ? `${_ + y - b}px` : ""
                                };
                                $2cd21d6115f08437$var$setStyles(r, {
                                    "--os-vaw": S.w,
                                    "--os-vah": S.h
                                });
                            }
                            return u;
                        };
                        const _undoViewportArrange = (t)=>{
                            if (u) {
                                const s = t || readViewportOverflowState();
                                const { rt: e } = n;
                                const { et: c } = _getViewportOverflowHideOffset(s);
                                const { x: l, y: i } = c;
                                const a = {};
                                const assignProps = (t)=>$2cd21d6115f08437$var$each(t, (t)=>{
                                        a[t] = e[t];
                                    });
                                if (l) assignProps([
                                    $2cd21d6115f08437$var$S,
                                    $2cd21d6115f08437$var$p,
                                    $2cd21d6115f08437$var$b
                                ]);
                                if (i) assignProps([
                                    $2cd21d6115f08437$var$w,
                                    $2cd21d6115f08437$var$y,
                                    $2cd21d6115f08437$var$g,
                                    $2cd21d6115f08437$var$h
                                ]);
                                const _ = $2cd21d6115f08437$var$getStyles(r, $2cd21d6115f08437$var$keys(a));
                                const d = $2cd21d6115f08437$var$removeAttrClass(r, $2cd21d6115f08437$var$q, $2cd21d6115f08437$var$j);
                                $2cd21d6115f08437$var$setStyles(r, a);
                                return [
                                    ()=>{
                                        $2cd21d6115f08437$var$setStyles(r, $2cd21d6115f08437$var$assignDeep({}, _, _hideNativeScrollbars(s, o, u)));
                                        d();
                                    },
                                    s
                                ];
                            }
                            return [
                                $2cd21d6115f08437$var$noop
                            ];
                        };
                        return {
                            lt: _getViewportOverflowHideOffset,
                            it: _arrangeViewport,
                            ut: _undoViewportArrange,
                            _t: _hideNativeScrollbars
                        };
                    }
                })
        }
    }))();
const $2cd21d6115f08437$var$At = "__osClickScrollPlugin";
const $2cd21d6115f08437$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$2cd21d6115f08437$var$At]: {
            static: ()=>(t, n, o, s)=>{
                    let e = false;
                    let c = $2cd21d6115f08437$var$noop;
                    const r = 133;
                    const l = 222;
                    const [i, a] = $2cd21d6115f08437$var$selfClearTimeout(r);
                    const u = Math.sign(n);
                    const _ = o * u;
                    const d = _ / 2;
                    const easing = (t)=>1 - (1 - t) * (1 - t);
                    const easedEndPressAnimation = (n, o)=>$2cd21d6115f08437$var$animateNumber(n, o, l, t, easing);
                    const linearPressAnimation = (o, s)=>$2cd21d6115f08437$var$animateNumber(o, n - _, r * s, (o, s, e)=>{
                            t(o);
                            if (e) c = easedEndPressAnimation(o, n);
                        });
                    const f = $2cd21d6115f08437$var$animateNumber(0, _, l, (r, l, a)=>{
                        t(r);
                        if (a) {
                            s(e);
                            if (!e) {
                                const t = n - r;
                                const s = Math.sign(t - d) === u;
                                s && i(()=>{
                                    const s = t - _;
                                    const e = Math.sign(s) === u;
                                    c = e ? linearPressAnimation(r, Math.abs(s) / o) : easedEndPressAnimation(r, n);
                                });
                            }
                        }
                    }, easing);
                    return (t)=>{
                        e = true;
                        if (t) f();
                        a();
                        c();
                    };
                }
        }
    }))();
const $2cd21d6115f08437$var$createSizeObserver = (t, n, o)=>{
    const { dt: s } = o || {};
    const e = $2cd21d6115f08437$var$getStaticPluginModuleInstance($2cd21d6115f08437$var$Ht);
    const [c] = $2cd21d6115f08437$var$createCache({
        o: false,
        u: true
    });
    return ()=>{
        const o = [];
        const r = $2cd21d6115f08437$var$createDOM(`<div class="${$2cd21d6115f08437$var$Q}"><div class="${$2cd21d6115f08437$var$tt}"></div></div>`);
        const l = r[0];
        const i = l.firstChild;
        const onSizeChangedCallbackProxy = (t)=>{
            const o = t instanceof ResizeObserverEntry;
            let s = false;
            let e = false;
            if (o) {
                const [n, , o] = c(t.contentRect);
                const r = $2cd21d6115f08437$var$domRectHasDimensions(n);
                e = $2cd21d6115f08437$var$domRectAppeared(n, o);
                s = !e && !r;
            } else e = t === true;
            if (!s) n({
                ft: true,
                dt: e
            });
        };
        if ($2cd21d6115f08437$var$f) {
            const t = new $2cd21d6115f08437$var$f((t)=>onSizeChangedCallbackProxy(t.pop()));
            t.observe(i);
            $2cd21d6115f08437$var$push(o, ()=>{
                t.disconnect();
            });
        } else if (e) {
            const [t, n] = e(i, onSizeChangedCallbackProxy, s);
            $2cd21d6115f08437$var$push(o, $2cd21d6115f08437$var$concat([
                $2cd21d6115f08437$var$addClass(l, $2cd21d6115f08437$var$Z),
                $2cd21d6115f08437$var$addEventListener(l, "animationstart", t)
            ], n));
        } else return $2cd21d6115f08437$var$noop;
        return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, $2cd21d6115f08437$var$push(o, $2cd21d6115f08437$var$appendChildren(t, l)));
    };
};
const $2cd21d6115f08437$var$createTrinsicObserver = (t, n)=>{
    let o;
    const isHeightIntrinsic = (t)=>t.h === 0 || t.isIntersecting || t.intersectionRatio > 0;
    const s = $2cd21d6115f08437$var$createDiv($2cd21d6115f08437$var$et);
    const [e] = $2cd21d6115f08437$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = e(isHeightIntrinsic(t));
            const [, c] = s;
            return c && !o && n(s) && [
                s
            ];
        }
    };
    const intersectionObserverCallback = (t, n)=>triggerOnTrinsicChangedCallback(n.pop(), t);
    return [
        ()=>{
            const n = [];
            if ($2cd21d6115f08437$var$d) {
                o = new $2cd21d6115f08437$var$d($2cd21d6115f08437$var$bind(intersectionObserverCallback, false), {
                    root: t
                });
                o.observe(s);
                $2cd21d6115f08437$var$push(n, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $2cd21d6115f08437$var$I(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                $2cd21d6115f08437$var$push(n, $2cd21d6115f08437$var$createSizeObserver(s, onSizeChanged)());
                onSizeChanged();
            }
            return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, $2cd21d6115f08437$var$push(n, $2cd21d6115f08437$var$appendChildren(t, s)));
        },
        ()=>o && intersectionObserverCallback(true, o.takeRecords())
    ];
};
const $2cd21d6115f08437$var$createObserversSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let l;
    let i;
    let a;
    const u = `[${$2cd21d6115f08437$var$P}]`;
    const _ = `[${$2cd21d6115f08437$var$q}]`;
    const d = [
        "id",
        "class",
        "style",
        "open",
        "wrap",
        "cols",
        "rows"
    ];
    const { vt: v, ht: p, ot: h, gt: g, bt: b, nt: w, wt: y, yt: S, St: m, Ot: O } = t;
    const getDirectionIsRTL = (t)=>$2cd21d6115f08437$var$getStyles(t, "direction") === "rtl";
    const $ = {
        $t: false,
        ct: getDirectionIsRTL(v)
    };
    const C = $2cd21d6115f08437$var$getEnvironment();
    const x = $2cd21d6115f08437$var$getStaticPluginModuleInstance($2cd21d6115f08437$var$zt);
    const [H] = $2cd21d6115f08437$var$createCache({
        i: $2cd21d6115f08437$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const s = x && x.tt(t, n, $, C, o).ut;
        const e = y && w;
        const c = !e && $2cd21d6115f08437$var$hasAttrClass(p, $2cd21d6115f08437$var$P, $2cd21d6115f08437$var$L);
        const r = !w && S($2cd21d6115f08437$var$j);
        const l = r && $2cd21d6115f08437$var$getElementScroll(g);
        const i = l && O();
        const a = m($2cd21d6115f08437$var$X, c);
        const u = r && s && s()[0];
        const _ = $2cd21d6115f08437$var$D(h);
        const d = $2cd21d6115f08437$var$getFractionalSize(h);
        u && u();
        $2cd21d6115f08437$var$scrollElementTo(g, l);
        i && i();
        c && a();
        return {
            w: _.w + d.w,
            h: _.h + d.h
        };
    });
    const E = $2cd21d6115f08437$var$debounce(s, {
        _: ()=>e,
        v: ()=>c,
        S (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $2cd21d6115f08437$var$concat($2cd21d6115f08437$var$keys(o), $2cd21d6115f08437$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const setDirection = (t)=>{
        const n = getDirectionIsRTL(v);
        $2cd21d6115f08437$var$assignDeep(t, {
            Ct: a !== n
        });
        $2cd21d6115f08437$var$assignDeep($, {
            ct: n
        });
        a = n;
    };
    const onTrinsicChanged = (t, n)=>{
        const [o, e] = t;
        const c = {
            xt: e
        };
        $2cd21d6115f08437$var$assignDeep($, {
            $t: o
        });
        !n && s(c);
        return c;
    };
    const onSizeChanged = ({ ft: t, dt: n })=>{
        const o = t && !n;
        const e = !o && C.R ? E : s;
        const c = {
            ft: t || n,
            dt: n
        };
        setDirection(c);
        e(c);
    };
    const onContentMutation = (t, n)=>{
        const [, o] = H();
        const e = {
            Ht: o
        };
        setDirection(e);
        const c = t ? s : E;
        o && !n && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            Et: n
        };
        setDirection(s);
        if (n && !o) E(s);
        return s;
    };
    const [z, I] = b ? $2cd21d6115f08437$var$createTrinsicObserver(p, onTrinsicChanged) : [];
    const A = !w && $2cd21d6115f08437$var$createSizeObserver(p, onSizeChanged, {
        dt: true
    });
    const [M, T] = $2cd21d6115f08437$var$createDOMObserver(p, false, onHostMutation, {
        X: d,
        j: d
    });
    const k = w && $2cd21d6115f08437$var$f && new $2cd21d6115f08437$var$f((t)=>{
        const n = t[t.length - 1].contentRect;
        onSizeChanged({
            ft: true,
            dt: $2cd21d6115f08437$var$domRectAppeared(n, i)
        });
        i = n;
    });
    const R = $2cd21d6115f08437$var$debounce(()=>{
        const [, t] = H();
        s({
            Ht: t
        });
    }, {
        _: 222,
        p: true
    });
    return [
        ()=>{
            k && k.observe(p);
            const t = A && A();
            const n = z && z();
            const o = M();
            const s = C.L((t)=>{
                if (t) E({
                    zt: t
                });
                else R();
            });
            return ()=>{
                k && k.disconnect();
                t && t();
                n && n();
                l && l();
                o();
                s();
            };
        },
        ({ It: t, At: n, Dt: o })=>{
            const s = {};
            const [i] = t("update.ignoreMutation");
            const [a, f] = t("update.attributes");
            const [v, p] = t("update.elementEvents");
            const [g, y] = t("update.debounce");
            const S = p || f;
            const m = n || o;
            const ignoreMutationFromOptions = (t)=>$2cd21d6115f08437$var$isFunction(i) && i(t);
            if (S) {
                r && r();
                l && l();
                const [t, n] = $2cd21d6115f08437$var$createDOMObserver(b || h, true, onContentMutation, {
                    j: $2cd21d6115f08437$var$concat(d, a || []),
                    Y: v,
                    W: u,
                    G: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !w ? $2cd21d6115f08437$var$liesBetween(o, u, _) : false;
                        return e || !!$2cd21d6115f08437$var$closest(o, `.${$2cd21d6115f08437$var$rt}`) || !!ignoreMutationFromOptions(t);
                    }
                });
                l = t();
                r = n;
            }
            if (y) {
                E.m();
                if ($2cd21d6115f08437$var$isArray(g)) {
                    const t = g[0];
                    const n = g[1];
                    e = $2cd21d6115f08437$var$isNumber(t) && t;
                    c = $2cd21d6115f08437$var$isNumber(n) && n;
                } else if ($2cd21d6115f08437$var$isNumber(g)) {
                    e = g;
                    c = false;
                } else {
                    e = false;
                    c = false;
                }
            }
            if (m) {
                const t = T();
                const n = I && I();
                const o = r && r();
                t && $2cd21d6115f08437$var$assignDeep(s, onHostMutation(t[0], t[1], m));
                n && $2cd21d6115f08437$var$assignDeep(s, onTrinsicChanged(n[0], m));
                o && $2cd21d6115f08437$var$assignDeep(s, onContentMutation(o[0], m));
            }
            setDirection(s);
            return s;
        },
        $
    ];
};
const $2cd21d6115f08437$var$createScrollbarsSetupElements = (t, n, o, s)=>{
    const e = "--os-viewport-percent";
    const c = "--os-scroll-percent";
    const r = "--os-scroll-direction";
    const { U: l } = $2cd21d6115f08437$var$getEnvironment();
    const { scrollbars: i } = l();
    const { slot: a } = i;
    const { vt: u, ht: _, ot: d, Mt: f, gt: p, wt: h, nt: g } = n;
    const { scrollbars: b } = f ? {} : t;
    const { slot: w } = b || {};
    const y = [];
    const S = [];
    const m = [];
    const O = $2cd21d6115f08437$var$dynamicInitializationElement([
        u,
        _,
        d
    ], ()=>g && h ? u : _, a, w);
    const initScrollTimeline = (t)=>{
        if ($2cd21d6115f08437$var$v) {
            const n = new $2cd21d6115f08437$var$v({
                source: p,
                axis: t
            });
            const _addScrollPercentAnimation = (t)=>{
                const o = t.Tt.animate({
                    clear: [
                        "left"
                    ],
                    [c]: [
                        0,
                        1
                    ]
                }, {
                    timeline: n
                });
                return ()=>o.cancel();
            };
            return {
                kt: _addScrollPercentAnimation
            };
        }
    };
    const $ = {
        x: initScrollTimeline("x"),
        y: initScrollTimeline("y")
    };
    const getViewportPercent = ()=>{
        const { Rt: t, Vt: n } = o;
        const getAxisValue = (t, n)=>$2cd21d6115f08437$var$capNumber(0, 1, t / (t + n) || 0);
        return {
            x: getAxisValue(n.x, t.x),
            y: getAxisValue(n.y, t.y)
        };
    };
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $2cd21d6115f08437$var$addClass : $2cd21d6115f08437$var$removeClass;
        $2cd21d6115f08437$var$each(t, (t)=>{
            s(t.Tt, n);
        });
    };
    const scrollbarStyle = (t, n)=>{
        $2cd21d6115f08437$var$each(t, (t)=>{
            const [o, s] = n(t);
            $2cd21d6115f08437$var$setStyles(o, s);
        });
    };
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $2cd21d6115f08437$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(S, t, n);
        c && scrollbarStructureAddRemoveClass(m, t, n);
    };
    const refreshScrollbarsHandleLength = ()=>{
        const t = getViewportPercent();
        const createScrollbarStyleFn = (t)=>(n)=>[
                    n.Tt,
                    {
                        [e]: $2cd21d6115f08437$var$roundCssNumber(t) + ""
                    }
                ];
        scrollbarStyle(S, createScrollbarStyleFn(t.x));
        scrollbarStyle(m, createScrollbarStyleFn(t.y));
    };
    const refreshScrollbarsHandleOffset = ()=>{
        if (!$2cd21d6115f08437$var$v) {
            const { Lt: t } = o;
            const n = $2cd21d6115f08437$var$getScrollCoordinatesPercent(t, $2cd21d6115f08437$var$getElementScroll(p));
            const createScrollbarStyleFn = (t)=>(n)=>[
                        n.Tt,
                        {
                            [c]: $2cd21d6115f08437$var$roundCssNumber(t) + ""
                        }
                    ];
            scrollbarStyle(S, createScrollbarStyleFn(n.x));
            scrollbarStyle(m, createScrollbarStyleFn(n.y));
        }
    };
    const refreshScrollbarsScrollCoordinates = ()=>{
        const { Lt: t } = o;
        const n = $2cd21d6115f08437$var$isDefaultDirectionScrollCoordinates(t);
        const createScrollbarStyleFn = (t)=>(n)=>[
                    n.Tt,
                    {
                        [r]: t ? "0" : "1"
                    }
                ];
        scrollbarStyle(S, createScrollbarStyleFn(n.x));
        scrollbarStyle(m, createScrollbarStyleFn(n.y));
    };
    const refreshScrollbarsScrollbarOffset = ()=>{
        if (g && !h) {
            const { Rt: t, Lt: n } = o;
            const s = $2cd21d6115f08437$var$isDefaultDirectionScrollCoordinates(n);
            const e = $2cd21d6115f08437$var$getScrollCoordinatesPercent(n, $2cd21d6115f08437$var$getElementScroll(p));
            const styleScrollbarPosition = (n)=>{
                const { Tt: o } = n;
                const c = $2cd21d6115f08437$var$parent(o) === d && o;
                const getTranslateValue = (t, n, o)=>{
                    const s = n * t;
                    return $2cd21d6115f08437$var$numberToCssPx(o ? s : -s);
                };
                return [
                    c,
                    c && {
                        transform: $2cd21d6115f08437$var$getTrasformTranslateValue({
                            x: getTranslateValue(e.x, t.x, s.x),
                            y: getTranslateValue(e.y, t.y, s.y)
                        })
                    }
                ];
            };
            scrollbarStyle(S, styleScrollbarPosition);
            scrollbarStyle(m, styleScrollbarPosition);
        }
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? "x" : "y";
        const o = t ? $2cd21d6115f08437$var$it : $2cd21d6115f08437$var$at;
        const e = $2cd21d6115f08437$var$createDiv(`${$2cd21d6115f08437$var$rt} ${o}`);
        const c = $2cd21d6115f08437$var$createDiv($2cd21d6115f08437$var$ut);
        const r = $2cd21d6115f08437$var$createDiv($2cd21d6115f08437$var$_t);
        const l = {
            Tt: e,
            Ut: c,
            Pt: r
        };
        const i = $[n];
        $2cd21d6115f08437$var$push(t ? S : m, l);
        $2cd21d6115f08437$var$push(y, [
            $2cd21d6115f08437$var$appendChildren(e, c),
            $2cd21d6115f08437$var$appendChildren(c, r),
            $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeElements, e),
            i && i.kt(l),
            s(l, scrollbarsAddRemoveClass, t)
        ]);
        return l;
    };
    const C = $2cd21d6115f08437$var$bind(generateScrollbarDOM, true);
    const x = $2cd21d6115f08437$var$bind(generateScrollbarDOM, false);
    const appendElements = ()=>{
        $2cd21d6115f08437$var$appendChildren(O, S[0].Tt);
        $2cd21d6115f08437$var$appendChildren(O, m[0].Tt);
        return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, y);
    };
    C();
    x();
    return [
        {
            Nt: refreshScrollbarsHandleLength,
            qt: refreshScrollbarsHandleOffset,
            Bt: refreshScrollbarsScrollCoordinates,
            Ft: refreshScrollbarsScrollbarOffset,
            jt: scrollbarsAddRemoveClass,
            Xt: {
                Yt: S,
                Wt: C,
                Jt: $2cd21d6115f08437$var$bind(scrollbarStyle, S)
            },
            Gt: {
                Yt: m,
                Wt: x,
                Jt: $2cd21d6115f08437$var$bind(scrollbarStyle, m)
            }
        },
        appendElements
    ];
};
const $2cd21d6115f08437$var$createScrollbarsSetupEvents = (t, n, o, s)=>(r, l, i)=>{
        const { ht: u, ot: _, nt: d, gt: f, Kt: v, Ot: p } = n;
        const { Tt: h, Ut: g, Pt: b } = r;
        const [w, y] = $2cd21d6115f08437$var$selfClearTimeout(333);
        const [S, m] = $2cd21d6115f08437$var$selfClearTimeout(444);
        const scrollOffsetElementScrollBy = (t)=>{
            $2cd21d6115f08437$var$isFunction(f.scrollBy) && f.scrollBy({
                behavior: "smooth",
                left: t.x,
                top: t.y
            });
        };
        const createInteractiveScrollEvents = ()=>{
            const n = "pointerup pointercancel lostpointercapture";
            const s = `client${i ? "X" : "Y"}`;
            const r = i ? $2cd21d6115f08437$var$$ : $2cd21d6115f08437$var$C;
            const l = i ? "left" : "top";
            const a = i ? "w" : "h";
            const u = i ? "x" : "y";
            const createRelativeHandleMove = (t, n)=>(s)=>{
                    const { Rt: e } = o;
                    const c = $2cd21d6115f08437$var$I(g)[a] - $2cd21d6115f08437$var$I(b)[a];
                    const r = n * s / c;
                    const l = r * e[u];
                    $2cd21d6115f08437$var$scrollElementTo(f, {
                        [u]: t + l
                    });
                };
            const _ = [];
            return $2cd21d6115f08437$var$addEventListener(g, "pointerdown", (o)=>{
                const i = $2cd21d6115f08437$var$closest(o.target, `.${$2cd21d6115f08437$var$_t}`) === b;
                const d = i ? b : g;
                const h = t.scrollbars;
                const w = h[i ? "dragScroll" : "clickScroll"];
                const { button: y, isPrimary: O, pointerType: $ } = o;
                const { pointers: C } = h;
                const x = y === 0 && O && w && (C || []).includes($);
                if (x) {
                    $2cd21d6115f08437$var$runEachAndClear(_);
                    m();
                    const t = !i && (o.shiftKey || w === "instant");
                    const h = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getBoundingClientRect, b);
                    const y = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getBoundingClientRect, g);
                    const getHandleOffset = (t, n)=>(t || h())[l] - (n || y())[l];
                    const O = $2cd21d6115f08437$var$e($2cd21d6115f08437$var$getBoundingClientRect(f)[r]) / $2cd21d6115f08437$var$I(f)[a] || 1;
                    const $ = createRelativeHandleMove($2cd21d6115f08437$var$getElementScroll(f)[u], 1 / O);
                    const C = o[s];
                    const x = h();
                    const H = y();
                    const E = x[r];
                    const z = getHandleOffset(x, H) + E / 2;
                    const A = C - H[l];
                    const D = i ? 0 : A - z;
                    const releasePointerCapture = (t)=>{
                        $2cd21d6115f08437$var$runEachAndClear(k);
                        d.releasePointerCapture(t.pointerId);
                    };
                    const M = i || t;
                    const T = p();
                    const k = [
                        $2cd21d6115f08437$var$addEventListener(v, n, releasePointerCapture),
                        $2cd21d6115f08437$var$addEventListener(v, "selectstart", (t)=>$2cd21d6115f08437$var$preventDefault(t), {
                            H: false
                        }),
                        $2cd21d6115f08437$var$addEventListener(g, n, releasePointerCapture),
                        M && $2cd21d6115f08437$var$addEventListener(g, "pointermove", (t)=>$(D + (t[s] - C))),
                        M && (()=>{
                            const t = $2cd21d6115f08437$var$getElementScroll(f);
                            T();
                            const n = $2cd21d6115f08437$var$getElementScroll(f);
                            const o = {
                                x: n.x - t.x,
                                y: n.y - t.y
                            };
                            if ($2cd21d6115f08437$var$c(o.x) > 3 || $2cd21d6115f08437$var$c(o.y) > 3) {
                                p();
                                $2cd21d6115f08437$var$scrollElementTo(f, t);
                                scrollOffsetElementScrollBy(o);
                                S(T);
                            }
                        })
                    ];
                    d.setPointerCapture(o.pointerId);
                    if (t) $(D);
                    else if (!i) {
                        const t = $2cd21d6115f08437$var$getStaticPluginModuleInstance($2cd21d6115f08437$var$At);
                        if (t) {
                            const n = t($, D, E, (t)=>{
                                if (t) T();
                                else $2cd21d6115f08437$var$push(k, T);
                            });
                            $2cd21d6115f08437$var$push(k, n);
                            $2cd21d6115f08437$var$push(_, $2cd21d6115f08437$var$bind(n, true));
                        }
                    }
                }
            });
        };
        let O = true;
        return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, [
            $2cd21d6115f08437$var$addEventListener(b, "pointermove pointerleave", s),
            $2cd21d6115f08437$var$addEventListener(h, "pointerenter", ()=>{
                l($2cd21d6115f08437$var$vt, true);
            }),
            $2cd21d6115f08437$var$addEventListener(h, "pointerleave pointercancel", ()=>{
                l($2cd21d6115f08437$var$vt, false);
            }),
            !d && $2cd21d6115f08437$var$addEventListener(h, "mousedown", ()=>{
                const t = $2cd21d6115f08437$var$getFocusedElement();
                if ($2cd21d6115f08437$var$hasAttr(t, $2cd21d6115f08437$var$q) || $2cd21d6115f08437$var$hasAttr(t, $2cd21d6115f08437$var$P) || t === document.body) $2cd21d6115f08437$var$a($2cd21d6115f08437$var$bind($2cd21d6115f08437$var$focusElement, _), 25);
            }),
            $2cd21d6115f08437$var$addEventListener(h, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: s } = t;
                if (O && s === 0 && $2cd21d6115f08437$var$parent(h) === u) scrollOffsetElementScrollBy({
                    x: n,
                    y: o
                });
                O = false;
                l($2cd21d6115f08437$var$bt, true);
                w(()=>{
                    O = true;
                    l($2cd21d6115f08437$var$bt);
                });
                $2cd21d6115f08437$var$preventDefault(t);
            }, {
                H: false,
                I: true
            }),
            $2cd21d6115f08437$var$addEventListener(h, "pointerdown", $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$addEventListener, v, "click", $2cd21d6115f08437$var$stopAndPrevent, {
                A: true,
                I: true,
                H: false
            }), {
                I: true
            }),
            createInteractiveScrollEvents(),
            y,
            m
        ]);
    };
const $2cd21d6115f08437$var$createScrollbarsSetup = (t, n, o, s, e, c)=>{
    let r;
    let l;
    let i;
    let a;
    let u;
    let _ = $2cd21d6115f08437$var$noop;
    let d = 0;
    const isHoverablePointerType = (t)=>t.pointerType === "mouse";
    const [f, v] = $2cd21d6115f08437$var$selfClearTimeout();
    const [p, h] = $2cd21d6115f08437$var$selfClearTimeout(100);
    const [g, b] = $2cd21d6115f08437$var$selfClearTimeout(100);
    const [w, y] = $2cd21d6115f08437$var$selfClearTimeout(()=>d);
    const [S, m] = $2cd21d6115f08437$var$createScrollbarsSetupElements(t, e, s, $2cd21d6115f08437$var$createScrollbarsSetupEvents(n, e, s, (t)=>isHoverablePointerType(t) && manageScrollbarsAutoHideInstantInteraction()));
    const { ht: O, Qt: $, wt: C } = e;
    const { jt: H, Nt: z, qt: I, Bt: A, Ft: D } = S;
    const manageScrollbarsAutoHide = (t, n)=>{
        y();
        if (t) H($2cd21d6115f08437$var$gt);
        else {
            const t = $2cd21d6115f08437$var$bind(H, $2cd21d6115f08437$var$gt, true);
            if (d > 0 && !n) w(t);
            else t();
        }
    };
    const manageScrollbarsAutoHideInstantInteraction = ()=>{
        if (i ? !r : !a) {
            manageScrollbarsAutoHide(true);
            p(()=>{
                manageScrollbarsAutoHide(false);
            });
        }
    };
    const manageAutoHideSuspension = (t)=>{
        H($2cd21d6115f08437$var$ht, t, true);
        H($2cd21d6115f08437$var$ht, t, false);
    };
    const onHostMouseEnter = (t)=>{
        if (isHoverablePointerType(t)) {
            r = i;
            i && manageScrollbarsAutoHide(true);
        }
    };
    const M = [
        y,
        h,
        b,
        v,
        ()=>_(),
        $2cd21d6115f08437$var$addEventListener(O, "pointerover", onHostMouseEnter, {
            A: true
        }),
        $2cd21d6115f08437$var$addEventListener(O, "pointerenter", onHostMouseEnter),
        $2cd21d6115f08437$var$addEventListener(O, "pointerleave", (t)=>{
            if (isHoverablePointerType(t)) {
                r = false;
                i && manageScrollbarsAutoHide(false);
            }
        }),
        $2cd21d6115f08437$var$addEventListener(O, "pointermove", (t)=>{
            isHoverablePointerType(t) && l && manageScrollbarsAutoHideInstantInteraction();
        }),
        $2cd21d6115f08437$var$addEventListener($, "scroll", (t)=>{
            f(()=>{
                I();
                manageScrollbarsAutoHideInstantInteraction();
            });
            c(t);
            D();
        })
    ];
    return [
        ()=>$2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, $2cd21d6115f08437$var$push(M, m())),
        ({ It: t, Dt: n, Zt: e, tn: c })=>{
            const { nn: r, sn: f, en: v, cn: p } = c || {};
            const { Ct: h, dt: b } = e || {};
            const { ct: w } = o;
            const { k: y } = $2cd21d6115f08437$var$getEnvironment();
            const { K: S, rn: m } = s;
            const [O, M] = t("showNativeOverlaidScrollbars");
            const [T, k] = t("scrollbars.theme");
            const [R, V] = t("scrollbars.visibility");
            const [L, U] = t("scrollbars.autoHide");
            const [P, N] = t("scrollbars.autoHideSuspend");
            const [q] = t("scrollbars.autoHideDelay");
            const [B, F] = t("scrollbars.dragScroll");
            const [j, X] = t("scrollbars.clickScroll");
            const [Y, W] = t("overflow");
            const J = b && !n;
            const G = m.x || m.y;
            const K = r || f || p || h || n;
            const Q = v || V || W;
            const Z = O && y.x && y.y;
            const setScrollbarVisibility = (t, n, o)=>{
                const s = t.includes($2cd21d6115f08437$var$E) && (R === $2cd21d6115f08437$var$x || R === "auto" && n === $2cd21d6115f08437$var$E);
                H($2cd21d6115f08437$var$dt, s, o);
                return s;
            };
            d = q;
            if (J) {
                if (P && G) {
                    manageAutoHideSuspension(false);
                    _();
                    g(()=>{
                        _ = $2cd21d6115f08437$var$addEventListener($, "scroll", $2cd21d6115f08437$var$bind(manageAutoHideSuspension, true), {
                            A: true
                        });
                    });
                } else manageAutoHideSuspension(true);
            }
            if (M) H($2cd21d6115f08437$var$ct, Z);
            if (k) {
                H(u);
                H(T, true);
                u = T;
            }
            if (N && !P) manageAutoHideSuspension(true);
            if (U) {
                l = L === "move";
                i = L === "leave";
                a = L === "never";
                manageScrollbarsAutoHide(a, true);
            }
            if (F) H($2cd21d6115f08437$var$yt, B);
            if (X) H($2cd21d6115f08437$var$wt, !!j);
            if (Q) {
                const t = setScrollbarVisibility(Y.x, S.x, true);
                const n = setScrollbarVisibility(Y.y, S.y, false);
                const o = t && n;
                H($2cd21d6115f08437$var$ft, !o);
            }
            if (K) {
                I();
                z();
                D();
                p && A();
                H($2cd21d6115f08437$var$pt, !m.x, true);
                H($2cd21d6115f08437$var$pt, !m.y, false);
                H($2cd21d6115f08437$var$lt, w && !C);
            }
        },
        {},
        S
    ];
};
const $2cd21d6115f08437$var$createStructureSetupElements = (t)=>{
    const o = $2cd21d6115f08437$var$getEnvironment();
    const { U: s, R: e } = o;
    const { elements: c } = s();
    const { padding: r, viewport: l, content: i } = c;
    const a = $2cd21d6115f08437$var$isHTMLElement(t);
    const u = a ? {} : t;
    const { elements: _ } = u;
    const { padding: d, viewport: f, content: v } = _ || {};
    const p = a ? t : u.target;
    const h = $2cd21d6115f08437$var$isBodyElement(p);
    const g = p.ownerDocument;
    const b = g.documentElement;
    const getDocumentWindow = ()=>g.defaultView || $2cd21d6115f08437$var$n;
    const w = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$staticInitializationElement, [
        p
    ]);
    const y = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$dynamicInitializationElement, [
        p
    ]);
    const S = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$createDiv, "");
    const $ = $2cd21d6115f08437$var$bind(w, S, l);
    const C = $2cd21d6115f08437$var$bind(y, S, i);
    const elementHasOverflow = (t)=>{
        const n = $2cd21d6115f08437$var$I(t);
        const o = $2cd21d6115f08437$var$D(t);
        const s = $2cd21d6115f08437$var$getStyles(t, $2cd21d6115f08437$var$m);
        const e = $2cd21d6115f08437$var$getStyles(t, $2cd21d6115f08437$var$O);
        return o.w - n.w > 0 && !$2cd21d6115f08437$var$overflowIsVisible(s) || o.h - n.h > 0 && !$2cd21d6115f08437$var$overflowIsVisible(e);
    };
    const x = $(f);
    const H = x === p;
    const E = H && h;
    const z = !H && C(v);
    const A = !H && x === z;
    const M = E ? b : x;
    const T = E ? M : p;
    const k = !H && y(S, r, d);
    const R = !A && z;
    const L = [
        R,
        M,
        k,
        T
    ].map((t)=>$2cd21d6115f08437$var$isHTMLElement(t) && !$2cd21d6115f08437$var$parent(t) && t);
    const elementIsGenerated = (t)=>t && $2cd21d6115f08437$var$inArray(L, t);
    const B = !elementIsGenerated(M) && elementHasOverflow(M) ? M : p;
    const F = E ? b : M;
    const j = E ? g : M;
    const X = {
        vt: p,
        ht: T,
        ot: M,
        ln: k,
        bt: R,
        gt: F,
        Qt: j,
        an: h ? b : B,
        Kt: g,
        wt: h,
        Mt: a,
        nt: H,
        un: getDocumentWindow,
        yt: (t)=>$2cd21d6115f08437$var$hasAttrClass(M, $2cd21d6115f08437$var$q, t),
        St: (t, n)=>$2cd21d6115f08437$var$addRemoveAttrClass(M, $2cd21d6115f08437$var$q, t, n),
        Ot: ()=>$2cd21d6115f08437$var$addRemoveAttrClass(F, $2cd21d6115f08437$var$q, $2cd21d6115f08437$var$Y, true)
    };
    const { vt: J, ht: Q, ln: Z, ot: tt, bt: nt } = X;
    const ot = [
        ()=>{
            $2cd21d6115f08437$var$removeAttrs(Q, [
                $2cd21d6115f08437$var$P,
                $2cd21d6115f08437$var$V
            ]);
            $2cd21d6115f08437$var$removeAttrs(J, $2cd21d6115f08437$var$V);
            if (h) $2cd21d6115f08437$var$removeAttrs(b, [
                $2cd21d6115f08437$var$V,
                $2cd21d6115f08437$var$P
            ]);
        }
    ];
    let st = $2cd21d6115f08437$var$contents([
        nt,
        tt,
        Z,
        Q,
        J
    ].find((t)=>t && !elementIsGenerated(t)));
    const et = E ? J : nt || tt;
    const ct = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, ot);
    const appendElements = ()=>{
        const t = getDocumentWindow();
        const n = $2cd21d6115f08437$var$getFocusedElement();
        const unwrap = (t)=>{
            $2cd21d6115f08437$var$appendChildren($2cd21d6115f08437$var$parent(t), $2cd21d6115f08437$var$contents(t));
            $2cd21d6115f08437$var$removeElements(t);
        };
        const prepareWrapUnwrapFocus = (t)=>$2cd21d6115f08437$var$addEventListener(t, "focusin focusout focus blur", $2cd21d6115f08437$var$stopAndPrevent, {
                I: true,
                H: false
            });
        const o = "tabindex";
        const s = $2cd21d6115f08437$var$getAttr(tt, o);
        const c = prepareWrapUnwrapFocus(n);
        $2cd21d6115f08437$var$setAttrs(Q, $2cd21d6115f08437$var$P, H ? "" : $2cd21d6115f08437$var$N);
        $2cd21d6115f08437$var$setAttrs(Z, $2cd21d6115f08437$var$G, "");
        $2cd21d6115f08437$var$setAttrs(tt, $2cd21d6115f08437$var$q, "");
        $2cd21d6115f08437$var$setAttrs(nt, $2cd21d6115f08437$var$K, "");
        if (!H) {
            $2cd21d6115f08437$var$setAttrs(tt, o, s || "-1");
            h && $2cd21d6115f08437$var$setAttrs(b, $2cd21d6115f08437$var$U, "");
        }
        $2cd21d6115f08437$var$appendChildren(et, st);
        $2cd21d6115f08437$var$appendChildren(Q, Z);
        $2cd21d6115f08437$var$appendChildren(Z || Q, !H && tt);
        $2cd21d6115f08437$var$appendChildren(tt, nt);
        $2cd21d6115f08437$var$push(ot, [
            c,
            ()=>{
                const t = $2cd21d6115f08437$var$getFocusedElement();
                const n = elementIsGenerated(tt);
                const e = n && t === tt ? J : t;
                const c = prepareWrapUnwrapFocus(e);
                $2cd21d6115f08437$var$removeAttrs(Z, $2cd21d6115f08437$var$G);
                $2cd21d6115f08437$var$removeAttrs(nt, $2cd21d6115f08437$var$K);
                $2cd21d6115f08437$var$removeAttrs(tt, $2cd21d6115f08437$var$q);
                h && $2cd21d6115f08437$var$removeAttrs(b, $2cd21d6115f08437$var$U);
                s ? $2cd21d6115f08437$var$setAttrs(tt, o, s) : $2cd21d6115f08437$var$removeAttrs(tt, o);
                elementIsGenerated(nt) && unwrap(nt);
                n && unwrap(tt);
                elementIsGenerated(Z) && unwrap(Z);
                $2cd21d6115f08437$var$focusElement(e);
                c();
            }
        ]);
        if (e && !H) {
            $2cd21d6115f08437$var$addAttrClass(tt, $2cd21d6115f08437$var$q, $2cd21d6115f08437$var$W);
            $2cd21d6115f08437$var$push(ot, $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$removeAttrs, tt, $2cd21d6115f08437$var$q));
        }
        $2cd21d6115f08437$var$focusElement(!H && h && n === J && t.top === t ? tt : n);
        c();
        st = 0;
        return ct;
    };
    return [
        X,
        appendElements,
        ct
    ];
};
const $2cd21d6115f08437$var$createTrinsicUpdateSegment = ({ bt: t })=>({ Zt: n, _n: o, Dt: s })=>{
        const { xt: e } = n || {};
        const { $t: c } = o;
        const r = t && (e || s);
        if (r) $2cd21d6115f08437$var$setStyles(t, {
            [$2cd21d6115f08437$var$C]: c && "100%"
        });
    };
const $2cd21d6115f08437$var$createPaddingUpdateSegment = ({ ht: t, ln: n, ot: o, nt: s }, e)=>{
    const [c, r] = $2cd21d6115f08437$var$createCache({
        i: $2cd21d6115f08437$var$equalTRBL,
        o: $2cd21d6115f08437$var$topRightBottomLeft()
    }, $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$topRightBottomLeft, t, "padding", ""));
    return ({ It: t, Zt: l, _n: i, Dt: a })=>{
        let [u, _] = r(a);
        const { R: d } = $2cd21d6115f08437$var$getEnvironment();
        const { ft: f, Ht: v, Ct: m } = l || {};
        const { ct: O } = i;
        const [C, x] = t("paddingAbsolute");
        const H = a || v;
        if (f || _ || H) [u, _] = c(a);
        const E = !s && (x || m || _);
        if (E) {
            const t = !C || !n && !d;
            const s = u.r + u.l;
            const c = u.t + u.b;
            const r = {
                [$2cd21d6115f08437$var$y]: t && !O ? -s : 0,
                [$2cd21d6115f08437$var$S]: t ? -c : 0,
                [$2cd21d6115f08437$var$w]: t && O ? -s : 0,
                top: t ? -u.t : 0,
                right: t ? O ? -u.r : "auto" : 0,
                left: t ? O ? "auto" : -u.l : 0,
                [$2cd21d6115f08437$var$$]: t && `calc(100% + ${s}px)`
            };
            const l = {
                [$2cd21d6115f08437$var$p]: t ? u.t : 0,
                [$2cd21d6115f08437$var$h]: t ? u.r : 0,
                [$2cd21d6115f08437$var$b]: t ? u.b : 0,
                [$2cd21d6115f08437$var$g]: t ? u.l : 0
            };
            $2cd21d6115f08437$var$setStyles(n || o, r);
            $2cd21d6115f08437$var$setStyles(o, l);
            $2cd21d6115f08437$var$assignDeep(e, {
                ln: u,
                dn: !t,
                rt: n ? l : $2cd21d6115f08437$var$assignDeep({}, r, l)
            });
        }
        return {
            fn: E
        };
    };
};
const $2cd21d6115f08437$var$createOverflowUpdateSegment = (t, s)=>{
    const e = $2cd21d6115f08437$var$getEnvironment();
    const { ht: c, ln: r, ot: l, nt: a, Qt: u, gt: _, wt: d, St: f, un: v } = t;
    const { R: p } = e;
    const h = d && a;
    const g = $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$o, 0);
    const b = {
        display: ()=>false,
        direction: (t)=>t !== "ltr",
        flexDirection: (t)=>t.endsWith("-reverse"),
        writingMode: (t)=>t !== "horizontal-tb"
    };
    const w = $2cd21d6115f08437$var$keys(b);
    const y = {
        i: $2cd21d6115f08437$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    };
    const S = {
        i: $2cd21d6115f08437$var$equalXY,
        o: {}
    };
    const setMeasuringMode = (t)=>{
        f($2cd21d6115f08437$var$X, !h && t);
    };
    const getMeasuredScrollCoordinates = (t)=>{
        const n = w.some((n)=>{
            const o = t[n];
            return o && b[n](o);
        });
        if (!n) return {
            D: {
                x: 0,
                y: 0
            },
            M: {
                x: 1,
                y: 1
            }
        };
        setMeasuringMode(true);
        const o = $2cd21d6115f08437$var$getElementScroll(_);
        const s = f($2cd21d6115f08437$var$J, true);
        const e = $2cd21d6115f08437$var$addEventListener(u, $2cd21d6115f08437$var$E, (t)=>{
            const n = $2cd21d6115f08437$var$getElementScroll(_);
            if (t.isTrusted && n.x === o.x && n.y === o.y) $2cd21d6115f08437$var$stopPropagation(t);
        }, {
            I: true,
            A: true
        });
        $2cd21d6115f08437$var$scrollElementTo(_, {
            x: 0,
            y: 0
        });
        s();
        const c = $2cd21d6115f08437$var$getElementScroll(_);
        const r = $2cd21d6115f08437$var$D(_);
        $2cd21d6115f08437$var$scrollElementTo(_, {
            x: r.w,
            y: r.h
        });
        const l = $2cd21d6115f08437$var$getElementScroll(_);
        $2cd21d6115f08437$var$scrollElementTo(_, {
            x: l.x - c.x < 1 && -r.w,
            y: l.y - c.y < 1 && -r.h
        });
        const a = $2cd21d6115f08437$var$getElementScroll(_);
        $2cd21d6115f08437$var$scrollElementTo(_, o);
        $2cd21d6115f08437$var$i(()=>e());
        return {
            D: c,
            M: a
        };
    };
    const getOverflowAmount = (t, o)=>{
        const s = $2cd21d6115f08437$var$n.devicePixelRatio % 1 !== 0 ? 1 : 0;
        const e = {
            w: g(t.w - o.w),
            h: g(t.h - o.h)
        };
        return {
            w: e.w > s ? e.w : 0,
            h: e.h > s ? e.h : 0
        };
    };
    const [m, O] = $2cd21d6115f08437$var$createCache(y, $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$getFractionalSize, l));
    const [$, C] = $2cd21d6115f08437$var$createCache(y, $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$D, l));
    const [z, I] = $2cd21d6115f08437$var$createCache(y);
    const [M] = $2cd21d6115f08437$var$createCache(S);
    const [T, k] = $2cd21d6115f08437$var$createCache(y);
    const [R] = $2cd21d6115f08437$var$createCache(S);
    const [V] = $2cd21d6115f08437$var$createCache({
        i: (t, n)=>$2cd21d6115f08437$var$equal(t, n, w),
        o: {}
    }, ()=>$2cd21d6115f08437$var$hasDimensions(l) ? $2cd21d6115f08437$var$getStyles(l, w) : {});
    const [U, N] = $2cd21d6115f08437$var$createCache({
        i: (t, n)=>$2cd21d6115f08437$var$equalXY(t.D, n.D) && $2cd21d6115f08437$var$equalXY(t.M, n.M),
        o: $2cd21d6115f08437$var$getZeroScrollCoordinates()
    });
    const q = $2cd21d6115f08437$var$getStaticPluginModuleInstance($2cd21d6115f08437$var$zt);
    const createViewportOverflowStyleClassName = (t, n)=>{
        const o = n ? $2cd21d6115f08437$var$B : $2cd21d6115f08437$var$F;
        return `${o}${$2cd21d6115f08437$var$capitalizeFirstLetter(t)}`;
    };
    const setViewportOverflowStyle = (t)=>{
        const createAllOverflowStyleClassNames = (t)=>[
                $2cd21d6115f08437$var$x,
                $2cd21d6115f08437$var$H,
                $2cd21d6115f08437$var$E
            ].map((n)=>createViewportOverflowStyleClassName(n, t));
        const n = createAllOverflowStyleClassNames(true).concat(createAllOverflowStyleClassNames()).join(" ");
        f(n);
        f($2cd21d6115f08437$var$keys(t).map((n)=>createViewportOverflowStyleClassName(t[n], n === "x")).join(" "), true);
    };
    return ({ It: n, Zt: o, _n: i, Dt: a }, { fn: u })=>{
        const { ft: _, Ht: d, Ct: b, dt: w, zt: y } = o || {};
        const S = q && q.tt(t, s, i, e, n);
        const { it: x, ut: H, _t: E } = S || {};
        const [D, B] = $2cd21d6115f08437$var$getShowNativeOverlaidScrollbars(n, e);
        const [F, j] = n("overflow");
        const X = $2cd21d6115f08437$var$overflowIsVisible(F.x);
        const Y = $2cd21d6115f08437$var$overflowIsVisible(F.y);
        const J = true;
        let K = O(a);
        let Q = C(a);
        let Z = I(a);
        let tt = k(a);
        if (B && p) f($2cd21d6115f08437$var$W, !D);
        {
            if ($2cd21d6115f08437$var$hasAttrClass(c, $2cd21d6115f08437$var$P, $2cd21d6115f08437$var$L)) setMeasuringMode(true);
            const [t] = H ? H() : [];
            const [n] = K = m(a);
            const [o] = Q = $(a);
            const s = $2cd21d6115f08437$var$A(l);
            const e = h && $2cd21d6115f08437$var$getWindowSize(v());
            const r = {
                w: g(o.w + n.w),
                h: g(o.h + n.h)
            };
            const i = {
                w: g((e ? e.w : s.w + g(s.w - o.w)) + n.w),
                h: g((e ? e.h : s.h + g(s.h - o.h)) + n.h)
            };
            t && t();
            tt = T(i);
            Z = z(getOverflowAmount(r, i), a);
        }
        const [nt, ot] = tt;
        const [st, et] = Z;
        const [ct, rt] = Q;
        const [lt, it] = K;
        const [at, ut] = M({
            x: st.w > 0,
            y: st.h > 0
        });
        const _t = X && Y && (at.x || at.y) || X && at.x && !at.y || Y && at.y && !at.x;
        const dt = u || b || y || it || rt || ot || et || j || B || J;
        const ft = $2cd21d6115f08437$var$createViewportOverflowState(at, F);
        const [vt, pt] = R(ft.K);
        const [ht, gt] = V(a);
        const bt = b || w || gt || ut || a;
        const [wt, yt] = bt ? U(getMeasuredScrollCoordinates(ht), a) : N();
        if (dt) {
            pt && setViewportOverflowStyle(ft.K);
            if (E && x) $2cd21d6115f08437$var$setStyles(l, E(ft, i, x(ft, ct, lt)));
        }
        setMeasuringMode(false);
        $2cd21d6115f08437$var$addRemoveAttrClass(c, $2cd21d6115f08437$var$P, $2cd21d6115f08437$var$L, _t);
        $2cd21d6115f08437$var$addRemoveAttrClass(r, $2cd21d6115f08437$var$G, $2cd21d6115f08437$var$L, _t);
        $2cd21d6115f08437$var$assignDeep(s, {
            K: vt,
            Vt: {
                x: nt.w,
                y: nt.h
            },
            Rt: {
                x: st.w,
                y: st.h
            },
            rn: at,
            Lt: $2cd21d6115f08437$var$sanitizeScrollCoordinates(wt, st)
        });
        return {
            en: pt,
            nn: ot,
            sn: et,
            cn: yt || et,
            vn: bt
        };
    };
};
const $2cd21d6115f08437$var$createStructureSetup = (t)=>{
    const [n, o, s] = $2cd21d6115f08437$var$createStructureSetupElements(t);
    const e = {
        ln: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
        },
        dn: false,
        rt: {
            [$2cd21d6115f08437$var$y]: 0,
            [$2cd21d6115f08437$var$S]: 0,
            [$2cd21d6115f08437$var$w]: 0,
            [$2cd21d6115f08437$var$p]: 0,
            [$2cd21d6115f08437$var$h]: 0,
            [$2cd21d6115f08437$var$b]: 0,
            [$2cd21d6115f08437$var$g]: 0
        },
        Vt: {
            x: 0,
            y: 0
        },
        Rt: {
            x: 0,
            y: 0
        },
        K: {
            x: $2cd21d6115f08437$var$H,
            y: $2cd21d6115f08437$var$H
        },
        rn: {
            x: false,
            y: false
        },
        Lt: $2cd21d6115f08437$var$getZeroScrollCoordinates()
    };
    const { vt: c, gt: r, nt: l, Ot: i } = n;
    const { R: a, k: u } = $2cd21d6115f08437$var$getEnvironment();
    const _ = !a && (u.x || u.y);
    const d = [
        $2cd21d6115f08437$var$createTrinsicUpdateSegment(n),
        $2cd21d6115f08437$var$createPaddingUpdateSegment(n, e),
        $2cd21d6115f08437$var$createOverflowUpdateSegment(n, e)
    ];
    return [
        o,
        (t)=>{
            const n = {};
            const o = _;
            const s = o && $2cd21d6115f08437$var$getElementScroll(r);
            const e = s && i();
            $2cd21d6115f08437$var$each(d, (o)=>{
                $2cd21d6115f08437$var$assignDeep(n, o(t, n) || {});
            });
            $2cd21d6115f08437$var$scrollElementTo(r, s);
            e && e();
            !l && $2cd21d6115f08437$var$scrollElementTo(c, 0);
            return n;
        },
        e,
        n,
        s
    ];
};
const $2cd21d6115f08437$var$createSetups = (t, n, o, s, e)=>{
    let c = false;
    const r = $2cd21d6115f08437$var$createOptionCheck(n, {});
    const [l, i, a, u, _] = $2cd21d6115f08437$var$createStructureSetup(t);
    const [d, f, v] = $2cd21d6115f08437$var$createObserversSetup(u, a, r, (t)=>{
        update({}, t);
    });
    const [p, h, , g] = $2cd21d6115f08437$var$createScrollbarsSetup(t, n, v, a, u, e);
    const updateHintsAreTruthy = (t)=>$2cd21d6115f08437$var$keys(t).some((n)=>!!t[n]);
    const update = (t, e)=>{
        if (o()) return false;
        const { pn: r, Dt: l, At: a, hn: u } = t;
        const _ = r || {};
        const d = !!l || !c;
        const p = {
            It: $2cd21d6115f08437$var$createOptionCheck(n, _, d),
            pn: _,
            Dt: d
        };
        if (u) {
            h(p);
            return false;
        }
        const g = e || f($2cd21d6115f08437$var$assignDeep({}, p, {
            At: a
        }));
        const b = i($2cd21d6115f08437$var$assignDeep({}, p, {
            _n: v,
            Zt: g
        }));
        h($2cd21d6115f08437$var$assignDeep({}, p, {
            Zt: g,
            tn: b
        }));
        const w = updateHintsAreTruthy(g);
        const y = updateHintsAreTruthy(b);
        const S = w || y || !$2cd21d6115f08437$var$isEmptyObject(_) || d;
        c = true;
        S && s(t, {
            Zt: g,
            tn: b
        });
        return S;
    };
    return [
        ()=>{
            const { an: t, gt: n, Ot: o } = u;
            const s = $2cd21d6115f08437$var$getElementScroll(t);
            const e = [
                d(),
                l(),
                p()
            ];
            const c = o();
            $2cd21d6115f08437$var$scrollElementTo(n, s);
            c();
            return $2cd21d6115f08437$var$bind($2cd21d6115f08437$var$runEachAndClear, e);
        },
        update,
        ()=>({
                gn: v,
                bn: a
            }),
        {
            wn: u,
            yn: g
        },
        _
    ];
};
const $2cd21d6115f08437$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { N: s } = $2cd21d6115f08437$var$getEnvironment();
    const e = $2cd21d6115f08437$var$isHTMLElement(t);
    const c = e ? t : t.target;
    const r = $2cd21d6115f08437$var$getInstance(c);
    if (n && !r) {
        let r = false;
        const l = [];
        const i = {};
        const validateOptions = (t)=>{
            const n = $2cd21d6115f08437$var$removeUndefinedProperties(t, true);
            const o = $2cd21d6115f08437$var$getStaticPluginModuleInstance($2cd21d6115f08437$var$xt);
            return o ? o(n, true) : n;
        };
        const a = $2cd21d6115f08437$var$assignDeep({}, s(), validateOptions(n));
        const [u, _, d] = $2cd21d6115f08437$var$createEventListenerHub();
        const [f, v, p] = $2cd21d6115f08437$var$createEventListenerHub(o);
        const triggerEvent = (t, n)=>{
            p(t, n);
            d(t, n);
        };
        const [h, g, b, w, y] = $2cd21d6115f08437$var$createSetups(t, a, ()=>r, ({ pn: t, Dt: n }, { Zt: o, tn: s })=>{
            const { ft: e, Ct: c, xt: r, Ht: l, Et: i, dt: a } = o;
            const { nn: u, sn: _, en: d, cn: f } = s;
            triggerEvent("updated", [
                S,
                {
                    updateHints: {
                        sizeChanged: !!e,
                        directionChanged: !!c,
                        heightIntrinsicChanged: !!r,
                        overflowEdgeChanged: !!u,
                        overflowAmountChanged: !!_,
                        overflowStyleChanged: !!d,
                        scrollCoordinatesChanged: !!f,
                        contentMutation: !!l,
                        hostMutation: !!i,
                        appear: !!a
                    },
                    changedOptions: t || {},
                    force: !!n
                }
            ]);
        }, (t)=>triggerEvent("scroll", [
                S,
                t
            ]));
        const destroy = (t)=>{
            $2cd21d6115f08437$var$removeInstance(c);
            $2cd21d6115f08437$var$runEachAndClear(l);
            r = true;
            triggerEvent("destroyed", [
                S,
                t
            ]);
            _();
            v();
        };
        const S = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $2cd21d6115f08437$var$getOptionsDiff(a, $2cd21d6115f08437$var$assignDeep(o, validateOptions(t)));
                    if (!$2cd21d6115f08437$var$isEmptyObject(e)) {
                        $2cd21d6115f08437$var$assignDeep(a, e);
                        g({
                            pn: e
                        });
                    }
                }
                return $2cd21d6115f08437$var$assignDeep({}, a);
            },
            on: f,
            off: (t, n)=>{
                t && n && v(t, n);
            },
            state () {
                const { gn: t, bn: n } = b();
                const { ct: o } = t;
                const { Vt: s, Rt: e, K: c, rn: l, ln: i, dn: a, Lt: u } = n;
                return $2cd21d6115f08437$var$assignDeep({}, {
                    overflowEdge: s,
                    overflowAmount: e,
                    overflowStyle: c,
                    hasOverflow: l,
                    scrollCoordinates: {
                        start: u.D,
                        end: u.M
                    },
                    padding: i,
                    paddingAbsolute: a,
                    directionRTL: o,
                    destroyed: r
                });
            },
            elements () {
                const { vt: t, ht: n, ln: o, ot: s, bt: e, gt: c, Qt: r } = w.wn;
                const { Xt: l, Gt: i } = w.yn;
                const translateScrollbarStructure = (t)=>{
                    const { Pt: n, Ut: o, Tt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Yt: n, Wt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $2cd21d6115f08437$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            g({
                                hn: true
                            });
                            return t;
                        }
                    });
                };
                return $2cd21d6115f08437$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(l),
                    scrollbarVertical: translateScrollbarsSetupElement(i)
                });
            },
            update: (t)=>g({
                    Dt: t,
                    At: true
                }),
            destroy: $2cd21d6115f08437$var$bind(destroy, false),
            plugin: (t)=>i[$2cd21d6115f08437$var$keys(t)[0]]
        };
        $2cd21d6115f08437$var$push(l, [
            y
        ]);
        $2cd21d6115f08437$var$addInstance(c, S);
        $2cd21d6115f08437$var$registerPluginModuleInstances($2cd21d6115f08437$var$$t, $2cd21d6115f08437$export$d08ab3fe303a3356, [
            S,
            u,
            i
        ]);
        if ($2cd21d6115f08437$var$cancelInitialization(w.wn.wt, !e && t.cancel)) {
            destroy(true);
            return S;
        }
        $2cd21d6115f08437$var$push(l, h());
        triggerEvent("initialized", [
            S
        ]);
        S.update();
        return S;
    }
    return r;
};
$2cd21d6115f08437$export$d08ab3fe303a3356.plugin = (t)=>{
    const n = $2cd21d6115f08437$var$isArray(t);
    const o = n ? t : [
        t
    ];
    const s = o.map((t)=>$2cd21d6115f08437$var$registerPluginModuleInstances(t, $2cd21d6115f08437$export$d08ab3fe303a3356)[0]);
    $2cd21d6115f08437$var$addPlugins(o);
    return n ? s : s[0];
};
$2cd21d6115f08437$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $2cd21d6115f08437$var$isFunction(n) && n();
    return $2cd21d6115f08437$var$isPlainObject(o) && !!$2cd21d6115f08437$var$getInstance(o.target);
};
$2cd21d6115f08437$export$d08ab3fe303a3356.env = ()=>{
    const { T: t, k: n, R: o, V: s, B: e, F: c, U: r, P: l, N: i, q: a } = $2cd21d6115f08437$var$getEnvironment();
    return $2cd21d6115f08437$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        scrollTimeline: s,
        staticDefaultInitialization: e,
        staticDefaultOptions: c,
        getDefaultInitialization: r,
        setDefaultInitialization: l,
        getDefaultOptions: i,
        setDefaultOptions: a
    });
};
$2cd21d6115f08437$export$d08ab3fe303a3356.nonce = $2cd21d6115f08437$var$setNonce;


if (document.querySelector("[data-scroll]")) {
    const scrollElArr = document.querySelectorAll("[data-scroll]");
    scrollElArr.forEach((scrollEl)=>{
        const osInstance = (0, $2cd21d6115f08437$export$d08ab3fe303a3356)(scrollEl, {});
    });
}


var $f45f188d8ea2dd92$var$t = function() {
    return $f45f188d8ea2dd92$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $f45f188d8ea2dd92$var$t.apply(this, arguments);
}, $f45f188d8ea2dd92$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $f45f188d8ea2dd92$var$t($f45f188d8ea2dd92$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ /**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ const $e981795122c4c4b4$var$counts = Array.from(document.getElementsByClassName("count-up"));
if ($e981795122c4c4b4$var$counts) {
    const defaultOptions = {
        separator: "",
        enableScrollSpy: true,
        scrollSpyRunOnce: true
    };
    let idNumber = 1;
    $e981795122c4c4b4$var$counts.forEach((count)=>{
        const id = `count-up-${idNumber}`, value = parseFloat(count.innerHTML);
        let optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === "") optionsFromDataAttr[key] = true;
        count.id = id;
        new (0, $f45f188d8ea2dd92$export$1567cc001e3d0c1d)(id, value, Object.assign(Object.assign({}, defaultOptions), optionsFromDataAttr));
        idNumber++;
    });
}


window.jsScrollToEl = function jsScrollToEl(targetID) {
    let config = targetID.split("|");
    let duration = +config[1] && (config[1], true) ? +config[1] : 800;
    let paddingTop = +config[2] && (config[2], true) ? +config[2] : 0;
    let target = config[0];
    let targetElement = document.querySelector(target);
    if (targetElement) {
        let targetOffsetTop = targetElement.offsetTop - paddingTop;
        window.scrollTo({
            top: targetOffsetTop,
            behavior: "smooth"
        });
        return false;
    }
};

})();
//# sourceMappingURL=scripts.da5645c7.js.map
